export const list = {
  TemplatesList: [
    {
      TemplateName: null,
      TemplateHtml:
        '<style>\n  .salesReceipt th {\n    font-size: 12px;\n    line-height: 14px;\n    font-family: Calibri;\n    padding: 0px 2px;\n  }\n  .salesReceipt td {\n    border-collapse: collapse;\n    font-family: Calibri;\n    padding: 0px;\n    font-size: 12px;\n    height: 20px;\n    line-height: 14px;\n  }\n</style>\n<div style="font-family: Calibri; font-size: 12px" class="salesReceipt">\n  <div style="width: 100%; text-align: center">\n    <!--<img src="{companyLogo}" style="height: 50px; width: auto"/>-->\n  </div>\n  <table style="width: 100%">\n    <thead>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            margin-bottom: 0;\n            font-size: 24px;\n            font-family: Calibri;\n            font-weight: 600;\n            color: #000;\n            height: 24px;\n          "\n        >\n          {companyName}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            font-size: 11px;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {{branchAddress}}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <div style="border: 2px solid #000; text-align: center">\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 600;\n              border: 0;\n              color: #000;\n              width: 100%;\n            "\n            colspan="2"\n          >\n            PRE-PAYMENT BILL\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <th\n            style="text-align: left; font-weight: 500; border: 0; color: #000"\n          >\n            {billDate}\n          </th>\n          <th\n            style="text-align: right; font-weight: 500; border: 0; color: #000"\n          >\n            {billTime}\n          </th>\n        </tr>\n        <tr>\n          <th\n            style="text-align: left; font-weight: 500; border: 0; color: #000"\n          >\n            Order Mode\n          </th>\n          <th\n            style="text-align: right; font-weight: 500; border: 0; color: #000"\n          >\n            {orderMode}\n          </th>\n        </tr>\n      </tbody>\n    </table>\n    <table style="width: 100%" class="salesReceipt">\n      <tbody>\n        {table}\n{waiter}\n {customerName}\n{address}{phone}\n\n\n\n{rider}\n      </tbody>\n    </table>\n  </div>\n  <table style="width: 100%" class="salesReceipt">\n    <tbody>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order #\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderNumber}\n        </th>\n      </tr>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Date/Time:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderDateTime}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <table\n    style="\n      width: 100%;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n    "\n  >\n    <thead>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Qty\n        </th>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Item\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          Price\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      {itemBody}\n    </tbody>\n  </table>\n  <table style="width: 100%; border-collapse: collapse">\n    <tbody>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Subtotal:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {productSubtotal}\n        </td>\n      </tr>\n      {beforeBill}\n      \n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Total Amount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {totalAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Discount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {discountAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            font-weight: 500;\n            color: #000;\n          "\n        >\n          Net Bill:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 500;\n            color: #000;\n            border: 0;\n          "\n        >\n          {productNetBill}\n        </td>\n      </tr>\n      {finalBill}\n    </tbody>\n  </table>\n  <br />\n  <div\n    style="margin: 2px 0; border: 2px solid #000; text-align: center"\n    class="salesReceipt"\n  >\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 400;\n              border: 0;\n              color: #000;\n              width: 100%;\n              padding: 3px;\n            "\n          >\n            Copyright© 2022 <br />\n            All Rights Reserved.\n          </th>\n        </tr>\n      </thead>\n    </table>\n  </div>\n</div>\n',
      CompanyId: 116,
      IsEnable: true,
      IsSelected: true,
      TemplateTypeId: "199",
      TemplateId: 20,
    },
    {
      TemplateName: null,
      TemplateHtml:
        '<style>\n  .salesReceipt th {\n    font-size: 12px;\n    line-height: 14px;\n    font-family: Calibri;\n    padding: 0px 2px;\n  }\n  .salesReceipt td {\n    border-collapse: collapse;\n    font-family: Calibri;\n    padding: 0px;\n    font-size: 12px;\n    height: 20px;\n    line-height: 14px;\n  }\n</style>\n<div style="font-family: Calibri; font-size: 12px" class="salesReceipt">\n  <div style="width: 100%; text-align: center">\n    <!--<img src="{companyLogo}" style="height: 50px; width: auto"/>-->\n  </div>\n  <table style="width: 100%">\n    <thead>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            margin-bottom: 0;\n            font-size: 24px;\n            font-family: Calibri;\n            font-weight: 600;\n            color: #000;\n            height: 24px;\n          "\n        >\n          {companyName}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            font-size: 11px;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {{branchAddress}}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <div style="border: 2px solid #000; text-align: center">\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 600;\n              border: 0;\n              color: #000;\n              width: 100%;\n            "\n            colspan="2"\n          >\n            SALE RECEIPT\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n       \n        <tr>\n          <th\n            style="text-align: left; font-weight: 500; border: 0; color: #000"\n          >\n            Order Mode\n          </th>\n          <th\n            style="text-align: right; font-weight: 500; border: 0; color: #000"\n          >\n            {orderMode}\n          </th>\n        </tr>\n      </tbody>\n    </table>\n    <table style="width: 100%" class="salesReceipt">\n      <tbody>\n{table} {waiter} {rider} {customerName}\n{address}{phone}\n      </tbody>\n    </table>\n  </div>\n  <table style="width: 100%" class="salesReceipt">\n    <tbody>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order #\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderNumber}\n        </th>\n      </tr>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Date/Time:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderDateTime}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <table\n    style="\n      width: 100%;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n    "\n  >\n    <thead>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Qty\n        </th>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Item\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          Price\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      {itemBody}\n    </tbody>\n  </table>\n  <table style="width: 100%; border-collapse: collapse">\n    <tbody>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Subtotal:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {productSubtotal}\n        </td>\n      </tr>\n      {beforeBill}\n     \n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Total Amount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {totalAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Discount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {discountAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            font-weight: 500;\n            color: #000;\n          "\n        >\n          Net Bill:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 500;\n            color: #000;\n            border: 0;\n          "\n        >\n          {productNetBill}\n        </td>\n      </tr>\n      {finalBill}\n{returnAmount}\n      {paymentMode}\n    </tbody>\n  </table>\n  <br />\n  <div\n    style="margin: 2px 0; border: 2px solid #000; text-align: center"\n    class="salesReceipt"\n  >\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 400;\n              border: 0;\n              color: #000;\n              width: 100%;\n              padding: 3px;\n            "\n          >\n            Copyright© 2022 <br />\n            All Rights Reserved.\n          </th>\n        </tr>\n      </thead>\n    </table>\n  </div>\n</div>\n',
      CompanyId: 116,
      IsEnable: true,
      IsSelected: true,
      TemplateTypeId: "358",
      TemplateId: 21,
    },
    {
      TemplateName: null,
      TemplateHtml:
        '<style>\n  .salesReceipt th {\n    font-size: 12px;\n    line-height: 14px;\n    font-family: Calibri;\n    padding: 0px 2px;\n  }\n  .salesReceipt td {\n    border-collapse: collapse;\n    font-family: Calibri;\n    padding: 0px;\n    font-size: 12px;\n    height: 20px;\n    line-height: 14px;\n  }\n</style>\n<div style="font-family: Calibri; font-size: 12px" class="salesReceipt">\n  <div style="width: 100%; text-align: center">\n    <!--<img src="{companyLogo}" style="height: 50px; width: auto"/>-->\n  </div>\n  <table style="width: 100%">\n    <thead>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            margin-bottom: 0;\n            font-size: 24px;\n            font-family: Calibri;\n            font-weight: 600;\n            color: #000;\n            height: 24px;\n          "\n        >\n          {companyName}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            font-size: 11px;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {{branchAddress}}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <div style="border: 2px solid #000; text-align: center">\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 600;\n              border: 0;\n              color: #000;\n              width: 100%;\n            "\n            colspan="2"\n          >\n            DUPLICATE SALE RECEIPT\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        \n        <tr>\n          <th\n            style="text-align: left; font-weight: 500; border: 0; color: #000"\n          >\n            Order Mode\n          </th>\n          <th\n            style="text-align: right; font-weight: 500; border: 0; color: #000"\n          >\n            {orderMode}\n          </th>\n        </tr>\n      </tbody>\n    </table>\n    <table style="width: 100%" class="salesReceipt">\n      <tbody>\n   {table}\n{waiter}\n {customerName}\n{address}{phone}\n\n\n\n{rider}\n      </tbody>\n    </table>\n  </div>\n  <table style="width: 100%" class="salesReceipt">\n    <tbody>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order #\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderNumber}\n        </th>\n      </tr>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Date/Time:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n{orderDateTime}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <table\n    style="\n      width: 100%;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n    "\n  >\n    <thead>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Qty\n        </th>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Item\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          Price\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      {itemBody}\n    </tbody>\n  </table>\n  <table style="width: 100%; border-collapse: collapse">\n    <tbody>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Subtotal:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {productSubtotal}\n        </td>\n      </tr>\n      {beforeBill}\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          GST ({gstPercent}):\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {productGst}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Total Amount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {totalAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Discount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {discountAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            font-weight: 500;\n            color: #000;\n          "\n        >\n          Net Bill:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 500;\n            color: #000;\n            border: 0;\n          "\n        >\n          {productNetBill}\n        </td>\n      </tr>\n      {finalBill}\n    </tbody>\n  </table>\n  <br />\n  <div\n    style="margin: 2px 0; border: 2px solid #000; text-align: center"\n    class="salesReceipt"\n  >\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 400;\n              border: 0;\n              color: #000;\n              width: 100%;\n              padding: 3px;\n            "\n          >\n            Copyright© 2022 <br />\n            All Rights Reserved.\n          </th>\n        </tr>\n      </thead>\n    </table>\n  </div>\n</div>\n',
      CompanyId: 116,
      IsEnable: true,
      IsSelected: true,
      TemplateTypeId: "359",
      TemplateId: 22,
    },
    {
      TemplateName: null,
      TemplateHtml:
        '<style>\n  .salesReceipt th {\n    font-size: 12px;\n    line-height: 14px;\n    font-family: Calibri;\n    padding: 0px 2px;\n  }\n  .salesReceipt td {\n    border-collapse: collapse;\n    font-family: Calibri;\n    padding: 0px;\n    font-size: 12px;\n    height: 20px;\n    line-height: 14px;\n  }\n</style>\n<div style="font-family: Calibri; font-size: 12px" class="salesReceipt">\n  <div style="width: 100%; text-align: center">\n    <!--<img src="{companyLogo}" style="height: 50px; width: auto"/>-->\n  </div>\n  <table style="width: 100%">\n    <thead>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            margin-bottom: 0;\n            font-size: 24px;\n            font-family: Calibri;\n            font-weight: 600;\n            color: #000;\n            height: 24px;\n          "\n        >\n          {companyName}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            font-size: 11px;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {{branchAddress}}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <div style="border: 2px solid #000; text-align: center">\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 600;\n              border: 0;\n              color: #000;\n              width: 100%;\n            "\n            colspan="2"\n          >\n            SALE RETURN\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <th\n            style="text-align: left; font-weight: 500; border: 0; color: #000"\n          >\n            {billDate}\n          </th>\n          <th\n            style="text-align: right; font-weight: 500; border: 0; color: #000"\n          >\n            {billTime}\n          </th>\n        </tr>\n        <tr>\n          <th\n            style="text-align: left; font-weight: 500; border: 0; color: #000"\n          >\n            Order Mode\n          </th>\n          <th\n            style="text-align: right; font-weight: 500; border: 0; color: #000"\n          >\n            {orderMode}\n          </th>\n        </tr>\n      </tbody>\n    </table>\n    <table style="width: 100%" class="salesReceipt">\n      <tbody>\n        {embadFields}\n      </tbody>\n    </table>\n  </div>\n  <table style="width: 100%" class="salesReceipt">\n    <tbody>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order #\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderNumber}\n        </th>\n      </tr>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Date/Time:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderDateTime}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <table\n    style="\n      width: 100%;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n    "\n  >\n    <thead>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Qty\n        </th>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Item\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          Price\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      {itemBody}\n    </tbody>\n  </table>\n  <table style="width: 100%; border-collapse: collapse">\n    <tbody>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Subtotal:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {productSubtotal}\n        </td>\n      </tr>\n      {beforeBill}\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          GST ({gstPercent}):\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {productGst}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Total Amount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {totalAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          Discount\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n        >\n          {discountAmount}\n        </td>\n      </tr>\n      <tr>\n        <td\n          style="\n            vertical-align: middle;\n            font-weight: 400;\n            border: 0;\n            font-weight: 500;\n            color: #000;\n          "\n        >\n          Net Bill:\n        </td>\n        <td\n          style="\n            text-align: right;\n            vertical-align: middle;\n            font-weight: 500;\n            color: #000;\n            border: 0;\n          "\n        >\n          {productNetBill}\n        </td>\n      </tr>\n      {finalBill}\n    </tbody>\n  </table>\n  <br />\n  <div\n    style="margin: 2px 0; border: 2px solid #000; text-align: center"\n    class="salesReceipt"\n  >\n    <table style="width: 100%">\n      <thead>\n        <tr>\n          <th\n            style="\n              text-align: center;\n              font-weight: 400;\n              border: 0;\n              color: #000;\n              width: 100%;\n              padding: 3px;\n            "\n          >\n            Copyright© 2022 <br />\n            All Rights Reserved.\n          </th>\n        </tr>\n      </thead>\n    </table>\n  </div>\n</div>\n',
      CompanyId: 116,
      IsEnable: true,
      IsSelected: true,
      TemplateTypeId: "361",
      TemplateId: 24,
    },
    {
      TemplateName: null,
      TemplateHtml:
        '<style>\n  .kotReceipt th {\n    font-size: 12px;\n    line-height: 16px;\n    font-family: Calibri;\n    padding: 0px 2px;\n  }\n  .kotReceipt td {\n    border-collapse: collapse;\n    font-family: Calibri;\n    padding: 0px;\n    font-size: 12px;\n    height: 20px;\n    line-height: 16px;\n  }\n</style>\n<div style="font-family: Calibri; font-size: 12px" class="kotReceipt">\n  <table style="width: 100%; border: 2px solid #000">\n    <thead>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            margin-bottom: 0;\n            font-size: 18px;\n            font-family: Calibri;\n            font-weight: 600;\n            color: #000;\n            height: 24px;\n          "\n          colspan="2"\n        >\n          Kitchen (KOT)\n        </th>\n      </tr>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            font-size: 16px;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n          colspan="2"\n        >\n          {orderNumber}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <th\n          style="\n            text-align: left;\n            font-weight: 500;\n            border: 0;\n            color: #000;\n            padding-top: 10px;\n          "\n        >\n          {billDate}\n        </th>\n        <th\n          style="\n            text-align: right;\n            font-weight: 500;\n            border: 0;\n            color: #000;\n            padding-top: 10px;\n          "\n        >\n          {billTime}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n<table style="width: 100%" class="kotReceipt">\n    <tbody>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order #\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderNumber}\n        </th>\n      </tr>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Date/Time:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderDateTime}\n        </th>\n      </tr>\n<tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Mode:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderMode}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n  <table style="width: 100%" class="salesReceipt">\n      <tbody>\n        {embadFields}\n      </tbody>\n    </table>\n  <table\n    style="\n      width: 100%;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n    "\n  >\n    <thead>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Qty\n        </th>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Item\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          Type\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      {itemBody}\n    </tbody>\n  </table>\n</div>\n',
      CompanyId: 116,
      IsEnable: true,
      IsSelected: true,
      TemplateTypeId: "352",
      TemplateId: 58,
    },
    {
      TemplateName: null,
      TemplateHtml:
        '<style>\n  .kotReceipt th {\n    font-size: 12px;\n    line-height: 16px;\n    font-family: Calibri;\n    padding: 0px 2px;\n  }\n  .kotReceipt td {\n    border-collapse: collapse;\n    font-family: Calibri;\n    padding: 0px;\n    font-size: 12px;\n    height: 20px;\n    line-height: 16px;\n  }\n</style>\n<div style="font-family: Calibri; font-size: 12px" class="kotReceipt">\n  <table style="width: 100%; border: 2px solid #000">\n    <thead>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            margin-bottom: 0;\n            font-size: 18px;\n            font-family: Calibri;\n            font-weight: 600;\n            color: #000;\n            height: 24px;\n          "\n          colspan="2"\n        >\n          Consolidated - KOT\n        </th>\n      </tr>\n      <tr>\n        <th\n          style="\n            text-align: center;\n            font-size: 16px;\n            font-weight: 400;\n            border: 0;\n            color: #000;\n          "\n          colspan="2"\n        >\n          {orderNumber}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <th\n          style="\n            text-align: left;\n            font-weight: 500;\n            border: 0;\n            color: #000;\n            padding-top: 10px;\n          "\n        >\n          {billDate}\n        </th>\n        <th\n          style="\n            text-align: right;\n            font-weight: 500;\n            border: 0;\n            color: #000;\n            padding-top: 10px;\n          "\n        >\n          {billTime}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n<table style="width: 100%" class="kotReceipt">\n    <tbody>\n      \n<tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Order Mode:\n        </th>\n        <th style="text-align: right; font-weight: 500; border: 0; color: #000">\n          {orderMode}\n        </th>\n      </tr>\n    </tbody>\n  </table>\n\n  <table\n    style="\n      width: 100%;\n      border-top: 2px solid #000;\n      border-bottom: 2px solid #000;\n    "\n  >\n    <thead>\n      <tr>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Qty\n        </th>\n        <th style="text-align: left; font-weight: 500; border: 0; color: #000">\n          Item\n        </th>\n      \n      </tr>\n    </thead>\n    <tbody>\n      {itemBody}\n    </tbody>\n  </table>\n</div>\n',
      CompanyId: 116,
      IsEnable: true,
      IsSelected: true,
      TemplateTypeId: "385",
      TemplateId: 60,
    },
  ],
  TemplateTypeList: [
    {
      TemplateTypeId: "199",
      TemplateTypeName: "BillTemplate",
    },
    {
      TemplateTypeId: "358",
      TemplateTypeName: "Sales Receipt Bill Template",
    },
    {
      TemplateTypeId: "359",
      TemplateTypeName: "Duplicate Sale Receipt Bill Template",
    },
    {
      TemplateTypeId: "352",
      TemplateTypeName: "KOT Bill Template",
    },
    {
      TemplateTypeId: "361",
      TemplateTypeName: "Sale Return Bill Template",
    },
    {
      TemplateTypeId: "385",
      TemplateTypeName: "Consolidated KOT ",
    },
  ],
  OrderStatusList: [
    {
      OrderStatusId: 298,
      OrderStatus: "New",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: true,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: true,
      IsTakeAway: true,
      IsDelivery: true,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 299,
      OrderStatus: "Preparation",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: true,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: true,
      IsTakeAway: true,
      IsDelivery: true,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 300,
      OrderStatus: "Dispatch",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: false,
      IsTakeAway: false,
      IsDelivery: true,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 301,
      OrderStatus: "Delivered",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: false,
      IsTakeAway: false,
      IsDelivery: true,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 302,
      OrderStatus: "Cancel",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: false,
      IsCancelable: true,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: true,
      IsTakeAway: true,
      IsDelivery: true,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 303,
      OrderStatus: "Paid",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: true,
      IsUnconfirm: false,
      IsDineIn: false,
      IsTakeAway: false,
      IsDelivery: false,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 304,
      OrderStatus: "Ready",
      CompanyId: 116,
      CreatedDate: null,
      CreatedBy: null,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: false,
      IsTakeAway: false,
      IsDelivery: false,
      IsReady: true,
      IsFinishWaste: false,
      IsRefund: false,
    },
    {
      OrderStatusId: 470,
      OrderStatus: "Waste",
      CompanyId: 116,
      CreatedDate: "2022-12-12T20:09:28.697",
      CreatedBy: 1,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: "",
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: false,
      IsTakeAway: false,
      IsDelivery: false,
      IsReady: false,
      IsFinishWaste: true,
      IsRefund: false,
    },
    {
      OrderStatusId: 568,
      OrderStatus: "Refund",
      CompanyId: 116,
      CreatedDate: "2022-12-12T20:09:36.027",
      CreatedBy: 1,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: "",
      IsActive: true,
      IsInitial: false,
      IsCancelable: false,
      IsProcess: false,
      IsClosed: false,
      IsUnconfirm: false,
      IsDineIn: false,
      IsTakeAway: false,
      IsDelivery: false,
      IsReady: false,
      IsFinishWaste: false,
      IsRefund: true,
    },
  ],
  Branch: [
    {
      BranchId: 168,
      BranchName: "Krispy2GO Johar",
    },
  ],
  BranchList: [
    {
      RowNum: 1,
      AreaId: 1521,
      CompanyId: 116,
      AreaName: "Bahadurabad",
      CountryName: "Pakistan",
      ProvinceName: "Sindh",
      CityName: "Karachi",
      CityId: 46,
      ProvinceId: 35,
      CountryId: 64,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-12-01T21:56:42.05",
      CreatedBy: "Krispy 2 Go",
      ModifiedBy: "Krispy 2 Go",
      UserIP: "12.1.1.2",
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
    },
    {
      RowNum: 2,
      AreaId: 1528,
      CompanyId: 116,
      AreaName: "DHA Karachi",
      CountryName: "Pakistan",
      ProvinceName: "Sindh",
      CityName: "Karachi",
      CityId: 46,
      ProvinceId: 35,
      CountryId: 64,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-12-12T17:23:05.17",
      CreatedBy: "Krispy 2 Go",
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
    },
    {
      RowNum: 3,
      AreaId: 1523,
      CompanyId: 116,
      AreaName: "Johar",
      CountryName: "Pakistan",
      ProvinceName: "Sindh",
      CityName: "Karachi",
      CityId: 46,
      ProvinceId: 35,
      CountryId: 64,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-12-01T21:57:27.647",
      CreatedBy: "Krispy 2 Go",
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
    },
    {
      RowNum: 4,
      AreaId: 1522,
      CompanyId: 116,
      AreaName: "Maskan",
      CountryName: "Pakistan",
      ProvinceName: "Sindh",
      CityName: "Karachi",
      CityId: 46,
      ProvinceId: 35,
      CountryId: 64,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-12-01T21:56:59.753",
      CreatedBy: "Krispy 2 Go",
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
    },
    {
      RowNum: 5,
      AreaId: 1524,
      CompanyId: 116,
      AreaName: "Masroor Base",
      CountryName: "Pakistan",
      ProvinceName: "Sindh",
      CityName: "Karachi",
      CityId: 46,
      ProvinceId: 35,
      CountryId: 64,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-12-01T21:57:53.88",
      CreatedBy: "Krispy 2 Go",
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
    },
    {
      RowNum: 6,
      AreaId: 1527,
      CompanyId: 116,
      AreaName: "Saddar",
      CountryName: "Pakistan",
      ProvinceName: "Punjab",
      CityName: "Rawalpindi",
      CityId: 55,
      ProvinceId: 36,
      CountryId: 64,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-12-09T15:50:30.81",
      CreatedBy: "Krispy 2 Go",
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
    },
  ],
  SetupDetailList: [
    {
      SetupDetailId: 55,
      SetupMasterId: 8,
      SetupDetailName: "Information",
      ParentId: 0,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      CreatedBy: 2,
      CreatedDate: "2022-04-14T01:15:57.26",
      ModifiedBy: 2,
      ModifiedDate: "2022-04-14T01:16:07.94",
      UserIP: "12.1.1.2",
      CompanyId: null,
    },
    {
      SetupDetailId: 56,
      SetupMasterId: 8,
      SetupDetailName: "Complaint",
      ParentId: 0,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      CreatedBy: 2,
      CreatedDate: "2022-04-14T01:15:57.26",
      ModifiedBy: 2,
      ModifiedDate: "2022-04-14T01:16:07.94",
      UserIP: "12.1.1.2",
      CompanyId: null,
    },
  ],
  PaymentModeList: [
    {
      PaymentModeId: 120,
      PaymentMode: "CASH",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 121,
      PaymentMode: "CARD",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 123,
      PaymentMode: "Golotloo Online",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 157,
      PaymentMode: "FP Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 158,
      PaymentMode: "Panda Go Web",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 159,
      PaymentMode: "Panda Go CC",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 160,
      PaymentMode: "Golootlo Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 161,
      PaymentMode: "Golootlo Card",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 162,
      PaymentMode: "PandaGO Golootlo",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 163,
      PaymentMode: "Call Center Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 164,
      PaymentMode: "Call Center CC",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 165,
      PaymentMode: "Web app cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 166,
      PaymentMode: "Web Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 197,
      PaymentMode: "WebApp Online",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 212,
      PaymentMode: "F.P Dine in Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 213,
      PaymentMode: "F.P Take Away Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 214,
      PaymentMode: "F.P Dine in Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 215,
      PaymentMode: "F.P Take Away Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
  ],
  Gst: [
    {
      RowNum: 1,
      GSTId: 63,
      CompanyId: 116,
      GSTName: "GST",
      CityName: "Karachi",
      CityId: 46,
      CompanyName: "Krispy 2 Go",
      CreatedDate: "2022-10-17T18:57:26.66",
      CreatedBy: "Admin",
      ModifiedBy: "Admin",
      UserIP: "12.1.1.2",
      GSTPercentage: 0,
      PaymentModeId: 120,
      PaymentMode: "CASH",
    },
  ],
  PaymentModeList2: [
    {
      PaymentModeId: 120,
      PaymentMode: "CASH",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 121,
      PaymentMode: "CARD",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 123,
      PaymentMode: "Golotloo Online",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 157,
      PaymentMode: "FP Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 158,
      PaymentMode: "Panda Go Web",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 159,
      PaymentMode: "Panda Go CC",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 160,
      PaymentMode: "Golootlo Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 161,
      PaymentMode: "Golootlo Card",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 162,
      PaymentMode: "PandaGO Golootlo",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 163,
      PaymentMode: "Call Center Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 164,
      PaymentMode: "Call Center CC",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 165,
      PaymentMode: "Web app cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 166,
      PaymentMode: "Web Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 197,
      PaymentMode: "WebApp Online",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 212,
      PaymentMode: "F.P Dine in Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 213,
      PaymentMode: "F.P Take Away Cash",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 214,
      PaymentMode: "F.P Dine in Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
    {
      PaymentModeId: 215,
      PaymentMode: "F.P Take Away Credit",
      IsFoc: false,
      OrderSourceId: null,
      IsPartyAccount: false,
    },
  ],
  OrderSourceList: [
    {
      OrderModeId: 109,
      OrderSourceId: 193,
      OrderMode: "DineIn",
      OrderSource: "POS",
    },
    {
      OrderModeId: 110,
      OrderSourceId: 193,
      OrderMode: "TakeAway",
      OrderSource: "POS",
    },
    {
      OrderModeId: 111,
      OrderSourceId: 193,
      OrderMode: "Delivery",
      OrderSource: "POS",
    },
    {
      OrderModeId: 112,
      OrderSourceId: 193,
      OrderMode: "FinishWaste",
      OrderSource: "POS",
    },
    {
      OrderModeId: 111,
      OrderSourceId: 363,
      OrderMode: "Delivery",
      OrderSource: "Food Panda",
    },
  ],
  WaiterList: [
    {
      WaiterId: 78,
      WaiterName: "Saqib",
    },
    {
      WaiterId: 79,
      WaiterName: "Aqib",
    },
    {
      WaiterId: 80,
      WaiterName: "Zia",
    },
  ],
  CustomerList: [
    {
      CustomerId: 83,
      CustomerName: "AHMED KIRMANI",
      IsActive: true,
      CreatedBy: 103,
      CreatedDate: "2022-05-14T16:47:13.94",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 108,
      CustomerName: "IRFAN AHMED",
      IsActive: true,
      CreatedBy: 103,
      CreatedDate: "2022-05-26T16:30:01.117",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 110,
      CustomerName: "MEHMOOD",
      IsActive: true,
      CreatedBy: 107,
      CreatedDate: "2022-05-28T19:48:36.58",
      ModifiedBy: 107,
      ModifiedDate: "2022-11-27T12:29:23.113",
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: true,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 111,
      CustomerName: "SUFYAN AHMED",
      IsActive: true,
      CreatedBy: 107,
      CreatedDate: "2022-05-28T19:59:57.42",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 561,
      CustomerName: "DSJKHDJKSHAK",
      IsActive: true,
      CreatedBy: 107,
      CreatedDate: "2022-12-01T22:19:03.687",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 2637,
      CustomerName: "MUSTAFA AHMED",
      IsActive: true,
      CreatedBy: 111,
      CreatedDate: "2022-12-30T00:00:00",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: "mustafa@gmail.com",
      Password: "asdasd",
    },
  ],
  TableList: [
    {
      TableId: 51,
      TableName: "Table 1",
      IsOpen: true,
    },
    {
      TableId: 59,
      TableName: "Table 5",
      IsOpen: true,
    },
    {
      TableId: 163,
      TableName: "table22",
      IsOpen: false,
    },
    {
      TableId: 176,
      TableName: "my table",
      IsOpen: true,
    },
    {
      TableId: 177,
      TableName: "your table",
      IsOpen: true,
    },
    {
      TableId: 178,
      TableName: "their table",
      IsOpen: false,
    },
  ],
  DealDescList: [
    {
      ProductDetailId: 4285,
      DealDescId: 2073,
      DealDescItemDetailId: 2996,
      Quantity: 1,
      Price: 0,
      DealItemId: 698,
      DealName: "MIDNIGHT MADNESS",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4285,
      DealDescId: 2074,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 699,
      DealName: "MIDNIGHT MADNESS",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4294,
      DealDescId: 2109,
      DealDescItemDetailId: 4257,
      Quantity: 8,
      Price: 0,
      DealItemId: 734,
      DealName: "BIG CHHICK",
      DealDescItemName: "KRISPY CHICKEN PIECES (1Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4570,
      DealDescId: 2292,
      DealDescItemDetailId: 3002,
      Quantity: 2,
      Price: 0,
      DealItemId: 765,
      DealName: "2 WRAPSTAR (FP)",
      DealDescItemName: "WRAP STAR",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4571,
      DealDescId: 2293,
      DealDescItemDetailId: 2993,
      Quantity: 2,
      Price: 0,
      DealItemId: 766,
      DealName: "2 KRISPY CHICKEN BURGER (FP)",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4594,
      DealDescId: 2294,
      DealDescItemDetailId: 2997,
      Quantity: 10,
      Price: 0,
      DealItemId: 767,
      DealName: "10 SUPPER VALUE BURGER",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4595,
      DealDescId: 2295,
      DealDescItemDetailId: 2997,
      Quantity: 15,
      Price: 0,
      DealItemId: 768,
      DealName: "15 SUPPER VALUE BURGER",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4596,
      DealDescId: 2296,
      DealDescItemDetailId: 2997,
      Quantity: 20,
      Price: 0,
      DealItemId: 769,
      DealName: "20 SUPPER VALUE BURGER",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4597,
      DealDescId: 2297,
      DealDescItemDetailId: 2997,
      Quantity: 25,
      Price: 0,
      DealItemId: 770,
      DealName: "25 SUPPER VALUE BURGER",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4572,
      DealDescId: 2298,
      DealDescItemDetailId: 2990,
      Quantity: 2,
      Price: 0,
      DealItemId: 771,
      DealName: "BIN SAFEER BOGO DELUX",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4573,
      DealDescId: 2299,
      DealDescItemDetailId: 2993,
      Quantity: 3,
      Price: 0,
      DealItemId: 772,
      DealName: "BIN SAFEER BOGO BUY 2 GET 1 CHICKEN BURGER",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4576,
      DealDescId: 2301,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 774,
      DealName: "BOGO K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4578,
      DealDescId: 2303,
      DealDescItemDetailId: 2997,
      Quantity: 1,
      Price: 0,
      DealItemId: 776,
      DealName: "F.P MIDNIGHT DEAL 1",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4578,
      DealDescId: 2304,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 777,
      DealName: "F.P MIDNIGHT DEAL 1",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4579,
      DealDescId: 2305,
      DealDescItemDetailId: 2993,
      Quantity: 1,
      Price: 0,
      DealItemId: 778,
      DealName: "F.P MID NIGHT DEAL 2",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4579,
      DealDescId: 2306,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 779,
      DealName: "F.P MID NIGHT DEAL 2",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4580,
      DealDescId: 2307,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 780,
      DealName: "GOLOTLO 2 K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4581,
      DealDescId: 2308,
      DealDescItemDetailId: 3002,
      Quantity: 2,
      Price: 0,
      DealItemId: 781,
      DealName: "GOLOTLO 2 WRAPSTAR",
      DealDescItemName: "WRAP STAR",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4582,
      DealDescId: 2309,
      DealDescItemDetailId: 2993,
      Quantity: 3,
      Price: 0,
      DealItemId: 782,
      DealName: "IMTIAZ BUY 2 GET 1 CHICKEN BURGER",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4586,
      DealDescId: 2314,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 787,
      DealName: "VOUCH 365 BOGO SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4602,
      DealDescId: 2319,
      DealDescItemDetailId: 2996,
      Quantity: 10,
      Price: 0,
      DealItemId: 792,
      DealName: "10 KRUNCHI BITE BURGER",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4603,
      DealDescId: 2320,
      DealDescItemDetailId: 2996,
      Quantity: 15,
      Price: 0,
      DealItemId: 793,
      DealName: "15 KRUNCHI BITE BURGER",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4604,
      DealDescId: 2321,
      DealDescItemDetailId: 2996,
      Quantity: 20,
      Price: 0,
      DealItemId: 794,
      DealName: "20 KRUNCHI BITE BURGER",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4605,
      DealDescId: 2322,
      DealDescItemDetailId: 2996,
      Quantity: 25,
      Price: 0,
      DealItemId: 795,
      DealName: "25 KRUNCHI BITE BURGER",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4606,
      DealDescId: 2323,
      DealDescItemDetailId: 2993,
      Quantity: 10,
      Price: 0,
      DealItemId: 796,
      DealName: "10 KRISPY CHICKEN BURGERS",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4607,
      DealDescId: 2324,
      DealDescItemDetailId: 2993,
      Quantity: 15,
      Price: 0,
      DealItemId: 797,
      DealName: "15 KRISPY CHICKEN BURGERS",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4608,
      DealDescId: 2325,
      DealDescItemDetailId: 2993,
      Quantity: 20,
      Price: 0,
      DealItemId: 798,
      DealName: "20 KRISPY CHICKEN BURGERS",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4609,
      DealDescId: 2326,
      DealDescItemDetailId: 2993,
      Quantity: 25,
      Price: 0,
      DealItemId: 799,
      DealName: "25 KRISPY CHICKEN BURGERS",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4628,
      DealDescId: 2329,
      DealDescItemDetailId: 2996,
      Quantity: 1,
      Price: 0,
      DealItemId: 802,
      DealName: "KRISPY SAVERS 01",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4628,
      DealDescId: 2331,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 804,
      DealName: "KRISPY SAVERS 01",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4629,
      DealDescId: 2332,
      DealDescItemDetailId: 4610,
      Quantity: 1,
      Price: 0,
      DealItemId: 805,
      DealName: "KRISPY SAVERS 02",
      DealDescItemName: "KRISPY CHICKEN PIECE (2 Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4629,
      DealDescId: 2333,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 806,
      DealName: "KRISPY SAVERS 02",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4630,
      DealDescId: 2334,
      DealDescItemDetailId: 2995,
      Quantity: 1,
      Price: 0,
      DealItemId: 807,
      DealName: "KRISPY SAVERS 03",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4630,
      DealDescId: 2335,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 808,
      DealName: "KRISPY SAVERS 03",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4631,
      DealDescId: 2336,
      DealDescItemDetailId: 3002,
      Quantity: 1,
      Price: 0,
      DealItemId: 809,
      DealName: "KRISPY SAVERS 04",
      DealDescItemName: "WRAP STAR",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4631,
      DealDescId: 2337,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 810,
      DealName: "KRISPY SAVERS 04",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4636,
      DealDescId: 2345,
      DealDescItemDetailId: 4635,
      Quantity: 1,
      Price: 0,
      DealItemId: 813,
      DealName: "Nuggets(5)",
      DealDescItemName: "NUGGETS (5 Pcs)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4636,
      DealDescId: 2346,
      DealDescItemDetailId: 4276,
      Quantity: 1,
      Price: 0,
      DealItemId: 814,
      DealName: "Nuggets(5)",
      DealDescItemName: "DIP N DIP",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4637,
      DealDescId: 2359,
      DealDescItemDetailId: 4617,
      Quantity: 1,
      Price: 0,
      DealItemId: 817,
      DealName: "Nuggets (10)",
      DealDescItemName: "NUGGETS (10 Pcs)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4637,
      DealDescId: 2360,
      DealDescItemDetailId: 4276,
      Quantity: 1,
      Price: 0,
      DealItemId: 818,
      DealName: "Nuggets (10)",
      DealDescItemName: "DIP N DIP",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4585,
      DealDescId: 2471,
      DealDescItemDetailId: 2993,
      Quantity: 2,
      Price: 0,
      DealItemId: 866,
      DealName: "VOUCH 365 BOGO CHICKEN BURGER",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4620,
      DealDescId: 2488,
      DealDescItemDetailId: 2990,
      Quantity: 2,
      Price: 0,
      DealItemId: 883,
      DealName: "Bogo Delux",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4574,
      DealDescId: 2489,
      DealDescItemDetailId: 2993,
      Quantity: 2,
      Price: 0,
      DealItemId: 884,
      DealName: "BOGO CHICKEN BURGER",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4619,
      DealDescId: 2502,
      DealDescItemDetailId: 2996,
      Quantity: 2,
      Price: 0,
      DealItemId: 897,
      DealName: "11.11 Krunchi Deal",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4646,
      DealDescId: 2503,
      DealDescItemDetailId: 2990,
      Quantity: 2,
      Price: 0,
      DealItemId: 898,
      DealName: "Imtiaz Bogo Delux",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4647,
      DealDescId: 2504,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 899,
      DealName: "Imtiaz Bogo K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4641,
      DealDescId: 2505,
      DealDescItemDetailId: 4640,
      Quantity: 6,
      Price: 0,
      DealItemId: 900,
      DealName: "6 Pcs Hot Wing",
      DealDescItemName: "5 Hot Wing (Pcs)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4641,
      DealDescId: 2506,
      DealDescItemDetailId: 4276,
      Quantity: 1,
      Price: 0,
      DealItemId: 901,
      DealName: "6 Pcs Hot Wing",
      DealDescItemName: "DIP N DIP",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4648,
      DealDescId: 2512,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 902,
      DealName: "BIN SAFEER K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4649,
      DealDescId: 2513,
      DealDescItemDetailId: 2990,
      Quantity: 2,
      Price: 0,
      DealItemId: 903,
      DealName: "Al Jadeed BOGO Delux",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4650,
      DealDescId: 2514,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 904,
      DealName: "Al Jadeed Bogo K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4651,
      DealDescId: 2515,
      DealDescItemDetailId: 2993,
      Quantity: 3,
      Price: 0,
      DealItemId: 905,
      DealName: "Al Jadeed BOGO Buy 2 Get 1",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4583,
      DealDescId: 2516,
      DealDescItemDetailId: 2993,
      Quantity: 3,
      Price: 0,
      DealItemId: 906,
      DealName: "J. BOGO Buy 2 Get 1 Chicken Burger",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4652,
      DealDescId: 2517,
      DealDescItemDetailId: 2990,
      Quantity: 2,
      Price: 0,
      DealItemId: 907,
      DealName: "J. BOGO DELUX",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4577,
      DealDescId: 2518,
      DealDescItemDetailId: 2993,
      Quantity: 3,
      Price: 0,
      DealItemId: 908,
      DealName: "DIAMOND BUY 2 GET 1 CHICKEN BURGER",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4584,
      DealDescId: 2521,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 911,
      DealName: "J. BOGO K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4653,
      DealDescId: 2522,
      DealDescItemDetailId: 2990,
      Quantity: 2,
      Price: 0,
      DealItemId: 912,
      DealName: "Diamond BOGO Delux",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4654,
      DealDescId: 2523,
      DealDescItemDetailId: 2995,
      Quantity: 2,
      Price: 0,
      DealItemId: 913,
      DealName: "Diamond Bogo K2G SPICY",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4633,
      DealDescId: 2531,
      DealDescItemDetailId: 4261,
      Quantity: 1,
      Price: 0,
      DealItemId: 916,
      DealName: "FRIES BUCKET.(eliminate)",
      DealDescItemName: "Bucket Fries",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4633,
      DealDescId: 2532,
      DealDescItemDetailId: 4277,
      Quantity: 1,
      Price: 0,
      DealItemId: 917,
      DealName: "FRIES BUCKET.(eliminate)",
      DealDescItemName: "DIP N DIP",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4656,
      DealDescId: 2538,
      DealDescItemDetailId: 2993,
      Quantity: 2,
      Price: 0,
      DealItemId: 918,
      DealName: "T20 World Cup F.P",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5232,
      DealDescId: 3545,
      DealDescItemDetailId: 2993,
      Quantity: 1,
      Price: 0,
      DealItemId: 1143,
      DealName: "COMBO 1",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5232,
      DealDescId: 3546,
      DealDescItemDetailId: 4257,
      Quantity: 1,
      Price: 0,
      DealItemId: 1144,
      DealName: "COMBO 1",
      DealDescItemName: "KRISPY CHICKEN PIECES (1Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5233,
      DealDescId: 3547,
      DealDescItemDetailId: 2997,
      Quantity: 1,
      Price: 0,
      DealItemId: 1145,
      DealName: "COMBO 2",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5233,
      DealDescId: 3548,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1146,
      DealName: "COMBO 2",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5068,
      DealDescId: 3549,
      DealDescItemDetailId: 2996,
      Quantity: 4,
      Price: 0,
      DealItemId: 1147,
      DealName: "KRUNCHY WINTER",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5068,
      DealDescId: 3550,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1148,
      DealName: "KRUNCHY WINTER",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5234,
      DealDescId: 3551,
      DealDescItemDetailId: 3002,
      Quantity: 1,
      Price: 0,
      DealItemId: 1149,
      DealName: "COMBO 3",
      DealDescItemName: "WRAP STAR",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5234,
      DealDescId: 3552,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1150,
      DealName: "COMBO 3",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5279,
      DealDescId: 3896,
      DealDescItemDetailId: 3001,
      Quantity: 1,
      Price: 0,
      DealItemId: 1250,
      DealName: "SPICY TOWER COMBO F.P",
      DealDescItemName: "SPICY TOWER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5279,
      DealDescId: 3897,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1251,
      DealName: "SPICY TOWER COMBO F.P",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5279,
      DealDescId: 3898,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1252,
      DealName: "SPICY TOWER COMBO F.P",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4622,
      DealDescId: 3910,
      DealDescItemDetailId: 4645,
      Quantity: 1,
      Price: 0,
      DealItemId: 1258,
      DealName: "Cricket Treat 2",
      DealDescItemName: "CHICKEN PIECE (4 PCS)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4622,
      DealDescId: 3911,
      DealDescItemDetailId: 4643,
      Quantity: 4,
      Price: 0,
      DealItemId: 1259,
      DealName: "Cricket Treat 2",
      DealDescItemName: "Chicken Strips (4 PCS)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4622,
      DealDescId: 3913,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1260,
      DealName: "Cricket Treat 2",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4622,
      DealDescId: 3914,
      DealDescItemDetailId: 4276,
      Quantity: 1,
      Price: 0,
      DealItemId: 1261,
      DealName: "Cricket Treat 2",
      DealDescItemName: "DIP N DIP",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4622,
      DealDescId: 3920,
      DealDescItemDetailId: 4267,
      Quantity: 1,
      Price: 0,
      DealItemId: 1262,
      DealName: "Cricket Treat 2",
      DealDescItemName: "LOADED FRIES Regular",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4623,
      DealDescId: 3921,
      DealDescItemDetailId: 3002,
      Quantity: 2,
      Price: 0,
      DealItemId: 1263,
      DealName: "Cricket Treat 3",
      DealDescItemName: "WRAP STAR",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4623,
      DealDescId: 3922,
      DealDescItemDetailId: 4643,
      Quantity: 4,
      Price: 0,
      DealItemId: 1264,
      DealName: "Cricket Treat 3",
      DealDescItemName: "Chicken Strips (4 PCS)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4623,
      DealDescId: 3924,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1265,
      DealName: "Cricket Treat 3",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4623,
      DealDescId: 3925,
      DealDescItemDetailId: 4276,
      Quantity: 1,
      Price: 0,
      DealItemId: 1266,
      DealName: "Cricket Treat 3",
      DealDescItemName: "DIP N DIP",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4623,
      DealDescId: 3931,
      DealDescItemDetailId: 4267,
      Quantity: 1,
      Price: 0,
      DealItemId: 1267,
      DealName: "Cricket Treat 3",
      DealDescItemName: "LOADED FRIES Regular",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5466,
      DealDescId: 3941,
      DealDescItemDetailId: 5189,
      Quantity: 1,
      Price: 0,
      DealItemId: 1276,
      DealName: "F.P 2 SANDWICH",
      DealDescItemName: "Tikka Sandwich",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4282,
      DealDescId: 3977,
      DealDescItemDetailId: 2993,
      Quantity: 1,
      Price: 0,
      DealItemId: 1294,
      DealName: "KIDDY MEAL 1",
      DealDescItemName: "CHICKEN BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4282,
      DealDescId: 3978,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1295,
      DealName: "KIDDY MEAL 1",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4282,
      DealDescId: 3979,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1296,
      DealName: "KIDDY MEAL 1",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 6492,
      DealDescId: 4026,
      DealDescItemDetailId: 2997,
      Quantity: 5,
      Price: 0,
      DealItemId: 1320,
      DealName: "YEAR END DEAL",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 6492,
      DealDescId: 4027,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1321,
      DealName: "YEAR END DEAL",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4269,
      DealDescId: 4144,
      DealDescItemDetailId: 2997,
      Quantity: 2,
      Price: 0,
      DealItemId: 1388,
      DealName: "TWIN DEAL 1",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4269,
      DealDescId: 4145,
      DealDescItemDetailId: 4264,
      Quantity: 2,
      Price: 0,
      DealItemId: 1389,
      DealName: "TWIN DEAL 1",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4269,
      DealDescId: 4146,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1390,
      DealName: "TWIN DEAL 1",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4290,
      DealDescId: 4147,
      DealDescItemDetailId: 4610,
      Quantity: 1,
      Price: 0,
      DealItemId: 1391,
      DealName: "KRISPY BITE 01",
      DealDescItemName: "KRISPY CHICKEN PIECE (2 Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4290,
      DealDescId: 4148,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1392,
      DealName: "KRISPY BITE 01",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4290,
      DealDescId: 4149,
      DealDescItemDetailId: 4614,
      Quantity: 1,
      Price: 0,
      DealItemId: 1393,
      DealName: "KRISPY BITE 01",
      DealDescItemName: "DINNER ROLL",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4290,
      DealDescId: 4150,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1394,
      DealName: "KRISPY BITE 01",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4291,
      DealDescId: 4151,
      DealDescItemDetailId: 4645,
      Quantity: 1,
      Price: 0,
      DealItemId: 1395,
      DealName: "KRISPY BITE 02",
      DealDescItemName: "CHICKEN PIECE (4 PCS)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4291,
      DealDescId: 4152,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1396,
      DealName: "KRISPY BITE 02",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4291,
      DealDescId: 4153,
      DealDescItemDetailId: 4614,
      Quantity: 2,
      Price: 0,
      DealItemId: 1397,
      DealName: "KRISPY BITE 02",
      DealDescItemName: "DINNER ROLL",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4291,
      DealDescId: 4154,
      DealDescItemDetailId: 4264,
      Quantity: 2,
      Price: 0,
      DealItemId: 1398,
      DealName: "KRISPY BITE 02",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4292,
      DealDescId: 4155,
      DealDescItemDetailId: 2996,
      Quantity: 1,
      Price: 0,
      DealItemId: 1399,
      DealName: "BRAVO MEAL",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4292,
      DealDescId: 4156,
      DealDescItemDetailId: 4257,
      Quantity: 1,
      Price: 0,
      DealItemId: 1400,
      DealName: "BRAVO MEAL",
      DealDescItemName: "KRISPY CHICKEN PIECES (1Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4292,
      DealDescId: 4157,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1401,
      DealName: "BRAVO MEAL",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4292,
      DealDescId: 4158,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1402,
      DealName: "BRAVO MEAL",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4293,
      DealDescId: 4159,
      DealDescItemDetailId: 2996,
      Quantity: 2,
      Price: 0,
      DealItemId: 1403,
      DealName: "BETTER 2 GETHER",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4293,
      DealDescId: 4160,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1404,
      DealName: "BETTER 2 GETHER",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4293,
      DealDescId: 4161,
      DealDescItemDetailId: 4264,
      Quantity: 2,
      Price: 0,
      DealItemId: 1405,
      DealName: "BETTER 2 GETHER",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4293,
      DealDescId: 4162,
      DealDescItemDetailId: 4610,
      Quantity: 2,
      Price: 0,
      DealItemId: 1406,
      DealName: "BETTER 2 GETHER",
      DealDescItemName: "KRISPY CHICKEN PIECE (2 Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4270,
      DealDescId: 4163,
      DealDescItemDetailId: 2996,
      Quantity: 2,
      Price: 0,
      DealItemId: 1407,
      DealName: "TWIN DEAL 2",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4270,
      DealDescId: 4164,
      DealDescItemDetailId: 4264,
      Quantity: 2,
      Price: 0,
      DealItemId: 1408,
      DealName: "TWIN DEAL 2",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4270,
      DealDescId: 4165,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1409,
      DealName: "TWIN DEAL 2",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4284,
      DealDescId: 4169,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1413,
      DealName: "KIDDY MEAL 3",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4284,
      DealDescId: 4170,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1414,
      DealName: "KIDDY MEAL 3",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4284,
      DealDescId: 4171,
      DealDescItemDetailId: 4642,
      Quantity: 1,
      Price: 0,
      DealItemId: 1415,
      DealName: "KIDDY MEAL 3",
      DealDescItemName: "Nuggets (4 Pcs)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4283,
      DealDescId: 4357,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1476,
      DealName: "KIDDY MEAL 2",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4283,
      DealDescId: 4358,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1477,
      DealName: "KIDDY MEAL 2",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4283,
      DealDescId: 4359,
      DealDescItemDetailId: 4644,
      Quantity: 1,
      Price: 0,
      DealItemId: 1478,
      DealName: "KIDDY MEAL 2",
      DealDescItemName: "Krispy Popper (7 PCS)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5235,
      DealDescId: 4445,
      DealDescItemDetailId: 4610,
      Quantity: 1,
      Price: 0,
      DealItemId: 1516,
      DealName: "COMBO 4",
      DealDescItemName: "KRISPY CHICKEN PIECE (2 Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5235,
      DealDescId: 4446,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1517,
      DealName: "COMBO 4",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4295,
      DealDescId: 4447,
      DealDescItemDetailId: 4257,
      Quantity: 4,
      Price: 0,
      DealItemId: 1518,
      DealName: "FAMILY O' CLOCK  01",
      DealDescItemName: "KRISPY CHICKEN PIECES (1Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4295,
      DealDescId: 4448,
      DealDescItemDetailId: 2997,
      Quantity: 4,
      Price: 0,
      DealItemId: 1519,
      DealName: "FAMILY O' CLOCK  01",
      DealDescItemName: "K2G SUPPER VALUE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4295,
      DealDescId: 4449,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1520,
      DealName: "FAMILY O' CLOCK  01",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4295,
      DealDescId: 4450,
      DealDescItemDetailId: 4261,
      Quantity: 1,
      Price: 0,
      DealItemId: 1521,
      DealName: "FAMILY O' CLOCK  01",
      DealDescItemName: "Bucket Fries",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4296,
      DealDescId: 4451,
      DealDescItemDetailId: 4257,
      Quantity: 4,
      Price: 0,
      DealItemId: 1522,
      DealName: "FAMILY O' CLOCK  02",
      DealDescItemName: "KRISPY CHICKEN PIECES (1Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4296,
      DealDescId: 4452,
      DealDescItemDetailId: 2996,
      Quantity: 4,
      Price: 0,
      DealItemId: 1523,
      DealName: "FAMILY O' CLOCK  02",
      DealDescItemName: "KRUNCHY BITE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4296,
      DealDescId: 4453,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1524,
      DealName: "FAMILY O' CLOCK  02",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4296,
      DealDescId: 4454,
      DealDescItemDetailId: 4261,
      Quantity: 1,
      Price: 0,
      DealItemId: 1525,
      DealName: "FAMILY O' CLOCK  02",
      DealDescItemName: "Bucket Fries",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4297,
      DealDescId: 4455,
      DealDescItemDetailId: 4257,
      Quantity: 9,
      Price: 0,
      DealItemId: 1526,
      DealName: "KRISPY TREAT",
      DealDescItemName: "KRISPY CHICKEN PIECES (1Pc)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4297,
      DealDescId: 4456,
      DealDescItemDetailId: 4261,
      Quantity: 1,
      Price: 0,
      DealItemId: 1527,
      DealName: "KRISPY TREAT",
      DealDescItemName: "Bucket Fries",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4297,
      DealDescId: 4457,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1528,
      DealName: "KRISPY TREAT",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4298,
      DealDescId: 4458,
      DealDescItemDetailId: 2989,
      Quantity: 1,
      Price: 0,
      DealItemId: 1529,
      DealName: "K2G SIGNATURE CLUB",
      DealDescItemName: "CHIPOTLE BURGER",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4298,
      DealDescId: 4459,
      DealDescItemDetailId: 2990,
      Quantity: 1,
      Price: 0,
      DealItemId: 1530,
      DealName: "K2G SIGNATURE CLUB",
      DealDescItemName: "KRISPY DELUX",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4298,
      DealDescId: 4460,
      DealDescItemDetailId: 2995,
      Quantity: 1,
      Price: 0,
      DealItemId: 1531,
      DealName: "K2G SIGNATURE CLUB",
      DealDescItemName: "K2G SPICY",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4298,
      DealDescId: 4461,
      DealDescItemDetailId: 4304,
      Quantity: 1,
      Price: 0,
      DealItemId: 1532,
      DealName: "K2G SIGNATURE CLUB",
      DealDescItemName: "1 LTR DRINK",
      SizeId: 556,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4298,
      DealDescId: 4462,
      DealDescItemDetailId: 4261,
      Quantity: 1,
      Price: 0,
      DealItemId: 1533,
      DealName: "K2G SIGNATURE CLUB",
      DealDescItemName: "Bucket Fries",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4613,
      DealDescId: 4468,
      DealDescItemDetailId: 5249,
      Quantity: 1,
      Price: 0,
      DealItemId: 1538,
      DealName: "Add on Fries & Drink",
      DealDescItemName: "Fries",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 4613,
      DealDescId: 4469,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1539,
      DealName: "Add on Fries & Drink",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5236,
      DealDescId: 4475,
      DealDescItemDetailId: 4264,
      Quantity: 1,
      Price: 0,
      DealItemId: 1544,
      DealName: "COMBO 5",
      DealDescItemName: "REG. DRINK",
      SizeId: 578,
      SortIndex: 0,
    },
    {
      ProductDetailId: 5236,
      DealDescId: 4476,
      DealDescItemDetailId: 4640,
      Quantity: 1,
      Price: 0,
      DealItemId: 1545,
      DealName: "COMBO 5",
      DealDescItemName: "5 Hot Wing (Pcs)",
      SizeId: 489,
      SortIndex: 0,
    },
    {
      ProductDetailId: 7059,
      DealDescId: 4499,
      DealDescItemDetailId: 3003,
      Quantity: 3,
      Price: 0,
      DealItemId: 1563,
      DealName: "Buy 2 get 1 free Imtiaz chipotle wrap star",
      DealDescItemName: "SIGNATURE CHIPOTLE WRAP STAR",
      SizeId: 489,
      SortIndex: 0,
    },
  ],
  RiderList: [
    {
      RiderId: 94,
      RiderName: "Ali",
    },
    {
      RiderId: 95,
      RiderName: "Jamshad",
    },
    {
      RiderId: 116,
      RiderName: "F.P Rider JHR",
    },
    {
      RiderId: 126,
      RiderName: "Ahsan khan",
    },
    {
      RiderId: 127,
      RiderName: "Panada Go  Rider",
    },
  ],
  ProductDetailList: [
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1668,
      ProductName: "CHICKEN BURGER",
      IsDeal: false,
      ProductDetailId: 2993,
      Price: 319,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1669,
      ProductName: "CHIPOTLE BURGER",
      IsDeal: false,
      ProductDetailId: 2989,
      Price: 632,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHIPOTLE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 13,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9bf2a3da-5fea-438d-a3fb-7eaa71b31f2e.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1670,
      ProductName: "CHIPOTLE TOWER",
      IsDeal: false,
      ProductDetailId: 2999,
      Price: 719,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHIPOTLE TOWER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\01632df6-9715-4a80-9dcd-038e496b9d6f.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1671,
      ProductName: "K2G SUPPER VALUE BURGER",
      IsDeal: false,
      ProductDetailId: 2997,
      Price: 384,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1672,
      ProductName: "KRISPY DELUX",
      IsDeal: false,
      ProductDetailId: 2990,
      Price: 576,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1673,
      ProductName: "KRUNCHY BITE BURGER",
      IsDeal: false,
      ProductDetailId: 2996,
      Price: 479,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1675,
      ProductName: "K2G SPICY",
      IsDeal: false,
      ProductDetailId: 2995,
      Price: 520,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1679,
      ProductName: "SIGNATURE CHIPOTLE WRAP STAR",
      IsDeal: false,
      ProductDetailId: 3003,
      Price: 450,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SIGNATURE CHIPOTLE WRAP STAR - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\d6b5137c-0f2b-4132-9833-af37af0219e3.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1681,
      ProductName: "SPICY TOWER",
      IsDeal: false,
      ProductDetailId: 3001,
      Price: 632,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SPICY TOWER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\b36731ea-3f1b-4de9-bc26-8cad0d5c6564.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1682,
      ProductName: "WRAP STAR",
      IsDeal: false,
      ProductDetailId: 3002,
      Price: 384,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "WRAP STAR - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2288,
      ProductName: "KRISPY CHICKEN PIECES (1Pc)",
      IsDeal: false,
      ProductDetailId: 4257,
      Price: 264,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2292,
      ProductName: "REG. DRINK",
      IsDeal: false,
      ProductDetailId: 4264,
      Price: 80,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "REG. DRINK - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2292,
      ProductName: "REG. DRINK",
      IsDeal: false,
      ProductDetailId: 5283,
      Price: 80,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "REG. DRINK - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2322,
      ProductName: "1 LTR DRINK",
      IsDeal: false,
      ProductDetailId: 4304,
      Price: 120,
      SizeId: 556,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "N/A",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2500,
      ProductName: "KRISPY CHICKEN PIECE (2 Pc)",
      IsDeal: false,
      ProductDetailId: 4610,
      Price: 440,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2501,
      ProductName: "KRISPY CHICKEN PIECE (5Pcs)",
      IsDeal: false,
      ProductDetailId: 4611,
      Price: 1028,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECE (5Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\77a25895-76bc-4745-a27a-ea23188498bc.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2502,
      ProductName: "KRISPY CHICKEN PIECE (8 Pcs)",
      IsDeal: false,
      ProductDetailId: 4612,
      Price: 1710,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECE (8 Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\deabec62-fe2e-4603-8fdf-beb5900348c1.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2891,
      ProductName: "KRISPY CHICKEN PIECE (4 Pc)",
      IsDeal: false,
      ProductDetailId: 5242,
      Price: 730,
      SizeId: 580,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "KRISPY CHICKEN PIECE (4 Pc) - 4 Pcs - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "4 Pcs",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4203529d-a192-401f-95da-497b0194ecf6.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2892,
      ProductName: "Beef Premium",
      IsDeal: false,
      ProductDetailId: 5245,
      Price: 650,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Beef Premium - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c81c29da-bf0d-4e49-ba85-ec061fa3bf82.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2894,
      ProductName: "Beef Classic",
      IsDeal: false,
      ProductDetailId: 5247,
      Price: 620,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Beef Classic - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e114e302-bc95-4974-b9ef-8ca3bc2f205d.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 3032,
      ProductName: "CHEESIEST BURGER",
      IsDeal: false,
      ProductDetailId: 5441,
      Price: 620,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHEESIEST BURGER - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2294,
      ProductName: "BETTER 2 GETHER",
      IsDeal: true,
      ProductDetailId: 4293,
      Price: 1250,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BETTER 2 GETHER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cfd8b084-04ef-4fd1-a8a8-0249fc8fd2b1.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2295,
      ProductName: "BIG CHHICK",
      IsDeal: true,
      ProductDetailId: 4294,
      Price: 1299,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BIG CHHICK - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\23a78ecc-9387-4761-b334-3f04733c8cbb.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2296,
      ProductName: "BRAVO MEAL",
      IsDeal: true,
      ProductDetailId: 4292,
      Price: 770,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BRAVO MEAL - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\621cbe9e-0a5d-4683-921d-452ec6389ebe.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2297,
      ProductName: "KRISPY BITE 01",
      IsDeal: true,
      ProductDetailId: 4290,
      Price: 690,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY BITE 01 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cbfcda72-f9c9-47e7-85f3-2f89c9a4a408.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2298,
      ProductName: "KRISPY BITE 02",
      IsDeal: true,
      ProductDetailId: 4291,
      Price: 950,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY BITE 02 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c2850a30-cecb-4aad-ab82-8eacd6d3db69.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2299,
      ProductName: "FAMILY O' CLOCK  01",
      IsDeal: true,
      ProductDetailId: 4295,
      Price: 1775,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "FAMILY O' CLOCK  01 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9f124b1d-f1b9-45bd-a9d5-fd87fdf31a76.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2300,
      ProductName: "FAMILY O' CLOCK  02",
      IsDeal: true,
      ProductDetailId: 4296,
      Price: 1999,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "FAMILY O' CLOCK  02 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1d0caafd-93f4-4549-9dd5-35bf8e043fad.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2301,
      ProductName: "K2G SIGNATURE CLUB",
      IsDeal: true,
      ProductDetailId: 4298,
      Price: 1650,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "K2G SIGNATURE CLUB - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\60661f0d-d9bc-4750-9900-61efe5412c5d.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2302,
      ProductName: "KRISPY TREAT",
      IsDeal: true,
      ProductDetailId: 4297,
      Price: 1750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY TREAT - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e195780c-d9d8-4464-a52a-9cef153f4e11.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 594,
      CategoryName: "FRIES",
      CategoryImage: null,
      ProductId: 2140,
      ProductName: "Fries",
      IsDeal: false,
      ProductDetailId: 5249,
      Price: 224,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Fries - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
      SortOrder: 10,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      CategoryImage: null,
      ProductId: 2304,
      ProductName: "KIDDY MEAL 1",
      IsDeal: true,
      ProductDetailId: 4282,
      Price: 490,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KIDDY MEAL 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\90232f41-619c-45bb-a6d6-0700bf5ad0dc.jpg",
      SortOrder: 13,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      CategoryImage: null,
      ProductId: 2305,
      ProductName: "KIDDY MEAL 2",
      IsDeal: true,
      ProductDetailId: 4283,
      Price: 490,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KIDDY MEAL 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\793ad154-991c-45b6-a581-d6e84c02eb2c.jpg",
      SortOrder: 13,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      CategoryImage: null,
      ProductId: 2306,
      ProductName: "KIDDY MEAL 3",
      IsDeal: true,
      ProductDetailId: 4284,
      Price: 490,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KIDDY MEAL 3 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bd4a3185-3765-4a64-9310-e0e39358cc02.jpg",
      SortOrder: 13,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2308,
      ProductName: "MIDNIGHT MADNESS",
      IsDeal: true,
      ProductDetailId: 4285,
      Price: 490,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "MIDNIGHT MADNESS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f38b6014-a906-4b7d-926f-31fbe2928a1a.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2507,
      ProductName: "11.11 Krunchi Deal",
      IsDeal: true,
      ProductDetailId: 4619,
      Price: 444,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "11.11 Krunchi Deal - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\d567e546-6b68-46aa-9616-58cdf262972b.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2508,
      ProductName: "Bogo Delux",
      IsDeal: true,
      ProductDetailId: 4620,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Bogo Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f35539c5-3b76-49ae-bc72-5397d444a583.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2514,
      ProductName: "BIN SAFEER BOGO BUY 2 GET 1 CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4573,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName:
        "BIN SAFEER BOGO BUY 2 GET 1 CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\05548b5a-813f-46cb-bfbb-e13510f9206d.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2515,
      ProductName: "BIN SAFEER BOGO DELUX",
      IsDeal: true,
      ProductDetailId: 4572,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BIN SAFEER BOGO DELUX - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\52a5950c-7a38-4e58-b1f5-f1cbfa5364aa.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2519,
      ProductName: "DIAMOND BUY 2 GET 1 CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4577,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DIAMOND BUY 2 GET 1 CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c31a8bb4-47b6-41f0-96a4-c04ff032ab56.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2522,
      ProductName: "IMTIAZ BUY 2 GET 1 CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4582,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "IMTIAZ BUY 2 GET 1 CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c6fc8e64-9f2a-4d16-afb9-52cdcb5d2f8d.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2523,
      ProductName: "J. BOGO K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4584,
      Price: 590,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "J. BOGO K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\ff221c69-7ae1-4447-bb5c-362848755765.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2524,
      ProductName: "J. BOGO Buy 2 Get 1 Chicken Burger",
      IsDeal: true,
      ProductDetailId: 4583,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "J. BOGO Buy 2 Get 1 Chicken Burger - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a51d8221-f518-4ed5-bbc6-57239c6d2bba.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2525,
      ProductName: "F.P MIDNIGHT DEAL 1",
      IsDeal: true,
      ProductDetailId: 4578,
      Price: 390,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "F.P MIDNIGHT DEAL 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1d4c18cc-bfb7-4748-8fd9-0f3a7beb56af.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2526,
      ProductName: "F.P MID NIGHT DEAL 2",
      IsDeal: true,
      ProductDetailId: 4579,
      Price: 350,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "F.P MID NIGHT DEAL 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f026acb0-f8bb-49fd-81ef-7756292f7157.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2563,
      ProductName: "Imtiaz Bogo Delux",
      IsDeal: true,
      ProductDetailId: 4646,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Imtiaz Bogo Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c1195b30-76ef-47fc-986f-c3ef6f13f62d.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2564,
      ProductName: "Imtiaz Bogo K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4647,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Imtiaz Bogo K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\df45da58-f101-43b4-a6fa-ab33061beb03.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2566,
      ProductName: "Al Jadeed BOGO Delux",
      IsDeal: true,
      ProductDetailId: 4649,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Al Jadeed BOGO Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\057910fd-70d6-4c95-9321-878600a19fe4.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2567,
      ProductName: "Al Jadeed Bogo K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4650,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Al Jadeed Bogo K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\634aa9b7-59b9-4d50-8b35-b6dfd439ac32.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2568,
      ProductName: "Al Jadeed BOGO Buy 2 Get 1",
      IsDeal: true,
      ProductDetailId: 4651,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Al Jadeed BOGO Buy 2 Get 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\873588af-423d-4f8c-a428-b009d924b971.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2569,
      ProductName: "J. BOGO DELUX",
      IsDeal: true,
      ProductDetailId: 4652,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "J. BOGO DELUX - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9e5e8ced-b86b-4fbd-a041-f7605f1d8c88.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2570,
      ProductName: "Diamond BOGO Delux",
      IsDeal: true,
      ProductDetailId: 4653,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Diamond BOGO Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\de21e0ef-7108-4ecb-862d-677b28e0a2c7.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2571,
      ProductName: "Diamond Bogo K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4654,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Diamond Bogo K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\ae1c0c81-0a13-41cf-b8f4-7ea45a823cf0.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2734,
      ProductName: "KRUNCHY WINTER",
      IsDeal: true,
      ProductDetailId: 5068,
      Price: 1199,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRUNCHY WINTER - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\ad2a70de-53b3-4ec4-bbc9-421a4b9a6d66.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2918,
      ProductName: "SPICY TOWER COMBO F.P",
      IsDeal: true,
      ProductDetailId: 5279,
      Price: 816,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SPICY TOWER COMBO F.P - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3036,
      ProductName: "F.P 2 SANDWICH",
      IsDeal: true,
      ProductDetailId: 5466,
      Price: 999,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "F.P 2 SANDWICH - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\40a648f8-f526-4fc5-85bf-cfa0438e3248.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3365,
      ProductName: "TREAT BOX 1",
      IsDeal: true,
      ProductDetailId: 5795,
      Price: 1190,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TREAT BOX 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\2a8a4fee-b35b-4b77-b8d1-11b79383fa27.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3366,
      ProductName: "TREAT BOX 2",
      IsDeal: true,
      ProductDetailId: 5796,
      Price: 1190,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TREAT BOX 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\29264375-e0af-4aac-956d-e5347469cedd.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3367,
      ProductName: "TREAT BOX 3",
      IsDeal: true,
      ProductDetailId: 5797,
      Price: 1190,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TREAT BOX 3 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\399ea030-b6c8-4f9c-93c9-296abeee42c6.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 4062,
      ProductName: "YEAR END DEAL",
      IsDeal: true,
      ProductDetailId: 6492,
      Price: 1200,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "YEAR END DEAL - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\27fea0be-41f6-4530-8803-9a3b95477b56.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 4641,
      ProductName: "Buy 2 get 1 free Imtiaz chipotle wrap star",
      IsDeal: true,
      ProductDetailId: 7059,
      Price: 799,
      SizeId: 556,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName:
        "Buy 2 get 1 free Imtiaz chipotle wrap star - N/A - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "N/A",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4f455281-ec4f-4677-8527-27bc11da004f.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2138,
      ProductName: "DINNER ROLL",
      IsDeal: false,
      ProductDetailId: 4614,
      Price: 40,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DINNER ROLL - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\6a0a130e-0db1-4f37-b011-3113be47ccfb.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2287,
      ProductName: "CHEESE (Slice)",
      IsDeal: false,
      ProductDetailId: 4262,
      Price: 70,
      SizeId: 572,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHEESE (Slice) - 1 PC - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "1 PC",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1a6ab6c9-18cb-427a-bbb4-ab4d9f69195c.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2290,
      ProductName: "Krispy Pop Corn (10 PCS)",
      IsDeal: false,
      ProductDetailId: 4260,
      Price: 552,
      SizeId: 573,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Krispy Pop Corn (10 PCS) - 10 PCS - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "10 PCS",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5173e4cd-15c4-4f9f-9f92-5e00365dba9f.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2290,
      ProductName: "Krispy Pop Corn (10 PCS)",
      IsDeal: false,
      ProductDetailId: 4638,
      Price: 552,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Krispy Pop Corn (10 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5173e4cd-15c4-4f9f-9f92-5e00365dba9f.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2291,
      ProductName: "MINERAL WATER",
      IsDeal: false,
      ProductDetailId: 4266,
      Price: 120,
      SizeId: 576,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "MINERAL WATER - L - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "L",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\146d547f-b95f-4667-a527-471826411812.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2293,
      ProductName: "Bucket Fries",
      IsDeal: false,
      ProductDetailId: 4261,
      Price: 300,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Bucket Fries - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2303,
      ProductName: "LOADED FRIES Regular",
      IsDeal: false,
      ProductDetailId: 4267,
      Price: 360,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2309,
      ProductName: "BROWNIE",
      IsDeal: false,
      ProductDetailId: 4275,
      Price: 350,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BROWNIE - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a8b7eca7-f01f-433e-bf22-4f96aae7ec93.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4276,
      Price: 80,
      SizeId: 489,
      FlavourId: 291,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "CHIPOTLE",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4277,
      Price: 80,
      SizeId: 489,
      FlavourId: 292,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "GARLIC MAYO",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4278,
      Price: 80,
      SizeId: 489,
      FlavourId: 300,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "SPICY MAYO",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4279,
      Price: 80,
      SizeId: 489,
      FlavourId: 293,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "HOT & SPICY",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4280,
      Price: 80,
      SizeId: 489,
      FlavourId: 295,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "PERY PERY",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4281,
      Price: 80,
      SizeId: 489,
      FlavourId: 294,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "LEMON & HERBS",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2503,
      ProductName: "LOADED FRIES (Large)",
      IsDeal: false,
      ProductDetailId: 4615,
      Price: 440,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "LOADED FRIES (Large) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a0f5820d-2fed-4910-85cf-461ec32da8e3.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2552,
      ProductName: "Add on Fries & Drink",
      IsDeal: true,
      ProductDetailId: 4613,
      Price: 240,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Add on Fries & Drink - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\2c702b1a-f424-48c4-8cf0-90d530a7ec16.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2554,
      ProductName: "Nuggets(5)",
      IsDeal: true,
      ProductDetailId: 4636,
      Price: 355,
      SizeId: 489,
      FlavourId: 294,
      OnlyForDeal: false,
      ProductDetailName: "Nuggets(5) - STD - LEMON & HERBS",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "LEMON & HERBS",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\0391e1c8-95f6-4ab7-9bab-604f557b6390.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2555,
      ProductName: "Nuggets (10)",
      IsDeal: true,
      ProductDetailId: 4637,
      Price: 532,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Nuggets (10) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cce6f7f3-bb78-4a76-9725-8baf2d0291f2.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2557,
      ProductName: "6 Pcs Hot Wing",
      IsDeal: true,
      ProductDetailId: 4641,
      Price: 390,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "6 Pcs Hot Wing - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\35da117f-2926-4513-9371-afbafb371299.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2558,
      ProductName: "5 Hot Wing (Pcs)",
      IsDeal: false,
      ProductDetailId: 4640,
      Price: 310,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "5 Hot Wing (Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cc900ecd-4f5d-460a-8268-06c2394f0fe8.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2559,
      ProductName: "Nuggets (4 Pcs)",
      IsDeal: false,
      ProductDetailId: 4642,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Nuggets (4 Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\02faf991-9267-41de-ae7f-d8ebf89b5c6f.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2560,
      ProductName: "Chicken Strips (4 PCS)",
      IsDeal: false,
      ProductDetailId: 4643,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Chicken Strips (4 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4c40ce12-d58e-484c-afb1-8d6e2c7e5a36.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2561,
      ProductName: "Krispy Popper (7 PCS)",
      IsDeal: false,
      ProductDetailId: 4644,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Krispy Popper (7 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\3250bce7-9d7c-4e02-bd9e-a915598b4d86.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2562,
      ProductName: "CHICKEN PIECE (4 PCS)",
      IsDeal: false,
      ProductDetailId: 4645,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "CHICKEN PIECE (4 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a9e8b996-4fab-4508-9f44-cc2b5d2b488f.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 4316,
      ProductName: "Nuggets",
      IsDeal: false,
      ProductDetailId: 6716,
      Price: 0,
      SizeId: 572,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Nuggets - 1 PC - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "1 PC",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 4468,
      ProductName: "MINERAL WATER - SMALL",
      IsDeal: false,
      ProductDetailId: 4265,
      Price: 90,
      SizeId: 579,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "MINERAL WATER - SMALL - S - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "S",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 599,
      CategoryName: "COMBO MEALS",
      CategoryImage: null,
      ProductId: 2314,
      ProductName: "TWIN DEAL 1",
      IsDeal: true,
      ProductDetailId: 4269,
      Price: 777,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TWIN DEAL 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\753a9071-e7c8-4cae-a28a-4c46bea60ebe.jpg",
      SortOrder: 11,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 599,
      CategoryName: "COMBO MEALS",
      CategoryImage: null,
      ProductId: 2315,
      ProductName: "TWIN DEAL 2",
      IsDeal: true,
      ProductDetailId: 4270,
      Price: 888,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TWIN DEAL 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\7d30ec8a-bf45-40e0-8ad3-494ee6e3c257.jpg",
      SortOrder: 11,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2512,
      ProductName: "2 KRISPY CHICKEN BURGER (FP)",
      IsDeal: true,
      ProductDetailId: 4571,
      Price: 500,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "2 KRISPY CHICKEN BURGER (FP) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\35e94749-19c8-46e5-84c2-f7c40c4f10ad.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2513,
      ProductName: "2 WRAPSTAR (FP)",
      IsDeal: true,
      ProductDetailId: 4570,
      Price: 532,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "2 WRAPSTAR (FP) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f4989730-cf39-4a20-81d6-02267360a2bd.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2518,
      ProductName: "BOGO K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4576,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BOGO K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\68bac92b-f245-41eb-b457-134fd7a23ce2.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2520,
      ProductName: "GOLOTLO 2 K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4580,
      Price: 540,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "GOLOTLO 2 K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\b6dd458c-79a8-4514-b74a-fee99bd72b07.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2521,
      ProductName: "GOLOTLO 2 WRAPSTAR",
      IsDeal: true,
      ProductDetailId: 4581,
      Price: 400,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "GOLOTLO 2 WRAPSTAR - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\55cc9d78-5378-4eeb-a7cb-36db9509c2e4.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2527,
      ProductName: "VOUCH 365 BOGO CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4585,
      Price: 310,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "VOUCH 365 BOGO CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\02acf779-6eda-484e-83f8-f1553a1b474f.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2528,
      ProductName: "VOUCH 365 BOGO SPICY",
      IsDeal: true,
      ProductDetailId: 4586,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "VOUCH 365 BOGO SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9aa62b7a-9a31-416f-9bdd-c92db56b909e.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2529,
      ProductName: "10 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4606,
      Price: 1900,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "10 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bd9153e4-8c81-4927-a1a2-bd8b15d8a4f0.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2530,
      ProductName: "10 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4602,
      Price: 3100,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "10 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9858270c-5e50-466a-8f58-48f213b5d9e6.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2531,
      ProductName: "10 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4594,
      Price: 2100,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "10 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\15169f5e-b0e8-46fc-a880-f866da27c5ef.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2532,
      ProductName: "15 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4607,
      Price: 2850,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1c5cc0d9-4bbf-403a-9d3d-de4bd30095a8.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2533,
      ProductName: "15 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4598,
      Price: 2250,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bd61e555-315b-40f7-9a0d-a28fc37b2a1e.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2534,
      ProductName: "15 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4603,
      Price: 4050,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f27a7f8a-5abc-4b9f-9f9f-7e46e1b15861.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2535,
      ProductName: "15 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4595,
      Price: 3150,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5c7595a3-cb6d-4104-8aa7-1a92e7d7acbe.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2536,
      ProductName: "20 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4608,
      Price: 2800,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4267afc7-3da9-4104-b5de-8ff53bbe5792.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2537,
      ProductName: "20 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4599,
      Price: 3000,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\25f8fefc-6b25-481b-a786-037e134aafeb.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2538,
      ProductName: "20 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4604,
      Price: 6200,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\b1bd46e6-d0fd-4979-a7dd-8042683fa7c1.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2539,
      ProductName: "20 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4596,
      Price: 4200,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cb0f3ea0-05a2-466e-817b-1dcc95c851b0.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2540,
      ProductName: "25 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4609,
      Price: 4750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\eb249cb6-fa05-4b85-a5d1-75d98d497011.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2541,
      ProductName: "25 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4600,
      Price: 3750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4aa4816f-3587-4489-bd65-02d01eb931bc.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2542,
      ProductName: "25 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4605,
      Price: 7750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e0035017-f71c-4df2-a1e5-9582bd0e0ce4.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2543,
      ProductName: "25 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4597,
      Price: 5250,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\8a5bf4fb-9142-43f0-a78a-eb1888980555.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2544,
      ProductName: "30 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4601,
      Price: 4500,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "30 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a0037f40-37e8-4def-a66c-128d2b36d44a.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 700,
      CategoryName: "SANDWICH",
      CategoryImage: "",
      ProductId: 2840,
      ProductName: "Tikka Sandwich",
      IsDeal: false,
      ProductDetailId: 5189,
      Price: 680,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Tikka Sandwich - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\3ccdb2ce-c530-4ef1-9ba1-12d421fe2635.jpg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 700,
      CategoryName: "SANDWICH",
      CategoryImage: "",
      ProductId: 2841,
      ProductName: "Malai Boti Sandwich",
      IsDeal: false,
      ProductDetailId: 5190,
      Price: 680,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Malai Boti Sandwich - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c0e6e063-d034-4ca3-9ac4-cf6784c90041.jpg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 700,
      CategoryName: "SANDWICH",
      CategoryImage: "",
      ProductId: 3035,
      ProductName: "SANDWICH TREAT BOX",
      IsDeal: true,
      ProductDetailId: 5465,
      Price: 1200,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SANDWICH TREAT BOX - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2882,
      ProductName: "COMBO 1",
      IsDeal: true,
      ProductDetailId: 5232,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 1 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\3eda2354-3482-4768-b47a-07871e0d0521.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2883,
      ProductName: "COMBO 2",
      IsDeal: true,
      ProductDetailId: 5233,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 2 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\8e28b63f-991f-4e76-8a40-9c2873adc36b.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2884,
      ProductName: "COMBO 3",
      IsDeal: true,
      ProductDetailId: 5234,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 3 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\32e9518d-1890-4f09-ad23-3b79c68f2f32.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2885,
      ProductName: "COMBO 4",
      IsDeal: true,
      ProductDetailId: 5235,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 4 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\00f73ae8-49da-458f-8589-6a026c20262e.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2886,
      ProductName: "COMBO 5",
      IsDeal: true,
      ProductDetailId: 5236,
      Price: 390,
      SizeId: 557,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 5 - PCS - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "PCS",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\d3b1331e-ea6e-4d88-a958-3f69328033c2.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      CategoryImage: "",
      ProductId: 2888,
      ProductName: "DC 80",
      IsDeal: true,
      ProductDetailId: 5237,
      Price: 80,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DC 80 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      CategoryImage: "",
      ProductId: 2889,
      ProductName: "DC 100",
      IsDeal: false,
      ProductDetailId: 5238,
      Price: 100,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DC 100 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },
    {
      orderSourceId: 193,
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      CategoryImage: "",
      ProductId: 2890,
      ProductName: "DC 120",
      IsDeal: false,
      ProductDetailId: 5239,
      Price: 120,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DC 120 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
    },

    /////////////////////////////////////////
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1668,
      ProductName: "CHICKEN BURGER",
      IsDeal: false,
      ProductDetailId: 2993,
      Price: 290,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1669,
      ProductName: "CHIPOTLE BURGER",
      IsDeal: false,
      ProductDetailId: 2989,
      Price: 666,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHIPOTLE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 13,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9bf2a3da-5fea-438d-a3fb-7eaa71b31f2e.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1670,
      ProductName: "CHIPOTLE TOWER",
      IsDeal: false,
      ProductDetailId: 2999,
      Price: 780,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHIPOTLE TOWER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\01632df6-9715-4a80-9dcd-038e496b9d6f.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1671,
      ProductName: "K2G SUPPER VALUE BURGER",
      IsDeal: false,
      ProductDetailId: 2997,
      Price: 330,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1672,
      ProductName: "KRISPY DELUX",
      IsDeal: false,
      ProductDetailId: 2990,
      Price: 610,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1673,
      ProductName: "KRUNCHY BITE BURGER",
      IsDeal: false,
      ProductDetailId: 2996,
      Price: 450,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1675,
      ProductName: "K2G SPICY",
      IsDeal: false,
      ProductDetailId: 2995,
      Price: 530,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1679,
      ProductName: "SIGNATURE CHIPOTLE WRAP STAR",
      IsDeal: false,
      ProductDetailId: 3003,
      Price: 380,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SIGNATURE CHIPOTLE WRAP STAR - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\d6b5137c-0f2b-4132-9833-af37af0219e3.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1681,
      ProductName: "SPICY TOWER",
      IsDeal: false,
      ProductDetailId: 3001,
      Price: 680,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SPICY TOWER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\b36731ea-3f1b-4de9-bc26-8cad0d5c6564.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 1682,
      ProductName: "WRAP STAR",
      IsDeal: false,
      ProductDetailId: 3002,
      Price: 370,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "WRAP STAR - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2288,
      ProductName: "KRISPY CHICKEN PIECES (1Pc)",
      IsDeal: false,
      ProductDetailId: 4257,
      Price: 220,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2292,
      ProductName: "REG. DRINK",
      IsDeal: false,
      ProductDetailId: 4264,
      Price: 80,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "REG. DRINK - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2292,
      ProductName: "REG. DRINK",
      IsDeal: false,
      ProductDetailId: 5283,
      Price: 80,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "REG. DRINK - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2322,
      ProductName: "1 LTR DRINK",
      IsDeal: false,
      ProductDetailId: 4304,
      Price: 150,
      SizeId: 556,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "N/A",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2500,
      ProductName: "KRISPY CHICKEN PIECE (2 Pc)",
      IsDeal: false,
      ProductDetailId: 4610,
      Price: 390,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2501,
      ProductName: "KRISPY CHICKEN PIECE (5Pcs)",
      IsDeal: false,
      ProductDetailId: 4611,
      Price: 950,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECE (5Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\77a25895-76bc-4745-a27a-ea23188498bc.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2502,
      ProductName: "KRISPY CHICKEN PIECE (8 Pcs)",
      IsDeal: false,
      ProductDetailId: 4612,
      Price: 1710,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY CHICKEN PIECE (8 Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\deabec62-fe2e-4603-8fdf-beb5900348c1.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2891,
      ProductName: "KRISPY CHICKEN PIECE (4 Pc)",
      IsDeal: false,
      ProductDetailId: 5242,
      Price: 730,
      SizeId: 580,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "KRISPY CHICKEN PIECE (4 Pc) - 4 Pcs - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "4 Pcs",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4203529d-a192-401f-95da-497b0194ecf6.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2892,
      ProductName: "Beef Premium",
      IsDeal: false,
      ProductDetailId: 5245,
      Price: 650,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Beef Premium - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c81c29da-bf0d-4e49-ba85-ec061fa3bf82.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 2894,
      ProductName: "Beef Classic",
      IsDeal: false,
      ProductDetailId: 5247,
      Price: 620,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Beef Classic - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e114e302-bc95-4974-b9ef-8ca3bc2f205d.png",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      CategoryImage: null,
      ProductId: 3032,
      ProductName: "CHEESIEST BURGER",
      IsDeal: false,
      ProductDetailId: 5441,
      Price: 620,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHEESIEST BURGER - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 9,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2294,
      ProductName: "BETTER 2 GETHER",
      IsDeal: true,
      ProductDetailId: 4293,
      Price: 1250,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BETTER 2 GETHER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cfd8b084-04ef-4fd1-a8a8-0249fc8fd2b1.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2295,
      ProductName: "BIG CHHICK",
      IsDeal: true,
      ProductDetailId: 4294,
      Price: 1299,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BIG CHHICK - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\23a78ecc-9387-4761-b334-3f04733c8cbb.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2296,
      ProductName: "BRAVO MEAL",
      IsDeal: true,
      ProductDetailId: 4292,
      Price: 770,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BRAVO MEAL - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\621cbe9e-0a5d-4683-921d-452ec6389ebe.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2297,
      ProductName: "KRISPY BITE 01",
      IsDeal: true,
      ProductDetailId: 4290,
      Price: 630,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY BITE 01 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cbfcda72-f9c9-47e7-85f3-2f89c9a4a408.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      CategoryImage: null,
      ProductId: 2298,
      ProductName: "KRISPY BITE 02",
      IsDeal: true,
      ProductDetailId: 4291,
      Price: 880,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY BITE 02 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c2850a30-cecb-4aad-ab82-8eacd6d3db69.jpg",
      SortOrder: 16,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2299,
      ProductName: "FAMILY O' CLOCK  01",
      IsDeal: true,
      ProductDetailId: 4295,
      Price: 1775,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "FAMILY O' CLOCK  01 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9f124b1d-f1b9-45bd-a9d5-fd87fdf31a76.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2300,
      ProductName: "FAMILY O' CLOCK  02",
      IsDeal: true,
      ProductDetailId: 4296,
      Price: 1999,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "FAMILY O' CLOCK  02 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1d0caafd-93f4-4549-9dd5-35bf8e043fad.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2301,
      ProductName: "K2G SIGNATURE CLUB",
      IsDeal: true,
      ProductDetailId: 4298,
      Price: 1650,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "K2G SIGNATURE CLUB - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\60661f0d-d9bc-4750-9900-61efe5412c5d.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      CategoryImage: null,
      ProductId: 2302,
      ProductName: "KRISPY TREAT",
      IsDeal: true,
      ProductDetailId: 4297,
      Price: 1750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRISPY TREAT - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e195780c-d9d8-4464-a52a-9cef153f4e11.jpg",
      SortOrder: 17,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 594,
      CategoryName: "FRIES",
      CategoryImage: null,
      ProductId: 2140,
      ProductName: "Fries",
      IsDeal: false,
      ProductDetailId: 5249,
      Price: 180,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Fries - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
      SortOrder: 10,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      CategoryImage: null,
      ProductId: 2304,
      ProductName: "KIDDY MEAL 1",
      IsDeal: true,
      ProductDetailId: 4282,
      Price: 350,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KIDDY MEAL 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\90232f41-619c-45bb-a6d6-0700bf5ad0dc.jpg",
      SortOrder: 13,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      CategoryImage: null,
      ProductId: 2305,
      ProductName: "KIDDY MEAL 2",
      IsDeal: true,
      ProductDetailId: 4283,
      Price: 350,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KIDDY MEAL 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\793ad154-991c-45b6-a581-d6e84c02eb2c.jpg",
      SortOrder: 13,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      CategoryImage: null,
      ProductId: 2306,
      ProductName: "KIDDY MEAL 3",
      IsDeal: true,
      ProductDetailId: 4284,
      Price: 350,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KIDDY MEAL 3 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bd4a3185-3765-4a64-9310-e0e39358cc02.jpg",
      SortOrder: 13,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2308,
      ProductName: "MIDNIGHT MADNESS",
      IsDeal: true,
      ProductDetailId: 4285,
      Price: 490,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "MIDNIGHT MADNESS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f38b6014-a906-4b7d-926f-31fbe2928a1a.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2507,
      ProductName: "11.11 Krunchi Deal",
      IsDeal: true,
      ProductDetailId: 4619,
      Price: 444,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "11.11 Krunchi Deal - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\d567e546-6b68-46aa-9616-58cdf262972b.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2508,
      ProductName: "Bogo Delux",
      IsDeal: true,
      ProductDetailId: 4620,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Bogo Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f35539c5-3b76-49ae-bc72-5397d444a583.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2514,
      ProductName: "BIN SAFEER BOGO BUY 2 GET 1 CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4573,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName:
        "BIN SAFEER BOGO BUY 2 GET 1 CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\05548b5a-813f-46cb-bfbb-e13510f9206d.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2515,
      ProductName: "BIN SAFEER BOGO DELUX",
      IsDeal: true,
      ProductDetailId: 4572,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BIN SAFEER BOGO DELUX - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\52a5950c-7a38-4e58-b1f5-f1cbfa5364aa.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2519,
      ProductName: "DIAMOND BUY 2 GET 1 CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4577,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DIAMOND BUY 2 GET 1 CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c31a8bb4-47b6-41f0-96a4-c04ff032ab56.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2522,
      ProductName: "IMTIAZ BUY 2 GET 1 CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4582,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "IMTIAZ BUY 2 GET 1 CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c6fc8e64-9f2a-4d16-afb9-52cdcb5d2f8d.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2523,
      ProductName: "J. BOGO K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4584,
      Price: 590,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "J. BOGO K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\ff221c69-7ae1-4447-bb5c-362848755765.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2524,
      ProductName: "J. BOGO Buy 2 Get 1 Chicken Burger",
      IsDeal: true,
      ProductDetailId: 4583,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "J. BOGO Buy 2 Get 1 Chicken Burger - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a51d8221-f518-4ed5-bbc6-57239c6d2bba.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2525,
      ProductName: "F.P MIDNIGHT DEAL 1",
      IsDeal: true,
      ProductDetailId: 4578,
      Price: 390,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "F.P MIDNIGHT DEAL 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1d4c18cc-bfb7-4748-8fd9-0f3a7beb56af.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2526,
      ProductName: "F.P MID NIGHT DEAL 2",
      IsDeal: true,
      ProductDetailId: 4579,
      Price: 350,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "F.P MID NIGHT DEAL 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f026acb0-f8bb-49fd-81ef-7756292f7157.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2563,
      ProductName: "Imtiaz Bogo Delux",
      IsDeal: true,
      ProductDetailId: 4646,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Imtiaz Bogo Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c1195b30-76ef-47fc-986f-c3ef6f13f62d.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2564,
      ProductName: "Imtiaz Bogo K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4647,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Imtiaz Bogo K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\df45da58-f101-43b4-a6fa-ab33061beb03.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2566,
      ProductName: "Al Jadeed BOGO Delux",
      IsDeal: true,
      ProductDetailId: 4649,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Al Jadeed BOGO Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\057910fd-70d6-4c95-9321-878600a19fe4.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2567,
      ProductName: "Al Jadeed Bogo K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4650,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Al Jadeed Bogo K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\634aa9b7-59b9-4d50-8b35-b6dfd439ac32.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2568,
      ProductName: "Al Jadeed BOGO Buy 2 Get 1",
      IsDeal: true,
      ProductDetailId: 4651,
      Price: 600,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Al Jadeed BOGO Buy 2 Get 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\873588af-423d-4f8c-a428-b009d924b971.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2569,
      ProductName: "J. BOGO DELUX",
      IsDeal: true,
      ProductDetailId: 4652,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "J. BOGO DELUX - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9e5e8ced-b86b-4fbd-a041-f7605f1d8c88.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2570,
      ProductName: "Diamond BOGO Delux",
      IsDeal: true,
      ProductDetailId: 4653,
      Price: 660,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Diamond BOGO Delux - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\de21e0ef-7108-4ecb-862d-677b28e0a2c7.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2571,
      ProductName: "Diamond Bogo K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4654,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Diamond Bogo K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\ae1c0c81-0a13-41cf-b8f4-7ea45a823cf0.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2734,
      ProductName: "KRUNCHY WINTER",
      IsDeal: true,
      ProductDetailId: 5068,
      Price: 1199,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "KRUNCHY WINTER - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\ad2a70de-53b3-4ec4-bbc9-421a4b9a6d66.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 2918,
      ProductName: "SPICY TOWER COMBO F.P",
      IsDeal: true,
      ProductDetailId: 5279,
      Price: 816,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SPICY TOWER COMBO F.P - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3036,
      ProductName: "F.P 2 SANDWICH",
      IsDeal: true,
      ProductDetailId: 5466,
      Price: 999,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "F.P 2 SANDWICH - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\40a648f8-f526-4fc5-85bf-cfa0438e3248.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3365,
      ProductName: "TREAT BOX 1",
      IsDeal: true,
      ProductDetailId: 5795,
      Price: 1190,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TREAT BOX 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\2a8a4fee-b35b-4b77-b8d1-11b79383fa27.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3366,
      ProductName: "TREAT BOX 2",
      IsDeal: true,
      ProductDetailId: 5796,
      Price: 1190,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TREAT BOX 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\29264375-e0af-4aac-956d-e5347469cedd.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 3367,
      ProductName: "TREAT BOX 3",
      IsDeal: true,
      ProductDetailId: 5797,
      Price: 1190,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TREAT BOX 3 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\399ea030-b6c8-4f9c-93c9-296abeee42c6.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 4062,
      ProductName: "YEAR END DEAL",
      IsDeal: true,
      ProductDetailId: 6492,
      Price: 1200,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "YEAR END DEAL - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\27fea0be-41f6-4530-8803-9a3b95477b56.jpeg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      CategoryImage: null,
      ProductId: 4641,
      ProductName: "Buy 2 get 1 free Imtiaz chipotle wrap star",
      IsDeal: true,
      ProductDetailId: 7059,
      Price: 799,
      SizeId: 556,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName:
        "Buy 2 get 1 free Imtiaz chipotle wrap star - N/A - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "N/A",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4f455281-ec4f-4677-8527-27bc11da004f.jpg",
      SortOrder: 14,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2138,
      ProductName: "DINNER ROLL",
      IsDeal: false,
      ProductDetailId: 4614,
      Price: 30,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DINNER ROLL - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\6a0a130e-0db1-4f37-b011-3113be47ccfb.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2287,
      ProductName: "CHEESE (Slice)",
      IsDeal: false,
      ProductDetailId: 4262,
      Price: 50,
      SizeId: 572,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "CHEESE (Slice) - 1 PC - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "1 PC",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1a6ab6c9-18cb-427a-bbb4-ab4d9f69195c.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2290,
      ProductName: "Krispy Pop Corn (10 PCS)",
      IsDeal: false,
      ProductDetailId: 4260,
      Price: 450,
      SizeId: 573,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Krispy Pop Corn (10 PCS) - 10 PCS - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "10 PCS",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5173e4cd-15c4-4f9f-9f92-5e00365dba9f.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2290,
      ProductName: "Krispy Pop Corn (10 PCS)",
      IsDeal: false,
      ProductDetailId: 4638,
      Price: 450,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Krispy Pop Corn (10 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5173e4cd-15c4-4f9f-9f92-5e00365dba9f.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2291,
      ProductName: "MINERAL WATER",
      IsDeal: false,
      ProductDetailId: 4266,
      Price: 100,
      SizeId: 576,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "MINERAL WATER - L - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "L",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\146d547f-b95f-4667-a527-471826411812.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2293,
      ProductName: "Bucket Fries",
      IsDeal: false,
      ProductDetailId: 4261,
      Price: 300,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Bucket Fries - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: "null",
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2303,
      ProductName: "LOADED FRIES Regular",
      IsDeal: false,
      ProductDetailId: 4267,
      Price: 290,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2309,
      ProductName: "BROWNIE",
      IsDeal: false,
      ProductDetailId: 4275,
      Price: 200,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BROWNIE - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a8b7eca7-f01f-433e-bf22-4f96aae7ec93.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4276,
      Price: 60,
      SizeId: 489,
      FlavourId: 291,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "CHIPOTLE",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4277,
      Price: 60,
      SizeId: 489,
      FlavourId: 292,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "GARLIC MAYO",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4278,
      Price: 60,
      SizeId: 489,
      FlavourId: 300,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "SPICY MAYO",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4279,
      Price: 60,
      SizeId: 489,
      FlavourId: 293,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "HOT & SPICY",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4280,
      Price: 60,
      SizeId: 489,
      FlavourId: 295,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "PERY PERY",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2310,
      ProductName: "DIP N DIP",
      IsDeal: false,
      ProductDetailId: 4281,
      Price: 60,
      SizeId: 489,
      FlavourId: 294,
      OnlyForDeal: false,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "LEMON & HERBS",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2503,
      ProductName: "LOADED FRIES (Large)",
      IsDeal: false,
      ProductDetailId: 4615,
      Price: 390,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "LOADED FRIES (Large) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a0f5820d-2fed-4910-85cf-461ec32da8e3.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2552,
      ProductName: "Add on Fries & Drink",
      IsDeal: true,
      ProductDetailId: 4613,
      Price: 180,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Add on Fries & Drink - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\2c702b1a-f424-48c4-8cf0-90d530a7ec16.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2554,
      ProductName: "Nuggets(5)",
      IsDeal: true,
      ProductDetailId: 4636,
      Price: 330,
      SizeId: 489,
      FlavourId: 294,
      OnlyForDeal: false,
      ProductDetailName: "Nuggets(5) - STD - LEMON & HERBS",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "LEMON & HERBS",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\0391e1c8-95f6-4ab7-9bab-604f557b6390.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2555,
      ProductName: "Nuggets (10)",
      IsDeal: true,
      ProductDetailId: 4637,
      Price: 450,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Nuggets (10) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cce6f7f3-bb78-4a76-9725-8baf2d0291f2.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2557,
      ProductName: "6 Pcs Hot Wing",
      IsDeal: true,
      ProductDetailId: 4641,
      Price: 390,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "6 Pcs Hot Wing - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\35da117f-2926-4513-9371-afbafb371299.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2558,
      ProductName: "5 Hot Wing (Pcs)",
      IsDeal: false,
      ProductDetailId: 4640,
      Price: 310,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "5 Hot Wing (Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cc900ecd-4f5d-460a-8268-06c2394f0fe8.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2559,
      ProductName: "Nuggets (4 Pcs)",
      IsDeal: false,
      ProductDetailId: 4642,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Nuggets (4 Pcs) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\02faf991-9267-41de-ae7f-d8ebf89b5c6f.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2560,
      ProductName: "Chicken Strips (4 PCS)",
      IsDeal: false,
      ProductDetailId: 4643,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Chicken Strips (4 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4c40ce12-d58e-484c-afb1-8d6e2c7e5a36.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2561,
      ProductName: "Krispy Popper (7 PCS)",
      IsDeal: false,
      ProductDetailId: 4644,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Krispy Popper (7 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\3250bce7-9d7c-4e02-bd9e-a915598b4d86.jpg",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 2562,
      ProductName: "CHICKEN PIECE (4 PCS)",
      IsDeal: false,
      ProductDetailId: 4645,
      Price: 1,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "CHICKEN PIECE (4 PCS) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a9e8b996-4fab-4508-9f44-cc2b5d2b488f.png",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 4316,
      ProductName: "Nuggets",
      IsDeal: false,
      ProductDetailId: 6716,
      Price: 0,
      SizeId: 572,
      FlavourId: 286,
      OnlyForDeal: true,
      ProductDetailName: "Nuggets - 1 PC - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "1 PC",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 598,
      CategoryName: "SNACKS",
      CategoryImage: null,
      ProductId: 4468,
      ProductName: "MINERAL WATER - SMALL",
      IsDeal: false,
      ProductDetailId: 4265,
      Price: 50,
      SizeId: 579,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "MINERAL WATER - SMALL - S - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "S",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 12,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 599,
      CategoryName: "COMBO MEALS",
      CategoryImage: null,
      ProductId: 2314,
      ProductName: "TWIN DEAL 1",
      IsDeal: true,
      ProductDetailId: 4269,
      Price: 690,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TWIN DEAL 1 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\753a9071-e7c8-4cae-a28a-4c46bea60ebe.jpg",
      SortOrder: 11,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 599,
      CategoryName: "COMBO MEALS",
      CategoryImage: null,
      ProductId: 2315,
      ProductName: "TWIN DEAL 2",
      IsDeal: true,
      ProductDetailId: 4270,
      Price: 790,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "TWIN DEAL 2 - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\7d30ec8a-bf45-40e0-8ad3-494ee6e3c257.jpg",
      SortOrder: 11,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2512,
      ProductName: "2 KRISPY CHICKEN BURGER (FP)",
      IsDeal: true,
      ProductDetailId: 4571,
      Price: 500,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "2 KRISPY CHICKEN BURGER (FP) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\35e94749-19c8-46e5-84c2-f7c40c4f10ad.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2513,
      ProductName: "2 WRAPSTAR (FP)",
      IsDeal: true,
      ProductDetailId: 4570,
      Price: 520,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "2 WRAPSTAR (FP) - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f4989730-cf39-4a20-81d6-02267360a2bd.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2518,
      ProductName: "BOGO K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4576,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "BOGO K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\68bac92b-f245-41eb-b457-134fd7a23ce2.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2520,
      ProductName: "GOLOTLO 2 K2G SPICY",
      IsDeal: true,
      ProductDetailId: 4580,
      Price: 540,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "GOLOTLO 2 K2G SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\b6dd458c-79a8-4514-b74a-fee99bd72b07.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2521,
      ProductName: "GOLOTLO 2 WRAPSTAR",
      IsDeal: true,
      ProductDetailId: 4581,
      Price: 400,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "GOLOTLO 2 WRAPSTAR - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\55cc9d78-5378-4eeb-a7cb-36db9509c2e4.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2527,
      ProductName: "VOUCH 365 BOGO CHICKEN BURGER",
      IsDeal: true,
      ProductDetailId: 4585,
      Price: 310,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "VOUCH 365 BOGO CHICKEN BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\02acf779-6eda-484e-83f8-f1553a1b474f.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      CategoryImage: null,
      ProductId: 2528,
      ProductName: "VOUCH 365 BOGO SPICY",
      IsDeal: true,
      ProductDetailId: 4586,
      Price: 575,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "VOUCH 365 BOGO SPICY - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9aa62b7a-9a31-416f-9bdd-c92db56b909e.jpg",
      SortOrder: 18,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2529,
      ProductName: "10 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4606,
      Price: 1900,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "10 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bd9153e4-8c81-4927-a1a2-bd8b15d8a4f0.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2530,
      ProductName: "10 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4602,
      Price: 3100,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "10 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\9858270c-5e50-466a-8f58-48f213b5d9e6.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2531,
      ProductName: "10 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4594,
      Price: 2100,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "10 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\15169f5e-b0e8-46fc-a880-f866da27c5ef.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2532,
      ProductName: "15 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4607,
      Price: 2850,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\1c5cc0d9-4bbf-403a-9d3d-de4bd30095a8.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2533,
      ProductName: "15 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4598,
      Price: 2250,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\bd61e555-315b-40f7-9a0d-a28fc37b2a1e.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2534,
      ProductName: "15 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4603,
      Price: 4050,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\f27a7f8a-5abc-4b9f-9f9f-7e46e1b15861.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2535,
      ProductName: "15 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4595,
      Price: 3150,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "15 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\5c7595a3-cb6d-4104-8aa7-1a92e7d7acbe.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2536,
      ProductName: "20 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4608,
      Price: 2800,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4267afc7-3da9-4104-b5de-8ff53bbe5792.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2537,
      ProductName: "20 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4599,
      Price: 3000,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\25f8fefc-6b25-481b-a786-037e134aafeb.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2538,
      ProductName: "20 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4604,
      Price: 6200,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\b1bd46e6-d0fd-4979-a7dd-8042683fa7c1.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2539,
      ProductName: "20 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4596,
      Price: 4200,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "20 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\cb0f3ea0-05a2-466e-817b-1dcc95c851b0.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2540,
      ProductName: "25 KRISPY CHICKEN BURGERS",
      IsDeal: true,
      ProductDetailId: 4609,
      Price: 4750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 KRISPY CHICKEN BURGERS - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\eb249cb6-fa05-4b85-a5d1-75d98d497011.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2541,
      ProductName: "25 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4600,
      Price: 3750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\4aa4816f-3587-4489-bd65-02d01eb931bc.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2542,
      ProductName: "25 KRUNCHI BITE BURGER",
      IsDeal: true,
      ProductDetailId: 4605,
      Price: 7750,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 KRUNCHI BITE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\e0035017-f71c-4df2-a1e5-9582bd0e0ce4.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2543,
      ProductName: "25 SUPPER VALUE BURGER",
      IsDeal: true,
      ProductDetailId: 4597,
      Price: 5250,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "25 SUPPER VALUE BURGER - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\8a5bf4fb-9142-43f0-a78a-eb1888980555.jpg",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      CategoryImage: null,
      ProductId: 2544,
      ProductName: "30 KRISPY CHICKEN PIECES",
      IsDeal: true,
      ProductDetailId: 4601,
      Price: 4500,
      SizeId: 489,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "30 KRISPY CHICKEN PIECES - STD - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "STD",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\a0037f40-37e8-4def-a66c-128d2b36d44a.png",
      SortOrder: 20,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 700,
      CategoryName: "SANDWICH",
      CategoryImage: "",
      ProductId: 2840,
      ProductName: "Tikka Sandwich",
      IsDeal: false,
      ProductDetailId: 5189,
      Price: 520,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Tikka Sandwich - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\3ccdb2ce-c530-4ef1-9ba1-12d421fe2635.jpg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 700,
      CategoryName: "SANDWICH",
      CategoryImage: "",
      ProductId: 2841,
      ProductName: "Malai Boti Sandwich",
      IsDeal: false,
      ProductDetailId: 5190,
      Price: 520,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "Malai Boti Sandwich - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "\\ProductImages\\c0e6e063-d034-4ca3-9ac4-cf6784c90041.jpg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 700,
      CategoryName: "SANDWICH",
      CategoryImage: "",
      ProductId: 3035,
      ProductName: "SANDWICH TREAT BOX",
      IsDeal: true,
      ProductDetailId: 5465,
      Price: 1200,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "SANDWICH TREAT BOX - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2882,
      ProductName: "COMBO 1",
      IsDeal: true,
      ProductDetailId: 5232,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 1 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\3eda2354-3482-4768-b47a-07871e0d0521.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2883,
      ProductName: "COMBO 2",
      IsDeal: true,
      ProductDetailId: 5233,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 2 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\8e28b63f-991f-4e76-8a40-9c2873adc36b.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2884,
      ProductName: "COMBO 3",
      IsDeal: true,
      ProductDetailId: 5234,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 3 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\32e9518d-1890-4f09-ad23-3b79c68f2f32.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2885,
      ProductName: "COMBO 4",
      IsDeal: true,
      ProductDetailId: 5235,
      Price: 390,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 4 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\00f73ae8-49da-458f-8589-6a026c20262e.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 702,
      CategoryName: "Super Saver",
      CategoryImage: "",
      ProductId: 2886,
      ProductName: "COMBO 5",
      IsDeal: true,
      ProductDetailId: 5236,
      Price: 390,
      SizeId: 557,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "COMBO 5 - PCS - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "PCS",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage:
        "\\ProductImages\\d3b1331e-ea6e-4d88-a958-3f69328033c2.jpeg",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      CategoryImage: "",
      ProductId: 2888,
      ProductName: "DC 80",
      IsDeal: true,
      ProductDetailId: 5237,
      Price: 80,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DC 80 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: true,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      CategoryImage: "",
      ProductId: 2889,
      ProductName: "DC 100",
      IsDeal: false,
      ProductDetailId: 5238,
      Price: 100,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DC 100 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },
    {
      DepartmentId: 209,
      DepartmentName: "KITCHEN",
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      CategoryImage: "",
      ProductId: 2890,
      ProductName: "DC 120",
      IsDeal: false,
      ProductDetailId: 5239,
      Price: 120,
      SizeId: 578,
      FlavourId: 286,
      OnlyForDeal: false,
      ProductDetailName: "DC 120 - REG - N/A",
      BranchId: 167,
      TaxPercent: 0,
      SizeName: "REG",
      FlavourName: "N/A",
      ProductCode: null,
      GSTPercentage: 0,
      IsTopping: false,
      ValidFrom: null,
      ValidTo: null,
      ProductDetailPropertyId: null,
      ProductDetailPropertyPrice: null,
      ProductDetailPropertyName: null,
      ProductImage: "",
      SortOrder: 0,
      ProductDetailPropertyCount: "1",
      ProductPropertyId: null,
      ProductDescription: null,
      IsDealDirectPunch: false,
      orderSourceId: 363,
    },

    ///////////////////////////////////////
  ],
  CategoryList: [
    {
      CategoryId: 700,
      CategoryName: "SANDWICH",
      SortOrder: 0,
      CategoryImage: "",
    },
    {
      CategoryId: 702,
      CategoryName: "Super Saver",
      SortOrder: 0,
      CategoryImage: "",
    },
    {
      CategoryId: 703,
      CategoryName: "Delivery Charges",
      SortOrder: 0,
      CategoryImage: "",
    },
    {
      CategoryId: 591,
      CategoryName: "ALA CARTE.",
      SortOrder: 9,
      CategoryImage: null,
    },
    {
      CategoryId: 594,
      CategoryName: "FRIES",
      SortOrder: 10,
      CategoryImage: null,
    },
    {
      CategoryId: 599,
      CategoryName: "COMBO MEALS",
      SortOrder: 11,
      CategoryImage: null,
    },
    {
      CategoryId: 598,
      CategoryName: "SNACKS",
      SortOrder: 12,
      CategoryImage: null,
    },
    {
      CategoryId: 595,
      CategoryName: "KIDDY MEALS",
      SortOrder: 13,
      CategoryImage: null,
    },
    {
      CategoryId: 597,
      CategoryName: "PROMOTIONS",
      SortOrder: 14,
      CategoryImage: null,
    },
    {
      CategoryId: 592,
      CategoryName: "CHICKEN DELIGHT",
      SortOrder: 16,
      CategoryImage: null,
    },
    {
      CategoryId: 593,
      CategoryName: "FAMILY DEALS",
      SortOrder: 17,
      CategoryImage: null,
    },
    {
      CategoryId: 642,
      CategoryName: "ALLIANCE",
      SortOrder: 18,
      CategoryImage: null,
    },
    {
      CategoryId: 643,
      CategoryName: "BULK DEAL",
      SortOrder: 20,
      CategoryImage: null,
    },
  ],
  ProductList: [
    {
      ProductId: 1668,
      ProductName: "CHICKEN BURGER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
      ProductPrice: 290,
      ProductDescription: "null",
    },
    {
      ProductId: 1669,
      ProductName: "CHIPOTLE BURGER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\9bf2a3da-5fea-438d-a3fb-7eaa71b31f2e.jpg",
      ProductPrice: 666,
      ProductDescription: null,
    },
    {
      ProductId: 1670,
      ProductName: "CHIPOTLE TOWER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\01632df6-9715-4a80-9dcd-038e496b9d6f.jpg",
      ProductPrice: 780,
      ProductDescription: null,
    },
    {
      ProductId: 1671,
      ProductName: "K2G SUPPER VALUE BURGER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
      ProductPrice: 330,
      ProductDescription: "null",
    },
    {
      ProductId: 1672,
      ProductName: "KRISPY DELUX",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
      ProductPrice: 610,
      ProductDescription: null,
    },
    {
      ProductId: 1673,
      ProductName: "KRUNCHY BITE BURGER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
      ProductPrice: 450,
      ProductDescription: null,
    },
    {
      ProductId: 1675,
      ProductName: "K2G SPICY",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
      ProductPrice: 530,
      ProductDescription: null,
    },
    {
      ProductId: 1679,
      ProductName: "SIGNATURE CHIPOTLE WRAP STAR",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\d6b5137c-0f2b-4132-9833-af37af0219e3.jpg",
      ProductPrice: 380,
      ProductDescription: null,
    },
    {
      ProductId: 1681,
      ProductName: "SPICY TOWER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\b36731ea-3f1b-4de9-bc26-8cad0d5c6564.jpg",
      ProductPrice: 680,
      ProductDescription: null,
    },
    {
      ProductId: 1682,
      ProductName: "WRAP STAR",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
      ProductPrice: 370,
      ProductDescription: null,
    },
    {
      ProductId: 2138,
      ProductName: "DINNER ROLL",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\6a0a130e-0db1-4f37-b011-3113be47ccfb.png",
      ProductPrice: 30,
      ProductDescription: null,
    },
    {
      ProductId: 2140,
      ProductName: "Fries",
      CategoryId: 594,
      IsDeal: false,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
      ProductPrice: 180,
      ProductDescription: "null",
    },
    {
      ProductId: 2287,
      ProductName: "CHEESE (Slice)",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\1a6ab6c9-18cb-427a-bbb4-ab4d9f69195c.jpg",
      ProductPrice: 50,
      ProductDescription: null,
    },
    {
      ProductId: 2288,
      ProductName: "KRISPY CHICKEN PIECES (1Pc)",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
      ProductPrice: 220,
      ProductDescription: null,
    },
    {
      ProductId: 2290,
      ProductName: "Krispy Pop Corn (10 PCS)",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\5173e4cd-15c4-4f9f-9f92-5e00365dba9f.jpg",
      ProductPrice: 450,
      ProductDescription: null,
    },
    {
      ProductId: 2291,
      ProductName: "MINERAL WATER",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\146d547f-b95f-4667-a527-471826411812.jpg",
      ProductPrice: 50,
      ProductDescription: null,
    },
    {
      ProductId: 2292,
      ProductName: "REG. DRINK",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
      ProductPrice: 80,
      ProductDescription: null,
    },
    {
      ProductId: 2293,
      ProductName: "Bucket Fries",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
      ProductPrice: 300,
      ProductDescription: "null",
    },
    {
      ProductId: 2294,
      ProductName: "BETTER 2 GETHER",
      CategoryId: 592,
      IsDeal: true,
      ProductImage: "\\ProductImages\\cfd8b084-04ef-4fd1-a8a8-0249fc8fd2b1.jpg",
      ProductPrice: 1250,
      ProductDescription: null,
    },
    {
      ProductId: 2295,
      ProductName: "BIG CHHICK",
      CategoryId: 592,
      IsDeal: true,
      ProductImage: "\\ProductImages\\23a78ecc-9387-4761-b334-3f04733c8cbb.jpg",
      ProductPrice: 1299,
      ProductDescription: null,
    },
    {
      ProductId: 2296,
      ProductName: "BRAVO MEAL",
      CategoryId: 592,
      IsDeal: true,
      ProductImage: "\\ProductImages\\621cbe9e-0a5d-4683-921d-452ec6389ebe.jpg",
      ProductPrice: 770,
      ProductDescription: null,
    },
    {
      ProductId: 2297,
      ProductName: "KRISPY BITE 01",
      CategoryId: 592,
      IsDeal: true,
      ProductImage: "\\ProductImages\\cbfcda72-f9c9-47e7-85f3-2f89c9a4a408.jpg",
      ProductPrice: 630,
      ProductDescription: null,
    },
    {
      ProductId: 2298,
      ProductName: "KRISPY BITE 02",
      CategoryId: 592,
      IsDeal: true,
      ProductImage: "\\ProductImages\\c2850a30-cecb-4aad-ab82-8eacd6d3db69.jpg",
      ProductPrice: 880,
      ProductDescription: null,
    },
    {
      ProductId: 2299,
      ProductName: "FAMILY O' CLOCK  01",
      CategoryId: 593,
      IsDeal: true,
      ProductImage: "\\ProductImages\\9f124b1d-f1b9-45bd-a9d5-fd87fdf31a76.jpg",
      ProductPrice: 1775,
      ProductDescription: null,
    },
    {
      ProductId: 2300,
      ProductName: "FAMILY O' CLOCK  02",
      CategoryId: 593,
      IsDeal: true,
      ProductImage: "\\ProductImages\\1d0caafd-93f4-4549-9dd5-35bf8e043fad.jpg",
      ProductPrice: 1999,
      ProductDescription: null,
    },
    {
      ProductId: 2301,
      ProductName: "K2G SIGNATURE CLUB",
      CategoryId: 593,
      IsDeal: true,
      ProductImage: "\\ProductImages\\60661f0d-d9bc-4750-9900-61efe5412c5d.jpg",
      ProductPrice: 1650,
      ProductDescription: null,
    },
    {
      ProductId: 2302,
      ProductName: "KRISPY TREAT",
      CategoryId: 593,
      IsDeal: true,
      ProductImage: "\\ProductImages\\e195780c-d9d8-4464-a52a-9cef153f4e11.jpg",
      ProductPrice: 1750,
      ProductDescription: null,
    },
    {
      ProductId: 2303,
      ProductName: "LOADED FRIES Regular",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
      ProductPrice: 290,
      ProductDescription: null,
    },
    {
      ProductId: 2304,
      ProductName: "KIDDY MEAL 1",
      CategoryId: 595,
      IsDeal: true,
      ProductImage: "\\ProductImages\\90232f41-619c-45bb-a6d6-0700bf5ad0dc.jpg",
      ProductPrice: 350,
      ProductDescription: null,
    },
    {
      ProductId: 2305,
      ProductName: "KIDDY MEAL 2",
      CategoryId: 595,
      IsDeal: true,
      ProductImage: "\\ProductImages\\793ad154-991c-45b6-a581-d6e84c02eb2c.jpg",
      ProductPrice: 350,
      ProductDescription: null,
    },
    {
      ProductId: 2306,
      ProductName: "KIDDY MEAL 3",
      CategoryId: 595,
      IsDeal: true,
      ProductImage: "\\ProductImages\\bd4a3185-3765-4a64-9310-e0e39358cc02.jpg",
      ProductPrice: 350,
      ProductDescription: null,
    },
    {
      ProductId: 2308,
      ProductName: "MIDNIGHT MADNESS",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\f38b6014-a906-4b7d-926f-31fbe2928a1a.jpg",
      ProductPrice: 490,
      ProductDescription: null,
    },
    {
      ProductId: 2309,
      ProductName: "BROWNIE",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\a8b7eca7-f01f-433e-bf22-4f96aae7ec93.jpg",
      ProductPrice: 200,
      ProductDescription: null,
    },
    {
      ProductId: 2310,
      ProductName: "DIP N DIP",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
      ProductPrice: 60,
      ProductDescription: null,
    },
    {
      ProductId: 2314,
      ProductName: "TWIN DEAL 1",
      CategoryId: 599,
      IsDeal: true,
      ProductImage: "\\ProductImages\\753a9071-e7c8-4cae-a28a-4c46bea60ebe.jpg",
      ProductPrice: 690,
      ProductDescription: null,
    },
    {
      ProductId: 2315,
      ProductName: "TWIN DEAL 2",
      CategoryId: 599,
      IsDeal: true,
      ProductImage: "\\ProductImages\\7d30ec8a-bf45-40e0-8ad3-494ee6e3c257.jpg",
      ProductPrice: 790,
      ProductDescription: null,
    },
    {
      ProductId: 2322,
      ProductName: "1 LTR DRINK",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
      ProductPrice: 150,
      ProductDescription: null,
    },
    {
      ProductId: 2500,
      ProductName: "KRISPY CHICKEN PIECE (2 Pc)",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2501,
      ProductName: "KRISPY CHICKEN PIECE (5Pcs)",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\77a25895-76bc-4745-a27a-ea23188498bc.png",
      ProductPrice: 950,
      ProductDescription: null,
    },
    {
      ProductId: 2502,
      ProductName: "KRISPY CHICKEN PIECE (8 Pcs)",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\deabec62-fe2e-4603-8fdf-beb5900348c1.png",
      ProductPrice: 1710,
      ProductDescription: null,
    },
    {
      ProductId: 2503,
      ProductName: "LOADED FRIES (Large)",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "\\ProductImages\\a0f5820d-2fed-4910-85cf-461ec32da8e3.jpg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2507,
      ProductName: "11.11 Krunchi Deal",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\d567e546-6b68-46aa-9616-58cdf262972b.jpg",
      ProductPrice: 444,
      ProductDescription: null,
    },
    {
      ProductId: 2508,
      ProductName: "Bogo Delux",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\f35539c5-3b76-49ae-bc72-5397d444a583.jpg",
      ProductPrice: 660,
      ProductDescription: null,
    },
    {
      ProductId: 2512,
      ProductName: "2 KRISPY CHICKEN BURGER (FP)",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\35e94749-19c8-46e5-84c2-f7c40c4f10ad.jpg",
      ProductPrice: 500,
      ProductDescription: null,
    },
    {
      ProductId: 2513,
      ProductName: "2 WRAPSTAR (FP)",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\f4989730-cf39-4a20-81d6-02267360a2bd.jpg",
      ProductPrice: 520,
      ProductDescription: null,
    },
    {
      ProductId: 2514,
      ProductName: "BIN SAFEER BOGO BUY 2 GET 1 CHICKEN BURGER",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\05548b5a-813f-46cb-bfbb-e13510f9206d.jpg",
      ProductPrice: 600,
      ProductDescription: null,
    },
    {
      ProductId: 2515,
      ProductName: "BIN SAFEER BOGO DELUX",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\52a5950c-7a38-4e58-b1f5-f1cbfa5364aa.jpg",
      ProductPrice: 660,
      ProductDescription: null,
    },
    {
      ProductId: 2518,
      ProductName: "BOGO K2G SPICY",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\68bac92b-f245-41eb-b457-134fd7a23ce2.jpg",
      ProductPrice: 575,
      ProductDescription: null,
    },
    {
      ProductId: 2519,
      ProductName: "DIAMOND BUY 2 GET 1 CHICKEN BURGER",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\c31a8bb4-47b6-41f0-96a4-c04ff032ab56.jpg",
      ProductPrice: 600,
      ProductDescription: null,
    },
    {
      ProductId: 2520,
      ProductName: "GOLOTLO 2 K2G SPICY",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\b6dd458c-79a8-4514-b74a-fee99bd72b07.jpg",
      ProductPrice: 540,
      ProductDescription: null,
    },
    {
      ProductId: 2521,
      ProductName: "GOLOTLO 2 WRAPSTAR",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\55cc9d78-5378-4eeb-a7cb-36db9509c2e4.jpg",
      ProductPrice: 400,
      ProductDescription: null,
    },
    {
      ProductId: 2522,
      ProductName: "IMTIAZ BUY 2 GET 1 CHICKEN BURGER",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\c6fc8e64-9f2a-4d16-afb9-52cdcb5d2f8d.jpg",
      ProductPrice: 600,
      ProductDescription: null,
    },
    {
      ProductId: 2523,
      ProductName: "J. BOGO K2G SPICY",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\ff221c69-7ae1-4447-bb5c-362848755765.jpg",
      ProductPrice: 590,
      ProductDescription: null,
    },
    {
      ProductId: 2524,
      ProductName: "J. BOGO Buy 2 Get 1 Chicken Burger",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\a51d8221-f518-4ed5-bbc6-57239c6d2bba.jpg",
      ProductPrice: 600,
      ProductDescription: null,
    },
    {
      ProductId: 2525,
      ProductName: "F.P MIDNIGHT DEAL 1",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\1d4c18cc-bfb7-4748-8fd9-0f3a7beb56af.jpg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2526,
      ProductName: "F.P MID NIGHT DEAL 2",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\f026acb0-f8bb-49fd-81ef-7756292f7157.jpg",
      ProductPrice: 350,
      ProductDescription: null,
    },
    {
      ProductId: 2527,
      ProductName: "VOUCH 365 BOGO CHICKEN BURGER",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\02acf779-6eda-484e-83f8-f1553a1b474f.jpg",
      ProductPrice: 310,
      ProductDescription: null,
    },
    {
      ProductId: 2528,
      ProductName: "VOUCH 365 BOGO SPICY",
      CategoryId: 642,
      IsDeal: true,
      ProductImage: "\\ProductImages\\9aa62b7a-9a31-416f-9bdd-c92db56b909e.jpg",
      ProductPrice: 575,
      ProductDescription: null,
    },
    {
      ProductId: 2529,
      ProductName: "10 KRISPY CHICKEN BURGERS",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\bd9153e4-8c81-4927-a1a2-bd8b15d8a4f0.jpg",
      ProductPrice: 1900,
      ProductDescription: null,
    },
    {
      ProductId: 2530,
      ProductName: "10 KRUNCHI BITE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\9858270c-5e50-466a-8f58-48f213b5d9e6.jpg",
      ProductPrice: 3100,
      ProductDescription: null,
    },
    {
      ProductId: 2531,
      ProductName: "10 SUPPER VALUE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\15169f5e-b0e8-46fc-a880-f866da27c5ef.jpg",
      ProductPrice: 2100,
      ProductDescription: null,
    },
    {
      ProductId: 2532,
      ProductName: "15 KRISPY CHICKEN BURGERS",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\1c5cc0d9-4bbf-403a-9d3d-de4bd30095a8.jpg",
      ProductPrice: 2850,
      ProductDescription: null,
    },
    {
      ProductId: 2533,
      ProductName: "15 KRISPY CHICKEN PIECES",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\bd61e555-315b-40f7-9a0d-a28fc37b2a1e.png",
      ProductPrice: 2250,
      ProductDescription: null,
    },
    {
      ProductId: 2534,
      ProductName: "15 KRUNCHI BITE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\f27a7f8a-5abc-4b9f-9f9f-7e46e1b15861.jpg",
      ProductPrice: 4050,
      ProductDescription: null,
    },
    {
      ProductId: 2535,
      ProductName: "15 SUPPER VALUE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\5c7595a3-cb6d-4104-8aa7-1a92e7d7acbe.jpg",
      ProductPrice: 3150,
      ProductDescription: null,
    },
    {
      ProductId: 2536,
      ProductName: "20 KRISPY CHICKEN BURGERS",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\4267afc7-3da9-4104-b5de-8ff53bbe5792.jpg",
      ProductPrice: 2800,
      ProductDescription: null,
    },
    {
      ProductId: 2537,
      ProductName: "20 KRISPY CHICKEN PIECES",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\25f8fefc-6b25-481b-a786-037e134aafeb.png",
      ProductPrice: 3000,
      ProductDescription: null,
    },
    {
      ProductId: 2538,
      ProductName: "20 KRUNCHI BITE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\b1bd46e6-d0fd-4979-a7dd-8042683fa7c1.jpg",
      ProductPrice: 6200,
      ProductDescription: null,
    },
    {
      ProductId: 2539,
      ProductName: "20 SUPPER VALUE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\cb0f3ea0-05a2-466e-817b-1dcc95c851b0.jpg",
      ProductPrice: 4200,
      ProductDescription: null,
    },
    {
      ProductId: 2540,
      ProductName: "25 KRISPY CHICKEN BURGERS",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\eb249cb6-fa05-4b85-a5d1-75d98d497011.jpg",
      ProductPrice: 4750,
      ProductDescription: null,
    },
    {
      ProductId: 2541,
      ProductName: "25 KRISPY CHICKEN PIECES",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\4aa4816f-3587-4489-bd65-02d01eb931bc.png",
      ProductPrice: 3750,
      ProductDescription: null,
    },
    {
      ProductId: 2542,
      ProductName: "25 KRUNCHI BITE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\e0035017-f71c-4df2-a1e5-9582bd0e0ce4.jpg",
      ProductPrice: 7750,
      ProductDescription: null,
    },
    {
      ProductId: 2543,
      ProductName: "25 SUPPER VALUE BURGER",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\8a5bf4fb-9142-43f0-a78a-eb1888980555.jpg",
      ProductPrice: 5250,
      ProductDescription: null,
    },
    {
      ProductId: 2544,
      ProductName: "30 KRISPY CHICKEN PIECES",
      CategoryId: 643,
      IsDeal: true,
      ProductImage: "\\ProductImages\\a0037f40-37e8-4def-a66c-128d2b36d44a.png",
      ProductPrice: 4500,
      ProductDescription: null,
    },
    {
      ProductId: 2552,
      ProductName: "Add on Fries & Drink",
      CategoryId: 598,
      IsDeal: true,
      ProductImage: "\\ProductImages\\2c702b1a-f424-48c4-8cf0-90d530a7ec16.png",
      ProductPrice: 180,
      ProductDescription: null,
    },
    {
      ProductId: 2554,
      ProductName: "Nuggets(5)",
      CategoryId: 598,
      IsDeal: true,
      ProductImage: "\\ProductImages\\0391e1c8-95f6-4ab7-9bab-604f557b6390.jpg",
      ProductPrice: 330,
      ProductDescription: null,
    },
    {
      ProductId: 2555,
      ProductName: "Nuggets (10)",
      CategoryId: 598,
      IsDeal: true,
      ProductImage: "\\ProductImages\\cce6f7f3-bb78-4a76-9725-8baf2d0291f2.jpg",
      ProductPrice: 450,
      ProductDescription: null,
    },
    {
      ProductId: 2557,
      ProductName: "6 Pcs Hot Wing",
      CategoryId: 598,
      IsDeal: true,
      ProductImage: "\\ProductImages\\35da117f-2926-4513-9371-afbafb371299.jpg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2563,
      ProductName: "Imtiaz Bogo Delux",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\c1195b30-76ef-47fc-986f-c3ef6f13f62d.jpg",
      ProductPrice: 660,
      ProductDescription: null,
    },
    {
      ProductId: 2564,
      ProductName: "Imtiaz Bogo K2G SPICY",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\df45da58-f101-43b4-a6fa-ab33061beb03.jpg",
      ProductPrice: 575,
      ProductDescription: null,
    },
    {
      ProductId: 2566,
      ProductName: "Al Jadeed BOGO Delux",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\057910fd-70d6-4c95-9321-878600a19fe4.jpg",
      ProductPrice: 660,
      ProductDescription: null,
    },
    {
      ProductId: 2567,
      ProductName: "Al Jadeed Bogo K2G SPICY",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\634aa9b7-59b9-4d50-8b35-b6dfd439ac32.jpg",
      ProductPrice: 575,
      ProductDescription: null,
    },
    {
      ProductId: 2568,
      ProductName: "Al Jadeed BOGO Buy 2 Get 1",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\873588af-423d-4f8c-a428-b009d924b971.jpg",
      ProductPrice: 600,
      ProductDescription: null,
    },
    {
      ProductId: 2569,
      ProductName: "J. BOGO DELUX",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\9e5e8ced-b86b-4fbd-a041-f7605f1d8c88.jpg",
      ProductPrice: 660,
      ProductDescription: null,
    },
    {
      ProductId: 2570,
      ProductName: "Diamond BOGO Delux",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\de21e0ef-7108-4ecb-862d-677b28e0a2c7.jpg",
      ProductPrice: 660,
      ProductDescription: null,
    },
    {
      ProductId: 2571,
      ProductName: "Diamond Bogo K2G SPICY",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\ae1c0c81-0a13-41cf-b8f4-7ea45a823cf0.jpg",
      ProductPrice: 575,
      ProductDescription: null,
    },
    {
      ProductId: 2734,
      ProductName: "KRUNCHY WINTER",
      CategoryId: 597,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\ad2a70de-53b3-4ec4-bbc9-421a4b9a6d66.jpeg",
      ProductPrice: 1199,
      ProductDescription: null,
    },
    {
      ProductId: 2840,
      ProductName: "Tikka Sandwich",
      CategoryId: 700,
      IsDeal: false,
      ProductImage: "\\ProductImages\\3ccdb2ce-c530-4ef1-9ba1-12d421fe2635.jpg",
      ProductPrice: 520,
      ProductDescription: null,
    },
    {
      ProductId: 2841,
      ProductName: "Malai Boti Sandwich",
      CategoryId: 700,
      IsDeal: false,
      ProductImage: "\\ProductImages\\c0e6e063-d034-4ca3-9ac4-cf6784c90041.jpg",
      ProductPrice: 520,
      ProductDescription: null,
    },
    {
      ProductId: 2882,
      ProductName: "COMBO 1",
      CategoryId: 702,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\3eda2354-3482-4768-b47a-07871e0d0521.jpeg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2883,
      ProductName: "COMBO 2",
      CategoryId: 702,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\8e28b63f-991f-4e76-8a40-9c2873adc36b.jpeg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2884,
      ProductName: "COMBO 3",
      CategoryId: 702,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\32e9518d-1890-4f09-ad23-3b79c68f2f32.jpeg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2885,
      ProductName: "COMBO 4",
      CategoryId: 702,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\00f73ae8-49da-458f-8589-6a026c20262e.jpeg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2886,
      ProductName: "COMBO 5",
      CategoryId: 702,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\d3b1331e-ea6e-4d88-a958-3f69328033c2.jpeg",
      ProductPrice: 390,
      ProductDescription: null,
    },
    {
      ProductId: 2888,
      ProductName: "DC 80",
      CategoryId: 703,
      IsDeal: true,
      ProductImage: "",
      ProductPrice: 80,
      ProductDescription: null,
    },
    {
      ProductId: 2889,
      ProductName: "DC 100",
      CategoryId: 703,
      IsDeal: false,
      ProductImage: "",
      ProductPrice: 100,
      ProductDescription: null,
    },
    {
      ProductId: 2890,
      ProductName: "DC 120",
      CategoryId: 703,
      IsDeal: false,
      ProductImage: "",
      ProductPrice: 120,
      ProductDescription: null,
    },
    {
      ProductId: 2892,
      ProductName: "Beef Premium",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\c81c29da-bf0d-4e49-ba85-ec061fa3bf82.png",
      ProductPrice: 650,
      ProductDescription: null,
    },
    {
      ProductId: 2894,
      ProductName: "Beef Classic",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "\\ProductImages\\e114e302-bc95-4974-b9ef-8ca3bc2f205d.png",
      ProductPrice: 620,
      ProductDescription: null,
    },
    {
      ProductId: 2918,
      ProductName: "SPICY TOWER COMBO F.P",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "",
      ProductPrice: 816,
      ProductDescription: null,
    },
    {
      ProductId: 3032,
      ProductName: "CHEESIEST BURGER",
      CategoryId: 591,
      IsDeal: false,
      ProductImage: "",
      ProductPrice: 620,
      ProductDescription: null,
    },
    {
      ProductId: 3035,
      ProductName: "SANDWICH TREAT BOX",
      CategoryId: 700,
      IsDeal: true,
      ProductImage: "",
      ProductPrice: 1200,
      ProductDescription: null,
    },
    {
      ProductId: 3036,
      ProductName: "F.P 2 SANDWICH",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\40a648f8-f526-4fc5-85bf-cfa0438e3248.jpg",
      ProductPrice: 999,
      ProductDescription: null,
    },
    {
      ProductId: 3365,
      ProductName: "TREAT BOX 1",
      CategoryId: 597,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\2a8a4fee-b35b-4b77-b8d1-11b79383fa27.jpeg",
      ProductPrice: 1190,
      ProductDescription: null,
    },
    {
      ProductId: 3366,
      ProductName: "TREAT BOX 2",
      CategoryId: 597,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\29264375-e0af-4aac-956d-e5347469cedd.jpeg",
      ProductPrice: 1190,
      ProductDescription: null,
    },
    {
      ProductId: 3367,
      ProductName: "TREAT BOX 3",
      CategoryId: 597,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\399ea030-b6c8-4f9c-93c9-296abeee42c6.jpeg",
      ProductPrice: 1190,
      ProductDescription: null,
    },
    {
      ProductId: 4062,
      ProductName: "YEAR END DEAL",
      CategoryId: 597,
      IsDeal: true,
      ProductImage:
        "\\ProductImages\\27fea0be-41f6-4530-8803-9a3b95477b56.jpeg",
      ProductPrice: 1200,
      ProductDescription: "null",
    },
    {
      ProductId: 4468,
      ProductName: "MINERAL WATER - SMALL",
      CategoryId: 598,
      IsDeal: false,
      ProductImage: "",
      ProductPrice: 50,
      ProductDescription: null,
    },
    {
      ProductId: 4641,
      ProductName: "Buy 2 get 1 free Imtiaz chipotle wrap star",
      CategoryId: 597,
      IsDeal: true,
      ProductImage: "\\ProductImages\\4f455281-ec4f-4677-8527-27bc11da004f.jpg",
      ProductPrice: 799,
      ProductDescription: "null",
    },
  ],
  DealOptionList: [
    {
      DealItemId: 1388,
      DealOptionName: "Burgers",
      ProductDetailId: 4269,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 557,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:06:22.26",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1124,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1389,
      DealOptionName: "Drink",
      ProductDetailId: 4269,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:06:22.26",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1125,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1390,
      DealOptionName: "Fries",
      ProductDetailId: 4269,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:06:22.26",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1126,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1407,
      DealOptionName: "Twin Deal 2",
      ProductDetailId: 4270,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 557,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:11:06.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1127,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1408,
      DealOptionName: "Drinks",
      ProductDetailId: 4270,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:11:06.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1128,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1409,
      DealOptionName: "Fries",
      ProductDetailId: 4270,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:11:06.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1129,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1294,
      DealOptionName: "Burger",
      ProductDetailId: 4282,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2022-12-14T20:31:39.313",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 686,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1295,
      DealOptionName: "Fries",
      ProductDetailId: 4282,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 579,
      ProductPropertyId: null,
      CreatedDate: "2022-12-14T20:31:39.313",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 687,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1296,
      DealOptionName: "Drink",
      ProductDetailId: 4282,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-14T20:31:39.313",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 688,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1476,
      DealOptionName: "Fries",
      ProductDetailId: 4283,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 579,
      ProductPropertyId: null,
      CreatedDate: "2022-12-22T19:13:28.397",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1411,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1477,
      DealOptionName: "Drink",
      ProductDetailId: 4283,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-22T19:13:28.397",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1412,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1478,
      DealOptionName: "Chicken",
      ProductDetailId: 4283,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-22T19:13:28.397",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 2,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1413,
      DealOptionName: "Fries",
      ProductDetailId: 4284,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 579,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:11:46.833",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 847,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1414,
      DealOptionName: "Drink",
      ProductDetailId: 4284,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:11:46.833",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 848,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1415,
      DealOptionName: "nugget",
      ProductDetailId: 4284,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:11:46.833",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 849,
      MaxQuantity: 1,
    },
    {
      DealItemId: 698,
      DealOptionName: "Burger",
      ProductDetailId: 4285,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-10-19T14:47:17.047",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 699,
      DealOptionName: "Drink",
      ProductDetailId: 4285,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-10-19T14:47:17.047",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1391,
      DealOptionName: "Chicken",
      ProductDetailId: 4290,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 574,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 885,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1392,
      DealOptionName: "Fries",
      ProductDetailId: 4290,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 886,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1393,
      DealOptionName: "Roll",
      ProductDetailId: 4290,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 887,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1394,
      DealOptionName: "Drink",
      ProductDetailId: 4290,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 4,
      TempDealItemId: 888,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1395,
      DealOptionName: "Chicken",
      ProductDetailId: 4291,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 580,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 893,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1396,
      DealOptionName: "Fries",
      ProductDetailId: 4291,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 894,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1397,
      DealOptionName: "Roll",
      ProductDetailId: 4291,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 895,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1398,
      DealOptionName: "Drinks",
      ProductDetailId: 4291,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 4,
      TempDealItemId: 896,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1399,
      DealOptionName: "Burger",
      ProductDetailId: 4292,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 726,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1400,
      DealOptionName: "Chicken",
      ProductDetailId: 4292,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 727,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1401,
      DealOptionName: "Fries",
      ProductDetailId: 4292,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 728,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1402,
      DealOptionName: "Drink",
      ProductDetailId: 4292,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 4,
      TempDealItemId: 729,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1403,
      DealOptionName: "Burger",
      ProductDetailId: 4293,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1155,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1404,
      DealOptionName: "Fries",
      ProductDetailId: 4293,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 1156,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1405,
      DealOptionName: "Drinks",
      ProductDetailId: 4293,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 4,
      TempDealItemId: 1157,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1406,
      DealOptionName: "Chicken Pcs",
      ProductDetailId: 4293,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1158,
      MaxQuantity: 2,
    },
    {
      DealItemId: 734,
      DealOptionName: "Chicken",
      ProductDetailId: 4294,
      Quantity: 8,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      CreatedDate: "2022-10-19T15:21:10.067",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 0,
      MaxQuantity: 8,
    },
    {
      DealItemId: 1518,
      DealOptionName: "Chicken",
      ProductDetailId: 4295,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1130,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1519,
      DealOptionName: "Burger",
      ProductDetailId: 4295,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1131,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1520,
      DealOptionName: "Drink",
      ProductDetailId: 4295,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 1132,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1521,
      DealOptionName: "Fries",
      ProductDetailId: 4295,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1133,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1522,
      DealOptionName: "Chicken",
      ProductDetailId: 4296,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1134,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1523,
      DealOptionName: "Burger",
      ProductDetailId: 4296,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1135,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1524,
      DealOptionName: "Drink",
      ProductDetailId: 4296,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 1136,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1525,
      DealOptionName: "Fries",
      ProductDetailId: 4296,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1137,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1526,
      DealOptionName: "Chicken",
      ProductDetailId: 4297,
      Quantity: 9,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:19:40.11",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 743,
      MaxQuantity: 9,
    },
    {
      DealItemId: 1527,
      DealOptionName: "Fries",
      ProductDetailId: 4297,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:19:40.11",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 744,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1528,
      DealOptionName: "Drink",
      ProductDetailId: 4297,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:19:40.11",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 745,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1529,
      DealOptionName: "Burger",
      ProductDetailId: 4298,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 1138,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1530,
      DealOptionName: "Krispy Burger",
      ProductDetailId: 4298,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 1139,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1531,
      DealOptionName: "Spicy Burger",
      ProductDetailId: 4298,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 3,
      TempDealItemId: 1140,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1532,
      DealOptionName: "Drink",
      ProductDetailId: 4298,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 4,
      TempDealItemId: 1141,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1533,
      DealOptionName: "Fries",
      ProductDetailId: 4298,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1142,
      MaxQuantity: 1,
    },
    {
      DealItemId: 765,
      DealOptionName: "Two Wrap Star ( FoodPanda )",
      ProductDetailId: 4570,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T12:52:59.313",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 766,
      DealOptionName: "Krispy Chicken Burger (FoodPanda)",
      ProductDetailId: 4571,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T12:54:19.207",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 771,
      DealOptionName: "Bin Safeer Bogo Delux",
      ProductDetailId: 4572,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:42:38.693",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 772,
      DealOptionName: "Bin Safeer Bogo Buy 2 Get 1",
      ProductDetailId: 4573,
      Quantity: 3,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:44:13.193",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 3,
    },
    {
      DealItemId: 884,
      DealOptionName: "Burger",
      ProductDetailId: 4574,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:24:56.097",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 774,
      DealOptionName: "BOGO K2G Spicy",
      ProductDetailId: 4576,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:47:17.323",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 908,
      DealOptionName: "Burgers",
      ProductDetailId: 4577,
      Quantity: 3,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:10:06.86",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 775,
      MaxQuantity: 3,
    },
    {
      DealItemId: 776,
      DealOptionName: "Value Burger",
      ProductDetailId: 4578,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:52:09.253",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 777,
      DealOptionName: "Reg. Drink",
      ProductDetailId: 4578,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:52:09.253",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 778,
      DealOptionName: "Chicken Burger",
      ProductDetailId: 4579,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:53:05.833",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 779,
      DealOptionName: "Drink",
      ProductDetailId: 4579,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:53:05.833",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 780,
      DealOptionName: "K2G SPICY",
      ProductDetailId: 4580,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:54:24.617",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 781,
      DealOptionName: "2 WRAPSTAR",
      ProductDetailId: 4581,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:55:38.51",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 782,
      DealOptionName: "IMTIAZ Buy 2 Get 1",
      ProductDetailId: 4582,
      Quantity: 3,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T15:56:14.12",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 3,
    },
    {
      DealItemId: 906,
      DealOptionName: "Chicken Burger",
      ProductDetailId: 4583,
      Quantity: 3,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:05:34.557",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 783,
      MaxQuantity: 3,
    },
    {
      DealItemId: 911,
      DealOptionName: "K2G Spicy Burger",
      ProductDetailId: 4584,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:13:15.05",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 784,
      MaxQuantity: 2,
    },
    {
      DealItemId: 866,
      DealOptionName: "Burgers",
      ProductDetailId: 4585,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:14:09.233",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 787,
      DealOptionName: "Spicy Burger",
      ProductDetailId: 4586,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T16:54:42.617",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 786,
      MaxQuantity: 2,
    },
    {
      DealItemId: 767,
      DealOptionName: "10 Supper Value Burger",
      ProductDetailId: 4594,
      Quantity: 10,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T14:40:54.107",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 0,
      MaxQuantity: 10,
    },
    {
      DealItemId: 768,
      DealOptionName: "15 Super Value Burger",
      ProductDetailId: 4595,
      Quantity: 15,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T14:41:33.36",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 15,
    },
    {
      DealItemId: 769,
      DealOptionName: "20 Supper Value Burger",
      ProductDetailId: 4596,
      Quantity: 20,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T14:42:14.297",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 20,
    },
    {
      DealItemId: 770,
      DealOptionName: "25 Supper Value Burger",
      ProductDetailId: 4597,
      Quantity: 25,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T14:42:46.36",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 25,
    },
    {
      DealItemId: 788,
      DealOptionName: "Chicken Piece",
      ProductDetailId: 4598,
      Quantity: 15,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:30:03.103",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 15,
    },
    {
      DealItemId: 789,
      DealOptionName: "Chicken Piece",
      ProductDetailId: 4599,
      Quantity: 20,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:30:46.2",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 20,
    },
    {
      DealItemId: 790,
      DealOptionName: "Chicken Piece",
      ProductDetailId: 4600,
      Quantity: 25,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:31:17.67",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 25,
    },
    {
      DealItemId: 791,
      DealOptionName: "Chicken Piece",
      ProductDetailId: 4601,
      Quantity: 30,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:31:46.89",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 30,
    },
    {
      DealItemId: 792,
      DealOptionName: "Krunchi Bite",
      ProductDetailId: 4602,
      Quantity: 10,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:42:28.72",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 10,
    },
    {
      DealItemId: 793,
      DealOptionName: "Krunchi Bite",
      ProductDetailId: 4603,
      Quantity: 15,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:43:12.13",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 15,
    },
    {
      DealItemId: 794,
      DealOptionName: "Krunchi Bite",
      ProductDetailId: 4604,
      Quantity: 20,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:44:21.223",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 20,
    },
    {
      DealItemId: 795,
      DealOptionName: "KRUNCHI BITE",
      ProductDetailId: 4605,
      Quantity: 25,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:44:57.663",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 25,
    },
    {
      DealItemId: 796,
      DealOptionName: "Chicken Burger",
      ProductDetailId: 4606,
      Quantity: 10,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:45:31.197",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 10,
    },
    {
      DealItemId: 797,
      DealOptionName: "Chicken Burger",
      ProductDetailId: 4607,
      Quantity: 15,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:46:10.43",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 15,
    },
    {
      DealItemId: 798,
      DealOptionName: "Chicken Burger",
      ProductDetailId: 4608,
      Quantity: 20,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:46:41.62",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 20,
    },
    {
      DealItemId: 799,
      DealOptionName: "Chicken Burger",
      ProductDetailId: 4609,
      Quantity: 25,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T17:47:18.857",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 25,
    },
    {
      DealItemId: 1538,
      DealOptionName: "Fries",
      ProductDetailId: 4613,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T18:47:58.963",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 1,
      TempDealItemId: 800,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1539,
      DealOptionName: "Drinks",
      ProductDetailId: 4613,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T18:47:58.963",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 2,
      TempDealItemId: 801,
      MaxQuantity: 1,
    },
    {
      DealItemId: 897,
      DealOptionName: "Burger",
      ProductDetailId: 4619,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:40:46.87",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 883,
      DealOptionName: "Burger",
      ProductDetailId: 4620,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:22:27.107",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1253,
      DealOptionName: "Burger",
      ProductDetailId: 4621,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 850,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1254,
      DealOptionName: "Drink",
      ProductDetailId: 4621,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 851,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1255,
      DealOptionName: "Dips",
      ProductDetailId: 4621,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 852,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1256,
      DealOptionName: "Strips",
      ProductDetailId: 4621,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 853,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1257,
      DealOptionName: "Loaded Fries",
      ProductDetailId: 4621,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 4,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1258,
      DealOptionName: "Chicken Piece",
      ProductDetailId: 4622,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 858,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1259,
      DealOptionName: "Strips/Nuggets",
      ProductDetailId: 4622,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 859,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1260,
      DealOptionName: "Drinks",
      ProductDetailId: 4622,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 860,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1261,
      DealOptionName: "Dips",
      ProductDetailId: 4622,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 861,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1262,
      DealOptionName: "Loaded Fries",
      ProductDetailId: 4622,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 4,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1263,
      DealOptionName: "Wraps",
      ProductDetailId: 4623,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 832,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1264,
      DealOptionName: "Strips/Nuggets",
      ProductDetailId: 4623,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 833,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1265,
      DealOptionName: "Drinks",
      ProductDetailId: 4623,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 834,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1266,
      DealOptionName: "Dips",
      ProductDetailId: 4623,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 835,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1267,
      DealOptionName: "Loaded Fries",
      ProductDetailId: 4623,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 4,
      MaxQuantity: 1,
    },
    {
      DealItemId: 802,
      DealOptionName: "Krunchy Bite Burger",
      ProductDetailId: 4628,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:39:34.55",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 803,
      DealOptionName: "Chicken",
      ProductDetailId: 4628,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:39:34.55",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 804,
      DealOptionName: "Drink",
      ProductDetailId: 4628,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:39:34.55",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 2,
      MaxQuantity: 1,
    },
    {
      DealItemId: 805,
      DealOptionName: "Chicken Piece",
      ProductDetailId: 4629,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:40:31.8",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 806,
      DealOptionName: "Drinks",
      ProductDetailId: 4629,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:40:31.8",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 807,
      DealOptionName: "Spicy Burger",
      ProductDetailId: 4630,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:41:34.96",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 808,
      DealOptionName: "Drink",
      ProductDetailId: 4630,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:41:34.96",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 809,
      DealOptionName: "Wrap",
      ProductDetailId: 4631,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:42:39.447",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 810,
      DealOptionName: "Drink",
      ProductDetailId: 4631,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T19:42:39.447",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 916,
      DealOptionName: "Fries",
      ProductDetailId: 4633,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 914,
      MaxQuantity: 1,
    },
    {
      DealItemId: 917,
      DealOptionName: "Dip",
      ProductDetailId: 4633,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 915,
      MaxQuantity: 1,
    },
    {
      DealItemId: 813,
      DealOptionName: "Nuggets",
      ProductDetailId: 4636,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 814,
      DealOptionName: "DIPS",
      ProductDetailId: 4636,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 817,
      DealOptionName: "Nuggets",
      ProductDetailId: 4637,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 818,
      DealOptionName: "DIPS",
      ProductDetailId: 4637,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 815,
      DealOptionName: "POP CORN",
      ProductDetailId: 4639,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 816,
      DealOptionName: "DIP N DIP",
      ProductDetailId: 4639,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 900,
      DealOptionName: "Wings",
      ProductDetailId: 4641,
      Quantity: 6,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 819,
      MaxQuantity: 6,
    },
    {
      DealItemId: 901,
      DealOptionName: "Dips",
      ProductDetailId: 4641,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 820,
      MaxQuantity: 1,
    },
    {
      DealItemId: 898,
      DealOptionName: "Burger",
      ProductDetailId: 4646,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:49:20.277",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 899,
      DealOptionName: "Burgers",
      ProductDetailId: 4647,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:50:30.433",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 902,
      DealOptionName: "Burgers",
      ProductDetailId: 4648,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T22:54:56.287",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 903,
      DealOptionName: "Burgers",
      ProductDetailId: 4649,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:00:38.943",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 904,
      DealOptionName: "Burgers",
      ProductDetailId: 4650,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:01:14.18",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 905,
      DealOptionName: "Burgeres",
      ProductDetailId: 4651,
      Quantity: 3,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:01:39.46",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 3,
    },
    {
      DealItemId: 907,
      DealOptionName: "Burgers",
      ProductDetailId: 4652,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:06:14.62",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 912,
      DealOptionName: "Burgers",
      ProductDetailId: 4653,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:14:13.537",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 909,
      MaxQuantity: 2,
    },
    {
      DealItemId: 913,
      DealOptionName: "Burgers",
      ProductDetailId: 4654,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-15T23:15:05.04",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 910,
      MaxQuantity: 2,
    },
    {
      DealItemId: 918,
      DealOptionName: "Burgers",
      ProductDetailId: 4656,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-11-16T15:59:48.71",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1147,
      DealOptionName: "Burger",
      ProductDetailId: 5068,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:36:52.757",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1018,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1148,
      DealOptionName: "Drink",
      ProductDetailId: 5068,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:36:52.757",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1019,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1143,
      DealOptionName: "Burger",
      ProductDetailId: 5232,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:31:37.673",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1144,
      DealOptionName: "Chicken PC",
      ProductDetailId: 5232,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:31:37.673",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1145,
      DealOptionName: "Burger",
      ProductDetailId: 5233,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:35:46.037",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1146,
      DealOptionName: "Drink",
      ProductDetailId: 5233,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:35:46.037",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1149,
      DealOptionName: "Burger",
      ProductDetailId: 5234,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:49:15.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1150,
      DealOptionName: "Drink",
      ProductDetailId: 5234,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-01T20:49:15.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1516,
      DealOptionName: "Chicken Pcs",
      ProductDetailId: 5235,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 557,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:44:18.233",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1151,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1517,
      DealOptionName: "Fries",
      ProductDetailId: 5235,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:44:18.233",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1152,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1544,
      DealOptionName: "Drink",
      ProductDetailId: 5236,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2023-01-04T14:22:57.42",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1474,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1545,
      DealOptionName: "HOt wings 5 pcs",
      ProductDetailId: 5236,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 575,
      ProductPropertyId: null,
      CreatedDate: "2023-01-04T14:22:57.42",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1475,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1250,
      DealOptionName: "Burger",
      ProductDetailId: 5279,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-03T17:54:30.977",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1251,
      DealOptionName: "Fries",
      ProductDetailId: 5279,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-03T17:54:30.977",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1252,
      DealOptionName: "Drinks",
      ProductDetailId: 5279,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-03T17:54:30.977",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 2,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1540,
      DealOptionName: "Sandwich",
      ProductDetailId: 5465,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1534,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1541,
      DealOptionName: "Chicken",
      ProductDetailId: 5465,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1535,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1542,
      DealOptionName: "Strips",
      ProductDetailId: 5465,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1536,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1543,
      DealOptionName: "Drink",
      ProductDetailId: 5465,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1537,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1276,
      DealOptionName: "Sandwich",
      ProductDetailId: 5466,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-12T16:11:15.663",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1506,
      DealOptionName: "BURGERS",
      ProductDetailId: 5795,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1492,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1507,
      DealOptionName: "DIPS",
      ProductDetailId: 5795,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1493,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1508,
      DealOptionName: "DRINK",
      ProductDetailId: 5795,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1494,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1509,
      DealOptionName: "Nuggets/Krispy Tender",
      ProductDetailId: 5795,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 580,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1495,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1510,
      DealOptionName: "Loaded Fries",
      ProductDetailId: 5795,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 4,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1511,
      DealOptionName: "KRISPY CHICKEN",
      ProductDetailId: 5796,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 580,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1496,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1512,
      DealOptionName: "LOADED FRIES",
      ProductDetailId: 5796,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1497,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1513,
      DealOptionName: "DRINK",
      ProductDetailId: 5796,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1498,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1514,
      DealOptionName: "DIPS",
      ProductDetailId: 5796,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1499,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1515,
      DealOptionName: "Nuggets/Krispy Tender",
      ProductDetailId: 5796,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 580,
      ProductPropertyId: null,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1500,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1501,
      DealOptionName: "WRAP STAR",
      ProductDetailId: 5797,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1287,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1502,
      DealOptionName: "LOADED FRIES",
      ProductDetailId: 5797,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1288,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1503,
      DealOptionName: "DIPS",
      ProductDetailId: 5797,
      Quantity: 2,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1290,
      MaxQuantity: 2,
    },
    {
      DealItemId: 1504,
      DealOptionName: "DRINK",
      ProductDetailId: 5797,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1291,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1505,
      DealOptionName: "Nuggets/Krispy Tender",
      ProductDetailId: 5797,
      Quantity: 4,
      IsToppingAllowed: false,
      SizeId: 580,
      ProductPropertyId: null,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 4,
      MaxQuantity: 4,
    },
    {
      DealItemId: 1320,
      DealOptionName: "BURGERS",
      ProductDetailId: 6492,
      Quantity: 5,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-15T23:40:59.787",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1292,
      MaxQuantity: 5,
    },
    {
      DealItemId: 1321,
      DealOptionName: "Drink",
      ProductDetailId: 6492,
      Quantity: 1,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      CreatedDate: "2022-12-15T23:40:59.787",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 1293,
      MaxQuantity: 1,
    },
    {
      DealItemId: 1563,
      DealOptionName: "Buy 2 get 1 free Imtiaz chipotle wrap star",
      ProductDetailId: 7059,
      Quantity: 3,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      CreatedDate: "2023-01-19T16:51:55.887",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: null,
      IsActive: true,
      SortOrder: 0,
      TempDealItemId: 0,
      MaxQuantity: 3,
    },
  ],
  DealItemList: [
    {
      DealDescId: 2075,
      DealItemId: 700,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-10-19T14:49:46.223",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2076,
      DealItemId: 701,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-10-19T14:49:46.223",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 2073,
      DealItemId: 698,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-10-19T14:47:17.047",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2080,
      DealItemId: 705,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-10-19T14:53:54.137",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2084,
      DealItemId: 709,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-10-19T15:06:26.203",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2085,
      DealItemId: 710,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-10-19T15:06:26.203",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 2082,
      DealItemId: 707,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-10-19T14:54:36.87",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 2089,
      DealItemId: 714,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-10-19T15:08:25.97",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2109,
      DealItemId: 734,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-10-19T15:21:10.067",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 2292,
      DealItemId: 765,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-11-15T12:52:59.313",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 2293,
      DealItemId: 766,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T12:54:19.207",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2294,
      DealItemId: 767,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-11-15T14:40:54.107",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 2295,
      DealItemId: 768,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-11-15T14:41:33.36",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 2296,
      DealItemId: 769,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-11-15T14:42:14.297",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 2297,
      DealItemId: 770,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-11-15T14:42:46.36",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 2298,
      DealItemId: 771,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T15:42:38.693",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2299,
      DealItemId: 772,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T15:44:13.193",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2300,
      DealItemId: 773,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T15:45:40.04",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2301,
      DealItemId: 774,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T15:47:17.323",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2303,
      DealItemId: 776,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-11-15T15:52:09.253",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 2307,
      DealItemId: 780,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T15:54:24.617",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2308,
      DealItemId: 781,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-11-15T15:55:38.51",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 2309,
      DealItemId: 782,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T15:56:14.12",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2314,
      DealItemId: 787,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T16:54:42.617",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2319,
      DealItemId: 792,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-11-15T17:42:28.72",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2320,
      DealItemId: 793,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-11-15T17:43:12.13",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2321,
      DealItemId: 794,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-11-15T17:44:21.223",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2322,
      DealItemId: 795,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-11-15T17:44:57.663",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2323,
      DealItemId: 796,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T17:45:31.197",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2324,
      DealItemId: 797,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T17:46:10.43",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2325,
      DealItemId: 798,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T17:46:41.62",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2326,
      DealItemId: 799,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T17:47:18.857",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2329,
      DealItemId: 802,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-11-15T19:39:34.55",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2345,
      DealItemId: 813,
      ProductDetailId: 4635,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "NUGGETS (5 Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\718a5dac-5f71-4f0d-a7ba-081aa2be6328.jpg",
    },
    {
      DealDescId: 2352,
      DealItemId: 815,
      ProductDetailId: 4638,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Krispy Pop Corn (10 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5173e4cd-15c4-4f9f-9f92-5e00365dba9f.jpg",
    },
    {
      DealDescId: 2359,
      DealItemId: 817,
      ProductDetailId: 4617,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "NUGGETS (10 Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\084bfc78-fd5d-4519-8912-123b43aca2fd.jpg",
    },
    {
      DealDescId: 2471,
      DealItemId: 866,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T22:14:09.233",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2488,
      DealItemId: 883,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T22:22:27.107",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2489,
      DealItemId: 884,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T22:24:56.097",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2502,
      DealItemId: 897,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-11-15T22:40:46.87",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 2503,
      DealItemId: 898,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T22:49:20.277",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2504,
      DealItemId: 899,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T22:50:30.433",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2505,
      DealItemId: 900,
      ProductDetailId: 4640,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "5 Hot Wing (Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\cc900ecd-4f5d-460a-8268-06c2394f0fe8.jpg",
    },
    {
      DealDescId: 2512,
      DealItemId: 902,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T22:54:56.287",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2513,
      DealItemId: 903,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T23:00:38.943",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2514,
      DealItemId: 904,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T23:01:14.18",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2515,
      DealItemId: 905,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T23:01:39.46",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2516,
      DealItemId: 906,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T23:05:34.557",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2517,
      DealItemId: 907,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T23:06:14.62",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2518,
      DealItemId: 908,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T23:10:06.86",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2521,
      DealItemId: 911,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T23:13:15.05",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2522,
      DealItemId: 912,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-11-15T23:14:13.537",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 2523,
      DealItemId: 913,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T23:15:05.04",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2531,
      DealItemId: 916,
      ProductDetailId: 4261,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Bucket Fries - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
    },
    {
      DealDescId: 2538,
      DealItemId: 918,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-16T15:59:48.71",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 3545,
      DealItemId: 1143,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-12-01T20:31:37.673",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 3546,
      DealItemId: 1144,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-12-01T20:31:37.673",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 3547,
      DealItemId: 1145,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-12-01T20:35:46.037",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 2091,
      DealItemId: 716,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-10-19T15:09:12.863",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 2305,
      DealItemId: 778,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-11-15T15:53:05.833",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 2332,
      DealItemId: 805,
      ProductDetailId: 4610,
      IsActive: true,
      CreatedDate: "2022-11-15T19:40:31.8",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
    },
    {
      DealDescId: 2334,
      DealItemId: 807,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-11-15T19:41:34.96",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 2336,
      DealItemId: 809,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-11-15T19:42:39.447",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 3549,
      DealItemId: 1147,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-12-01T20:36:52.757",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 3551,
      DealItemId: 1149,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-12-01T20:49:15.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 3896,
      DealItemId: 1250,
      ProductDetailId: 3001,
      IsActive: true,
      CreatedDate: "2022-12-03T17:54:30.977",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "SPICY TOWER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\b36731ea-3f1b-4de9-bc26-8cad0d5c6564.jpg",
    },
    {
      DealDescId: 3908,
      DealItemId: 1256,
      ProductDetailId: 4642,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets (4 Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\02faf991-9267-41de-ae7f-d8ebf89b5c6f.jpg",
    },
    {
      DealDescId: 3907,
      DealItemId: 1256,
      ProductDetailId: 4643,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Chicken Strips (4 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\4c40ce12-d58e-484c-afb1-8d6e2c7e5a36.png",
    },
    {
      DealDescId: 3909,
      DealItemId: 1257,
      ProductDetailId: 4267,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
    },
    {
      DealDescId: 3910,
      DealItemId: 1258,
      ProductDetailId: 4645,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN PIECE (4 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a9e8b996-4fab-4508-9f44-cc2b5d2b488f.png",
    },
    {
      DealDescId: 3912,
      DealItemId: 1259,
      ProductDetailId: 4642,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets (4 Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\02faf991-9267-41de-ae7f-d8ebf89b5c6f.jpg",
    },
    {
      DealDescId: 3911,
      DealItemId: 1259,
      ProductDetailId: 4643,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Chicken Strips (4 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\4c40ce12-d58e-484c-afb1-8d6e2c7e5a36.png",
    },
    {
      DealDescId: 3899,
      DealItemId: 1253,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 3931,
      DealItemId: 1267,
      ProductDetailId: 4267,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
    },
    {
      DealDescId: 3977,
      DealItemId: 1294,
      ProductDetailId: 2993,
      IsActive: true,
      CreatedDate: "2022-12-14T20:31:39.313",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d7915bde-1c19-4cfa-a2b0-93194c3f7539.jpg",
    },
    {
      DealDescId: 4026,
      DealItemId: 1320,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-12-15T23:40:59.787",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 4144,
      DealItemId: 1388,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-12-16T21:06:22.26",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 4147,
      DealItemId: 1391,
      ProductDetailId: 4610,
      IsActive: true,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
    },
    {
      DealDescId: 4149,
      DealItemId: 1393,
      ProductDetailId: 4614,
      IsActive: true,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DINNER ROLL - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a0a130e-0db1-4f37-b011-3113be47ccfb.png",
    },
    {
      DealDescId: 4151,
      DealItemId: 1395,
      ProductDetailId: 4645,
      IsActive: true,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHICKEN PIECE (4 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a9e8b996-4fab-4508-9f44-cc2b5d2b488f.png",
    },
    {
      DealDescId: 4155,
      DealItemId: 1399,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 4156,
      DealItemId: 1400,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 4153,
      DealItemId: 1397,
      ProductDetailId: 4614,
      IsActive: true,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DINNER ROLL - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a0a130e-0db1-4f37-b011-3113be47ccfb.png",
    },
    {
      DealDescId: 4159,
      DealItemId: 1403,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 4162,
      DealItemId: 1406,
      ProductDetailId: 4610,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
    },
    {
      DealDescId: 4163,
      DealItemId: 1407,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-12-16T21:11:06.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 4359,
      DealItemId: 1478,
      ProductDetailId: 4644,
      IsActive: true,
      CreatedDate: "2022-12-22T19:13:28.397",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Krispy Popper (7 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\3250bce7-9d7c-4e02-bd9e-a915598b4d86.jpg",
    },
    {
      DealDescId: 4412,
      DealItemId: 1501,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 4413,
      DealItemId: 1502,
      ProductDetailId: 4267,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
    },
    {
      DealDescId: 3920,
      DealItemId: 1262,
      ProductDetailId: 4267,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
    },
    {
      DealDescId: 3921,
      DealItemId: 1263,
      ProductDetailId: 3002,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\a651b44c-d122-4384-94d5-e58d6ae3c2d4.jpg",
    },
    {
      DealDescId: 3922,
      DealItemId: 1264,
      ProductDetailId: 4643,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Chicken Strips (4 PCS) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\4c40ce12-d58e-484c-afb1-8d6e2c7e5a36.png",
    },
    {
      DealDescId: 3923,
      DealItemId: 1264,
      ProductDetailId: 4642,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets (4 Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\02faf991-9267-41de-ae7f-d8ebf89b5c6f.jpg",
    },
    {
      DealDescId: 4171,
      DealItemId: 1415,
      ProductDetailId: 4642,
      IsActive: true,
      CreatedDate: "2022-12-16T21:11:46.833",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets (4 Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\02faf991-9267-41de-ae7f-d8ebf89b5c6f.jpg",
    },
    {
      DealDescId: 4422,
      DealItemId: 1505,
      ProductDetailId: 4618,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Krispy Tender - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9268325c-8fb4-4f0e-b04b-5ba079fd0891.png",
    },
    {
      DealDescId: 4423,
      DealItemId: 1506,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 4431,
      DealItemId: 1509,
      ProductDetailId: 4618,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Krispy Tender - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9268325c-8fb4-4f0e-b04b-5ba079fd0891.png",
    },
    {
      DealDescId: 4433,
      DealItemId: 1510,
      ProductDetailId: 4267,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
    },
    {
      DealDescId: 4435,
      DealItemId: 1512,
      ProductDetailId: 4267,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "LOADED FRIES Regular - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\bb439f3b-59bd-466b-a16a-62ff2ce13878.jpg",
    },
    {
      DealDescId: 4444,
      DealItemId: 1515,
      ProductDetailId: 4618,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Krispy Tender - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9268325c-8fb4-4f0e-b04b-5ba079fd0891.png",
    },
    {
      DealDescId: 4445,
      DealItemId: 1516,
      ProductDetailId: 4610,
      IsActive: true,
      CreatedDate: "2022-12-26T14:44:18.233",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
    },
    {
      DealDescId: 4450,
      DealItemId: 1521,
      ProductDetailId: 4261,
      IsActive: true,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Bucket Fries - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
    },
    {
      DealDescId: 4451,
      DealItemId: 1522,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 4452,
      DealItemId: 1523,
      ProductDetailId: 2996,
      IsActive: true,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRUNCHY BITE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\67b8ccbb-de68-4d67-b5bb-4ae8be3d9945.jpg",
    },
    {
      DealDescId: 4454,
      DealItemId: 1525,
      ProductDetailId: 4261,
      IsActive: true,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Bucket Fries - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
    },
    {
      DealDescId: 4455,
      DealItemId: 1526,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-12-26T15:19:40.11",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 4456,
      DealItemId: 1527,
      ProductDetailId: 4261,
      IsActive: true,
      CreatedDate: "2022-12-26T15:19:40.11",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Bucket Fries - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
    },
    {
      DealDescId: 4476,
      DealItemId: 1545,
      ProductDetailId: 4640,
      IsActive: true,
      CreatedDate: "2023-01-04T14:22:57.42",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "5 Hot Wing (Pcs) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\cc900ecd-4f5d-460a-8268-06c2394f0fe8.jpg",
    },
    {
      DealDescId: 4499,
      DealItemId: 1563,
      ProductDetailId: 3003,
      IsActive: true,
      CreatedDate: "2023-01-19T16:51:55.887",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "SIGNATURE CHIPOTLE WRAP STAR - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\d6b5137c-0f2b-4132-9833-af37af0219e3.jpg",
    },
    {
      DealDescId: 3925,
      DealItemId: 1266,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4437,
      DealItemId: 1514,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4424,
      DealItemId: 1507,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3901,
      DealItemId: 1255,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3914,
      DealItemId: 1261,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4414,
      DealItemId: 1503,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2360,
      DealItemId: 818,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2506,
      DealItemId: 901,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2533,
      DealItemId: 917,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2346,
      DealItemId: 814,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2353,
      DealItemId: 816,
      ProductDetailId: 4276,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - CHIPOTLE",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2347,
      DealItemId: 814,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2354,
      DealItemId: 816,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2532,
      DealItemId: 917,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2361,
      DealItemId: 818,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2507,
      DealItemId: 901,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3915,
      DealItemId: 1261,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3902,
      DealItemId: 1255,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3926,
      DealItemId: 1266,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4415,
      DealItemId: 1503,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4438,
      DealItemId: 1514,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4425,
      DealItemId: 1507,
      ProductDetailId: 4277,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - GARLIC MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4427,
      DealItemId: 1507,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4440,
      DealItemId: 1514,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4417,
      DealItemId: 1503,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3927,
      DealItemId: 1266,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3928,
      DealItemId: 1266,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3904,
      DealItemId: 1255,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2535,
      DealItemId: 917,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3917,
      DealItemId: 1261,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2509,
      DealItemId: 901,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2362,
      DealItemId: 818,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2349,
      DealItemId: 814,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2356,
      DealItemId: 816,
      ProductDetailId: 4279,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - HOT & SPICY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2351,
      DealItemId: 814,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2364,
      DealItemId: 818,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2358,
      DealItemId: 816,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2537,
      DealItemId: 917,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2511,
      DealItemId: 901,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3919,
      DealItemId: 1261,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3906,
      DealItemId: 1255,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4419,
      DealItemId: 1503,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3930,
      DealItemId: 1266,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4429,
      DealItemId: 1507,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4442,
      DealItemId: 1514,
      ProductDetailId: 4281,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - LEMON & HERBS",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4441,
      DealItemId: 1514,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4418,
      DealItemId: 1503,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3929,
      DealItemId: 1266,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3905,
      DealItemId: 1255,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4428,
      DealItemId: 1507,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3918,
      DealItemId: 1261,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2510,
      DealItemId: 901,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2357,
      DealItemId: 816,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2363,
      DealItemId: 818,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2536,
      DealItemId: 917,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2350,
      DealItemId: 814,
      ProductDetailId: 4280,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - PERY PERY",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2508,
      DealItemId: 901,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-11-15T22:51:07.013",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2365,
      DealItemId: 818,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-11-15T21:15:52.93",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2348,
      DealItemId: 814,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-11-15T20:59:38.807",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2355,
      DealItemId: 816,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-11-15T21:05:58.7",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 2534,
      DealItemId: 917,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-11-16T12:51:49.68",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3903,
      DealItemId: 1255,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4439,
      DealItemId: 1514,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 3916,
      DealItemId: 1261,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4416,
      DealItemId: 1503,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4426,
      DealItemId: 1507,
      ProductDetailId: 4278,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "DIP N DIP - STD - SPICY MAYO",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\f1b344d8-d629-4fde-b410-af56b82ae5fe.jpg",
    },
    {
      DealDescId: 4458,
      DealItemId: 1529,
      ProductDetailId: 2989,
      IsActive: true,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "CHIPOTLE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 13,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9bf2a3da-5fea-438d-a3fb-7eaa71b31f2e.jpg",
    },
    {
      DealDescId: 4459,
      DealItemId: 1530,
      ProductDetailId: 2990,
      IsActive: true,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY DELUX - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\ea2ea370-9926-4d58-9554-455bddbcf33c.jpg",
    },
    {
      DealDescId: 4460,
      DealItemId: 1531,
      ProductDetailId: 2995,
      IsActive: true,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SPICY - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\5d169cfe-1b51-4d0b-8555-94ad7f1d348f.jpg",
    },
    {
      DealDescId: 4462,
      DealItemId: 1533,
      ProductDetailId: 4261,
      IsActive: true,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Bucket Fries - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\92b0f591-dc22-4925-853a-5f3c504c772b.png",
    },
    {
      DealDescId: 4472,
      DealItemId: 1541,
      ProductDetailId: 4610,
      IsActive: true,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECE (2 Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\869950e1-9121-4f49-8681-ad220b769125.png",
    },
    {
      DealDescId: 4473,
      DealItemId: 1542,
      ProductDetailId: 4618,
      IsActive: true,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Krispy Tender - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9268325c-8fb4-4f0e-b04b-5ba079fd0891.png",
    },
    {
      DealDescId: 4447,
      DealItemId: 1518,
      ProductDetailId: 4257,
      IsActive: true,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECES (1Pc) - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\e82ae6e6-9210-4350-ba95-ef1358c03ffb.png",
    },
    {
      DealDescId: 4448,
      DealItemId: 1519,
      ProductDetailId: 2997,
      IsActive: true,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "K2G SUPPER VALUE BURGER - STD - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 489,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\863c2236-66a7-4418-9c28-07065a0b99de.jpg",
    },
    {
      DealDescId: 4449,
      DealItemId: 1520,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T15:16:38.24",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4474,
      DealItemId: 1543,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4461,
      DealItemId: 1532,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T15:23:08.6",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4457,
      DealItemId: 1528,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T15:19:40.11",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4453,
      DealItemId: 1524,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T15:17:36.83",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4436,
      DealItemId: 1513,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4430,
      DealItemId: 1508,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 3924,
      DealItemId: 1265,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:49",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4420,
      DealItemId: 1504,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4027,
      DealItemId: 1321,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-15T23:40:59.787",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 3900,
      DealItemId: 1254,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-08T13:05:03.17",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 3913,
      DealItemId: 1260,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-08T13:06:19.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 3550,
      DealItemId: 1148,
      ProductDetailId: 4304,
      IsActive: true,
      CreatedDate: "2022-12-01T20:36:52.757",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "1 LTR DRINK - N/A - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 556,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c9f16521-f26c-4c83-b2ea-189a6de78db3.jpg",
    },
    {
      DealDescId: 4432,
      DealItemId: 1509,
      ProductDetailId: 6716,
      IsActive: true,
      CreatedDate: "2022-12-26T14:18:01.81",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets - 1 PC - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "",
    },
    {
      DealDescId: 4421,
      DealItemId: 1505,
      ProductDetailId: 6716,
      IsActive: true,
      CreatedDate: "2022-12-23T22:49:09.987",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets - 1 PC - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "",
    },
    {
      DealDescId: 4443,
      DealItemId: 1515,
      ProductDetailId: 6716,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Nuggets - 1 PC - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 572,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "",
    },
    {
      DealDescId: 4446,
      DealItemId: 1517,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-26T14:44:18.233",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4357,
      DealItemId: 1476,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-22T19:13:28.397",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4358,
      DealItemId: 1477,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-22T19:13:28.397",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 3941,
      DealItemId: 1276,
      ProductDetailId: 5189,
      IsActive: true,
      CreatedDate: "2022-12-12T16:11:15.663",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Tikka Sandwich - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\3ccdb2ce-c530-4ef1-9ba1-12d421fe2635.jpg",
    },
    {
      DealDescId: 3942,
      DealItemId: 1276,
      ProductDetailId: 5190,
      IsActive: true,
      CreatedDate: "2022-12-12T16:11:15.663",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Malai Boti Sandwich - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c0e6e063-d034-4ca3-9ac4-cf6784c90041.jpg",
    },
    {
      DealDescId: 3978,
      DealItemId: 1295,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-14T20:31:39.313",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 3979,
      DealItemId: 1296,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-14T20:31:39.313",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4148,
      DealItemId: 1392,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4145,
      DealItemId: 1389,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:06:22.26",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4146,
      DealItemId: 1390,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:06:22.26",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4164,
      DealItemId: 1408,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:11:06.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4165,
      DealItemId: 1409,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:11:06.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4169,
      DealItemId: 1413,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:11:46.833",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4170,
      DealItemId: 1414,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:11:46.833",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4160,
      DealItemId: 1404,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4161,
      DealItemId: 1405,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:34.533",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4154,
      DealItemId: 1398,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4157,
      DealItemId: 1401,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4158,
      DealItemId: 1402,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:10:12.063",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4152,
      DealItemId: 1396,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-16T21:09:31.873",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4150,
      DealItemId: 1394,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-16T21:08:49.53",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2337,
      DealItemId: 810,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-11-15T19:42:39.447",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 3897,
      DealItemId: 1251,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-03T17:54:30.977",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 3898,
      DealItemId: 1252,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-03T17:54:30.977",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 3552,
      DealItemId: 1150,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-01T20:49:15.627",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2335,
      DealItemId: 808,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-11-15T19:41:34.96",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2333,
      DealItemId: 806,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-11-15T19:40:31.8",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2306,
      DealItemId: 779,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-11-15T15:53:05.833",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2092,
      DealItemId: 717,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T15:09:12.863",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 3548,
      DealItemId: 1146,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-01T20:35:46.037",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2331,
      DealItemId: 804,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-11-15T19:39:34.55",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2304,
      DealItemId: 777,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-11-15T15:52:09.253",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2090,
      DealItemId: 715,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T15:08:25.97",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2083,
      DealItemId: 708,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T14:54:36.87",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2086,
      DealItemId: 711,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T15:06:26.203",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2088,
      DealItemId: 713,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T15:07:37.75",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2081,
      DealItemId: 706,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T14:53:54.137",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2074,
      DealItemId: 699,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T14:47:17.047",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2077,
      DealItemId: 702,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T14:49:46.223",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 2079,
      DealItemId: 704,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-10-19T14:53:03.353",
      CreatedBy: 212,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4468,
      DealItemId: 1538,
      ProductDetailId: 5249,
      IsActive: true,
      CreatedDate: "2022-12-26T18:47:58.963",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Fries - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\9b58a13c-c3b8-4dca-a65d-c7627e90d953.png",
    },
    {
      DealDescId: 4469,
      DealItemId: 1539,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2022-12-26T18:47:58.963",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4470,
      DealItemId: 1540,
      ProductDetailId: 5189,
      IsActive: true,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Tikka Sandwich - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\3ccdb2ce-c530-4ef1-9ba1-12d421fe2635.jpg",
    },
    {
      DealDescId: 4471,
      DealItemId: 1540,
      ProductDetailId: 5190,
      IsActive: true,
      CreatedDate: "2022-12-26T23:13:24.197",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "Malai Boti Sandwich - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\c0e6e063-d034-4ca3-9ac4-cf6784c90041.jpg",
    },
    {
      DealDescId: 4475,
      DealItemId: 1544,
      ProductDetailId: 4264,
      IsActive: true,
      CreatedDate: "2023-01-04T14:22:57.42",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "REG. DRINK - REG - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 578,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\6a150159-4b07-4a41-bc98-43d60850d9ce.jpg",
    },
    {
      DealDescId: 4434,
      DealItemId: 1511,
      ProductDetailId: 5242,
      IsActive: true,
      CreatedDate: "2022-12-26T14:37:41.877",
      CreatedBy: 246,
      ModifiedDate: null,
      ModifiedBy: null,
      SortOrder: 0,
      Price: 0,
      ProductDetailName: "KRISPY CHICKEN PIECE (4 Pc) - 4 Pcs - N/A",
      GSTPercentage: 0,
      TaxPercent: 0,
      IsToppingAllowed: false,
      SizeId: 580,
      ProductPropertyId: null,
      ProductPropertyName: null,
      ProductPropertyCount: null,
      ProductPropertyPrice: 0,
      ProductImage: "\\ProductImages\\4203529d-a192-401f-95da-497b0194ecf6.png",
    },
  ],
  ProductSizeList: [
    {
      ProductId: 1668,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1669,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1670,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1671,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1672,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1673,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1675,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1679,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1681,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 1682,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2138,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2140,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2287,
      SizeId: 572,
      SizeName: "1 PC",
    },
    {
      ProductId: 2288,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2290,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2291,
      SizeId: 576,
      SizeName: "L",
    },
    {
      ProductId: 2292,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2293,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2294,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2295,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2296,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2297,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2298,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2299,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2300,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2301,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2302,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2303,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2304,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2305,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2306,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2308,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2309,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2310,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2314,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2315,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2322,
      SizeId: 556,
      SizeName: "N/A",
    },
    {
      ProductId: 2500,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2501,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2502,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2503,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2507,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2508,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2512,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2513,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2514,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2515,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2518,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2519,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2520,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2521,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2522,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2523,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2524,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2525,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2526,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2527,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2528,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2529,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2530,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2531,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2532,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2533,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2534,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2535,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2536,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2537,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2538,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2539,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2540,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2541,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2542,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2543,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2544,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2552,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2554,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2555,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2557,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2563,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2564,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2566,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2567,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2568,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2569,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2570,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2571,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 2734,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2840,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2841,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2882,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2883,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2884,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2885,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2886,
      SizeId: 557,
      SizeName: "PCS",
    },
    {
      ProductId: 2888,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2889,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2890,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2892,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2894,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 2918,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 3032,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 3035,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 3036,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 3365,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 3366,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 3367,
      SizeId: 489,
      SizeName: "STD",
    },
    {
      ProductId: 4062,
      SizeId: 578,
      SizeName: "REG",
    },
    {
      ProductId: 4468,
      SizeId: 579,
      SizeName: "S",
    },
    {
      ProductId: 4641,
      SizeId: 556,
      SizeName: "N/A",
    },
  ],
  FlavourList: [
    {
      ProductId: 1668,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1669,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1670,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1671,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1672,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1673,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1675,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1679,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1681,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 1682,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2138,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2140,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2287,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 572,
    },
    {
      ProductId: 2288,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2290,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2291,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 576,
    },
    {
      ProductId: 2292,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2293,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2294,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2295,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2296,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2297,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2298,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2299,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2300,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2301,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2302,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2303,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2304,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2305,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2306,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2308,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2309,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2310,
      FlavourId: 291,
      FlavourName: "CHIPOTLE",
      SizeId: 489,
    },
    {
      ProductId: 2310,
      FlavourId: 292,
      FlavourName: "GARLIC MAYO",
      SizeId: 489,
    },
    {
      ProductId: 2310,
      FlavourId: 293,
      FlavourName: "HOT & SPICY",
      SizeId: 489,
    },
    {
      ProductId: 2310,
      FlavourId: 294,
      FlavourName: "LEMON & HERBS",
      SizeId: 489,
    },
    {
      ProductId: 2310,
      FlavourId: 295,
      FlavourName: "PERY PERY",
      SizeId: 489,
    },
    {
      ProductId: 2310,
      FlavourId: 300,
      FlavourName: "SPICY MAYO",
      SizeId: 489,
    },
    {
      ProductId: 2314,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2315,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2322,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 556,
    },
    {
      ProductId: 2500,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2501,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2502,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2503,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2507,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2508,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2512,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2513,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2514,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2515,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2518,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2519,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2520,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2521,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2522,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2523,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2524,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2525,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2526,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2527,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2528,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2529,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2530,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2531,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2532,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2533,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2534,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2535,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2536,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2537,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2538,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2539,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2540,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2541,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2542,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2543,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2544,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2552,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2554,
      FlavourId: 294,
      FlavourName: "LEMON & HERBS",
      SizeId: 489,
    },
    {
      ProductId: 2555,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2557,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2563,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2564,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2566,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2567,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2568,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2569,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2570,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2571,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 2734,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2840,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2841,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2882,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2883,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2884,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2885,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2886,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 557,
    },
    {
      ProductId: 2888,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2889,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2890,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2892,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2894,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 2918,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 3032,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 3035,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 3036,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 3365,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 3366,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 3367,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 489,
    },
    {
      ProductId: 4062,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 578,
    },
    {
      ProductId: 4468,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 579,
    },
    {
      ProductId: 4641,
      FlavourId: 286,
      FlavourName: "N/A",
      SizeId: 556,
    },
  ],
  OrderSource: [
    {
      OrderSourceId: 363,
      OrderSource: "POS",
      IsPos: 1,
    },
  ],
  PaymentMode: [
    {
      GSTId: 63,
      GSTName: "GST",
      GSTPercentage: 0,
      PaymentModeId: 120,
      PaymentMode: "CASH",
    },
  ],
  DiscountTypeList: [
    {
      Value: "25% Discount",
      DiscountId: 79,
      DiscountPercent: 25,
      DiscountTimeStart: "00:00:00",
      DiscountTimeEnd: "23:59:00",
      CreatedDate: "2022-12-01T20:11:03.77",
      CreatedBy: 246,
      ModifiedDate: "2023-01-23T13:54:30.583",
      ModifiedBy: 246,
      UserIP: "12.1.1.2",
      IsActive: true,
      DiscountName: "25% Discount",
      IsOpen: false,
      IsActiveInWeb: true,
      StartDate: "2022-12-01T00:00:00",
      EndDate: "2030-12-31T00:00:00",
      IsAreaWise: false,
      IsDayWise: false,
      Priority: 1,
      IsActiveInPOS: true,
      DiscountTypeId: null,
      CompanyId: 116,
      IsActiveInMobile: true,
      IsActiveInODMS: true,
      IsPercentage: true,
      IsAutoDiscount: false,
      DiscountAreaMappingId: null,
      DiscountDayMappingId: null,
    },
    {
      Value: "FoodPanda Discount",
      DiscountId: 72,
      DiscountPercent: 20,
      DiscountTimeStart: "00:00:00",
      DiscountTimeEnd: "23:59:00",
      CreatedDate: "2022-11-15T13:05:59.627",
      CreatedBy: 212,
      ModifiedDate: "2023-01-23T13:54:41.583",
      ModifiedBy: 246,
      UserIP: "12.1.1.2",
      IsActive: true,
      DiscountName: "FoodPanda Discount",
      IsOpen: false,
      IsActiveInWeb: true,
      StartDate: "2022-11-15T00:00:00",
      EndDate: "2025-02-28T00:00:00",
      IsAreaWise: false,
      IsDayWise: false,
      Priority: 1,
      IsActiveInPOS: true,
      DiscountTypeId: null,
      CompanyId: 116,
      IsActiveInMobile: true,
      IsActiveInODMS: true,
      IsPercentage: true,
      IsAutoDiscount: true,
      DiscountAreaMappingId: null,
      DiscountDayMappingId: null,
    },
    {
      Value: "20 % WEB/APP",
      DiscountId: 71,
      DiscountPercent: 20,
      DiscountTimeStart: "00:00:00",
      DiscountTimeEnd: "23:59:00",
      CreatedDate: "2022-11-14T17:48:09.943",
      CreatedBy: 231,
      ModifiedDate: "2023-01-23T13:54:56.007",
      ModifiedBy: 246,
      UserIP: "12.1.1.2",
      IsActive: true,
      DiscountName: "20 % WEB/APP",
      IsOpen: false,
      IsActiveInWeb: true,
      StartDate: "2022-11-01T00:00:00",
      EndDate: "2026-12-31T00:00:00",
      IsAreaWise: false,
      IsDayWise: false,
      Priority: 1,
      IsActiveInPOS: true,
      DiscountTypeId: null,
      CompanyId: 116,
      IsActiveInMobile: true,
      IsActiveInODMS: true,
      IsPercentage: true,
      IsAutoDiscount: true,
      DiscountAreaMappingId: null,
      DiscountDayMappingId: null,
    },
    {
      Value: "10%",
      DiscountId: 80,
      DiscountPercent: 10,
      DiscountTimeStart: "00:00:00",
      DiscountTimeEnd: "23:59:00",
      CreatedDate: "2022-12-01T20:15:53.763",
      CreatedBy: 246,
      ModifiedDate: "2023-01-23T14:20:11.607",
      ModifiedBy: 246,
      UserIP: "12.1.1.2",
      IsActive: true,
      DiscountName: "10%",
      IsOpen: false,
      IsActiveInWeb: true,
      StartDate: "2022-12-01T00:00:00",
      EndDate: "2030-12-31T00:00:00",
      IsAreaWise: false,
      IsDayWise: false,
      Priority: 1,
      IsActiveInPOS: true,
      DiscountTypeId: null,
      CompanyId: 116,
      IsActiveInMobile: true,
      IsActiveInODMS: true,
      IsPercentage: true,
      IsAutoDiscount: false,
      DiscountAreaMappingId: null,
      DiscountDayMappingId: null,
    },
  ],
  DiscountProductMappingList: [
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2989,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2990,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2992,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2993,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2994,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2995,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2996,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2997,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2998,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 2999,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 3000,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 3001,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 3002,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 3003,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4018,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4019,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4020,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4021,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4024,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4026,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4027,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4033,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4038,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4039,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4040,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4041,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4043,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4044,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4046,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4047,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4048,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4049,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4050,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4051,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4053,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4054,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4055,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4056,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4057,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4059,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4060,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4064,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4065,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4066,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4067,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4068,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4069,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4070,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4071,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4072,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4073,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4074,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4077,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4078,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4079,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4081,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4084,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4085,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4086,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4087,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4089,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4093,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4095,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4102,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4103,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4105,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4106,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4109,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4257,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4260,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4261,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4262,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4264,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4265,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4266,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4267,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4274,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4275,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4276,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4277,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4278,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4279,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4280,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4281,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4293,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4304,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4610,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4611,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4612,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4613,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4614,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4615,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4617,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4618,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4633,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4634,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4635,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4636,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4637,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4638,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4639,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4640,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4641,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4642,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4643,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4644,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4645,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 4656,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5070,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5158,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5159,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5161,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5171,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5172,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5173,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5174,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5175,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5176,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5177,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5178,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5179,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5180,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5181,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5183,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5186,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5187,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5188,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5189,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5190,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5200,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5202,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5217,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5218,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5219,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5222,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5223,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5224,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5225,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5227,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5237,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5238,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5239,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5241,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5242,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5245,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5247,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5249,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5283,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5419,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5420,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5422,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5424,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5425,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5426,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5428,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5429,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5430,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5440,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5441,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 5442,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 6015,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 6491,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 6716,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 6884,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 71,
      DiscountPercent: 20,
      ProductDetailId: 6885,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2989,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2990,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2992,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2993,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2994,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2995,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2996,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2997,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2998,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 2999,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 3000,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 3001,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 3002,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 3003,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4018,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4019,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4020,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4021,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4024,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4026,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4027,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4033,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4038,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4039,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4040,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4041,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4043,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4044,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4046,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4047,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4048,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4049,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4050,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4051,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4053,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4054,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4055,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4056,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4057,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4059,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4060,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4064,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4065,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4066,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4067,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4068,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4069,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4070,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4071,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4072,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4073,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4074,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4077,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4078,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4079,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4081,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4084,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4085,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4086,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4087,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4089,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4093,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4095,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4102,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4103,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4105,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4106,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4109,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4257,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4260,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4261,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4262,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4264,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4265,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4266,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4267,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4269,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4270,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4274,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4275,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4276,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4277,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4278,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4279,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4280,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4281,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4282,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4283,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4284,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4285,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4290,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4291,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4292,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4293,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4294,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4295,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4296,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4297,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4298,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4304,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4570,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4571,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4572,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4573,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4574,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4576,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4577,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4578,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4579,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4580,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4581,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4582,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4583,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4584,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4585,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4586,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4594,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4595,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4596,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4597,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4598,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4599,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4600,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4601,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4602,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4603,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4604,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4605,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4606,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4607,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4608,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4609,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4610,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4611,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4612,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4613,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4614,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4615,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4617,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4618,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4619,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4620,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4621,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4622,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4623,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4628,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4629,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4630,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4631,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4632,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4633,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4634,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4635,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4636,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4637,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4638,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4639,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4640,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4641,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4642,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4643,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4644,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4645,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4646,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4647,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4648,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4649,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4650,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4651,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4652,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4653,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4654,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 4656,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 5068,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
    {
      DiscountId: 72,
      DiscountPercent: 20,
      ProductDetailId: 5070,
      IsPercentage: true,
      IsAutoDiscount: true,
    },
  ],
};

export const customerData = {
  Table: [
    {
      PhoneId: 68,
      PhoneNumber: "0333",
      CreatedDate: "2022-05-14T16:47:13.94",
      CreatedBy: 103,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: "1.2.2.1",
      IsActive: true,
      CreatedDateInt: null,
      ModifiedDateInt: null,
      CompanyId: 62,
      PhoneTypeId: 135,
    },
  ],
  Table1: [
    {
      CustomerId: 83,
      CustomerName: "AHMED KIRMANI",
      IsActive: true,
      CreatedBy: 103,
      CreatedDate: "2022-05-14T16:47:13.94",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 108,
      CustomerName: "IRFAN AHMED",
      IsActive: true,
      CreatedBy: 103,
      CreatedDate: "2022-05-26T16:30:01.117",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 110,
      CustomerName: "MEHMOOD",
      IsActive: true,
      CreatedBy: 107,
      CreatedDate: "2022-05-28T19:48:36.58",
      ModifiedBy: 107,
      ModifiedDate: "2022-11-27T12:29:23.113",
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: true,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 111,
      CustomerName: "SUFYAN AHMED",
      IsActive: true,
      CreatedBy: 107,
      CreatedDate: "2022-05-28T19:59:57.42",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 561,
      CustomerName: "DSJKHDJKSHAK",
      IsActive: true,
      CreatedBy: 107,
      CreatedDate: "2022-12-01T22:19:03.687",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1.2.2.1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: null,
      Password: null,
    },
    {
      CustomerId: 2637,
      CustomerName: "MUSTAFA AHMED",
      IsActive: true,
      CreatedBy: 111,
      CreatedDate: "2022-12-30T00:00:00",
      ModifiedBy: null,
      ModifiedDate: null,
      UserIP: "1",
      PhoneId: 68,
      IsPrimary: false,
      CompanyId: 62,
      IsTaxPayer: null,
      IsApprovedVendor: null,
      NTN: null,
      GST: null,
      SST: null,
      CNIC: null,
      Email: "mustafa@gmail.com",
      Password: "asdasd",
    },
  ],
  Table2: [
    {
      CustomerAddressId: 84,
      IsPrimary: false,
      AddressTypeId: 132,
      CompanyId: 62,
      CityId: 46,
      AreaId: 194,
      LandMark: "PRESS CLUB",
      CompanyName: "SYBRID",
      Building: "LAKSON SQUARE BLDG # 3",
      RoomHouse: "701",
      BlockFloor: "7",
      StreetRowLane: "SARWAR SHAHEED ROAD",
      RoomHouseCaptionId: 140,
      BlockFloorCaptionId: 142,
      StreetRowLaneCaptionId: 143,
      Remarks: "",
      CreatedDate: "2022-05-14T16:47:13.94",
      CreatedBy: 103,
      ModifiedDate: "2022-05-28T19:59:57.42",
      ModifiedBy: 107,
      UserIP: "1.2.2.1",
      IsActive: true,
      PhoneId: 68,
      CaptionId: null,
      CompleteAddress: null,
      IsPrimaryAddress: false,
      CityName: "Karachi",
      AreaName: "Saddar",
      AddressType: "Office",
      RoomHouseCaption: "Suit No",
      BlockFloorCaption: "Floor",
      StreetRowLaneCaption: "Lane",
      CompleteAddress1: null,
    },
    {
      CustomerAddressId: 299,
      IsPrimary: true,
      AddressTypeId: null,
      CompanyId: 62,
      CityId: 46,
      AreaId: 173,
      LandMark: "",
      CompanyName: "",
      Building: "",
      RoomHouse: "",
      BlockFloor: "",
      StreetRowLane: "",
      RoomHouseCaptionId: null,
      BlockFloorCaptionId: null,
      StreetRowLaneCaptionId: null,
      Remarks: "",
      CreatedDate: "2022-11-27T12:29:23.113",
      CreatedBy: 107,
      ModifiedDate: "2022-12-01T22:19:03.687",
      ModifiedBy: 107,
      UserIP: "1.2.2.1",
      IsActive: true,
      PhoneId: 68,
      CaptionId: null,
      CompleteAddress: "Block 3-A",
      IsPrimaryAddress: true,
      CityName: "Karachi",
      AreaName: "A O Clinic",
      AddressType: "",
      RoomHouseCaption: "",
      BlockFloorCaption: "",
      StreetRowLaneCaption: "",
      CompleteAddress1: "Block 3-A",
    },
  ],
  Table3: [
    {
      SerialNo: 1,
      SetupDetailId: 132,
      SetupMasterId: 9,
      SetupDetailName: "Office",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 2,
      SetupDetailId: 133,
      SetupMasterId: 9,
      SetupDetailName: "Other",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 3,
      SetupDetailId: 134,
      SetupMasterId: 9,
      SetupDetailName: "Residential",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
  ],
  Table4: [
    {
      SerialNo: 1,
      SetupDetailId: 136,
      SetupMasterId: 10,
      SetupDetailName: "Landline",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 2,
      SetupDetailId: 135,
      SetupMasterId: 10,
      SetupDetailName: "Mobile",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
  ],
  Table5: [
    {
      SerialNo: 1,
      SetupDetailId: 138,
      SetupMasterId: 11,
      SetupDetailName: "House No",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 2,
      SetupDetailId: 139,
      SetupMasterId: 11,
      SetupDetailName: "Room No",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 3,
      SetupDetailId: 140,
      SetupMasterId: 11,
      SetupDetailName: "Suit No",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
  ],
  Table6: [
    {
      SerialNo: 1,
      SetupDetailId: 141,
      SetupMasterId: 12,
      SetupDetailName: "Block",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 2,
      SetupDetailId: 142,
      SetupMasterId: 12,
      SetupDetailName: "Floor",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
  ],
  Table7: [
    {
      SerialNo: 1,
      SetupDetailId: 143,
      SetupMasterId: 13,
      SetupDetailName: "Lane",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 2,
      SetupDetailId: 144,
      SetupMasterId: 13,
      SetupDetailName: "Row",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
    {
      SerialNo: 3,
      SetupDetailId: 145,
      SetupMasterId: 13,
      SetupDetailName: "Street No",
      ParentId: null,
      Flex1: "",
      Flex2: "",
      Flex3: "",
      IsActive: true,
      Active: "Yes",
      "Created Date": "2022-04-18T00:05:34.127",
      "Created By": "Admin",
      "Last Modified Date": "2022-04-18T00:06:15.06",
      "Last Modified By": "Admin",
      ParentId1: null,
      ParentName: null,
    },
  ],
  Table8: [
    {
      AreaId: 172,
      AreaName: "2 Minute Chowrangi",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:11:50.59",
      CreatedBy: 103,
      ModifiedDate: "2022-09-21T16:22:23.87",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 173,
      AreaName: "A O Clinic",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:12:31.593",
      CreatedBy: 103,
      ModifiedDate: "2022-06-29T21:09:03.797",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 175,
      AreaName: "Abbasi Shaheed Hosp",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:20:06.797",
      CreatedBy: 103,
      ModifiedDate: "2022-07-06T13:39:09.84",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 176,
      AreaName: "Abdullah Haroon Rd",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:20:44.58",
      CreatedBy: 103,
      ModifiedDate: "2022-06-08T18:35:16.657",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 177,
      AreaName: "Adamjee Nagar Blk A",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:21:10.01",
      CreatedBy: 103,
      ModifiedDate: "2022-06-08T18:35:20.61",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 178,
      AreaName: "Adamjee Nagar Blk B",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:21:29.557",
      CreatedBy: 103,
      ModifiedDate: "2022-06-08T18:35:22.583",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 179,
      AreaName: "Aga Khan Hospital",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:21:49.84",
      CreatedBy: 103,
      ModifiedDate: "2022-06-08T18:35:24.397",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 180,
      AreaName: "Airport",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:22:07.73",
      CreatedBy: 103,
      ModifiedDate: "2022-06-08T18:35:26.123",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 181,
      AreaName: "Aisha Bawani",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:22:30.503",
      CreatedBy: 103,
      ModifiedDate: "2022-06-08T18:35:28.07",
      ModifiedBy: 103,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 182,
      AreaName: "Akbar Apt Safety Pride",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-12T11:22:52.7",
      CreatedBy: 103,
      ModifiedDate: "2022-06-13T11:04:26.63",
      ModifiedBy: 108,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 194,
      AreaName: "Saddar",
      CityId: 46,
      IsEnable: true,
      StartTime: "00:00:00",
      EndTime: "23:59:00",
      CreatedDate: "2022-05-14T16:45:48.78",
      CreatedBy: 103,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
    {
      AreaId: 253,
      AreaName: "North Karachi",
      CityId: 46,
      IsEnable: true,
      StartTime: "01:00:00",
      EndTime: "20:00:00",
      CreatedDate: "2022-07-07T16:33:29.72",
      CreatedBy: 103,
      ModifiedDate: null,
      ModifiedBy: null,
      UserIP: "12.1.1.2",
      IsActive: true,
      CompanyId: 62,
    },
  ],
  Table9: [
    {
      CityId: 46,
      CityName: "Karachi",
      CountryId: 64,
      ProvinceId: 35,
      CreatedDate: "2022-04-21T10:47:00.597",
      CreatedBy: 38,
      ModifiedDate: "2022-06-13T11:09:11.92",
      ModifiedBy: 108,
      UserIP: "12.1.1.2",
      IsActive: true,
    },
  ],
  Table10: [
    {
      BranchId: 168,
      CityBranchName: "Krispy2GO Johar",
      CityId: 46,
      CityName: "Karachi",
    },
  ],
};
